import { browserHistory } from 'react-router';
import React, { Suspense, createRef } from 'react';
// Lazy load the ChartComponent
import $ from 'jquery';
import Dropdown from 'react-bootstrap/Dropdown';
import {faChartArea } from '@fortawesome/free-solid-svg-icons';
import { Modal, Form, InputGroup } from 'react-bootstrap';
import RealTimeLeftPanel from './realtimeLeftPanel';
import DQIncidentGrid from "./dqincidentgrid"
import ListGroup from 'react-bootstrap/ListGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faServer, faLayerGroup, faTag, faExclamationTriangle, faCalendar, faCheck } from '@fortawesome/free-solid-svg-icons';//faSearch
import './react-autosuggest.css';
import { Scrollbars } from 'react-custom-scrollbars';
import Image from '../components/image';
import Nav from 'react-bootstrap/Nav';
// import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { getApi } from '../utils/event_handling';
import { getMetaDatas } from '../utils/dataProfileEventHandling'
import { getWebSocketUrl, getWatchList, getAllEnvironmentIntegrations, getMetricsValue, getAllMetaData, getChartData, saveWatchList, deleteWatchList, getEditWatchList, updateWatchList, getProgressInfo,getIntegration,getWindirectDeployment } from '../utils/realtimeEventHandle'
import { getTeamId, getUserId } from '../utils/common_utils'
import Tab from 'react-bootstrap/Tab';
import moment from 'moment';
import Load from '../components/loadAction';
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import AdvancedSearch from './advancedSearch';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Toast } from 'react-bootstrap';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import RcTooltip from 'rc-tooltip';
import html2canvas from 'html2canvas';
import ProgressStatus from "../components/progressStatus"
import {IS_NONE_CHECK} from "../utils/constant";
import ParetoChart from './compoents/paretoChart';
import DqChart from './dqChart';
import { io } from "socket.io-client";
import { ui_service_ip } from "../utils/ip_details";
import { normalizeChildDatasetName,normalizeAttributeName } from '../utils/attribute_name_utils';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

let WINEDIRECT_REALTIME_DEPLOYMENT_DATE = "";

const ChartComponent = React.lazy(() => import('./chartcomponent')); //
const renderTooltipSummary = (props) => {
  return (
    <span>
      {props}
    </span>)
};

export default class DQ extends React.Component {

  constructor(props, context) {
    super(props, context);


    this.state = {
      initialIntegrationId: props.initialIntegrationId || null,
      selectedDate: props.selectedDate || null,
      chartTypes: {}, // Object to store individual chart types by chartId
      showContent: false,
      cardName: "",
      //  selectedWatchlistName :"",
      nestedData: {},
      newData: {},
      showTreeView: false,
      initialSelection: {},
      isSearchHappened: false,
      errorOccurred: false,
      autoCompleteData: [],
      subString: null,
      searchCount: 0,
      fullData: [],
      isFilterOpen: false,
      isNoResult: false,
      saveWatchListSearchText: '',
      filteredData: [],
      isRedirect: false,
      value: '',
      suggestions: [],
      preSelectedEnv: null,
      preSelectedDataset: null,
      preSelectedAttribute: null,
      preSelectedDatasource: null,
      envCount: null,
      datasourceCount: null,
      datasetCount: null,
      autocompletemodal: false,
      show: false,
      watchListOpen: false,
      metricListRename: false,
      startDate: "",
      endDate: "",
      // startDate:moment().utc().endOf('day').format("Y-m-d"),
      // endDate:moment().utc().endOf('day').format("Y-m-d"),
      // startDate: moment().subtract(29, 'days'),
      // endDate: moment().utc().endOf('day'),
      watchListName: '',
      environment: [],
      //  selectedWatchlistName: "All",
      selectedWatchlistName: "All",
      editWatchlist: false,
      integration_details: "",
      showDeleteModal: false,
      disableDelete: false,
      metaData: {},
      search_text: "",
      selectedEnv: null,
      latest_env_name: null,
      isChecked: true,
      showToast: false,
      delete_watchlist_requsest: [],
      //selectedWatchlistId:"",
      arrowIndicator: true,
      newValue: true,
      oldValue: true,
      rangeValue: 0,
      filterData: [],
      // NEW Format
      selectedRange: '', // 1D Default selected range
      dateRanges: ['1D', '5D', '1M', '3M', '6M'],
      seletedTabId: 1,// DQ Selections
      selectedEnvId: this.props.selectedEnvId,
      selectedEnvName: this.props.selectedEnvName,
      selectedIntegrationId: "",
      selectedIntegrationName: "",
      selectedDatasetId: "",
      selectedDatasetName: "",
      selectedDatasetAttrId: "",
      selectedDatasetAttrName: "",
      selectedDatasetMeticsId: "",
      selectedDatasetMeticsName: "",
      selectedWatchListId: "",
      selectedWatchListName: "",
      selectedLeftPanelType: "",
      selectedMeticsName: "",
      selectedStartDate: moment().subtract(29, 'days'),
      selectedEndDate: moment().utc().endOf('day'),
      browserTabId: this.props.browserTabId,
      teamId: getTeamId(),
      userId: getUserId(),
      browsersessionId: this.props.browserSessionId,
      //browserTabId:this.props.tabId,
      watchListInformation: {},
      integrationsInformation: "",
      menu: "monitor",
      leftPanelLoader: true,
      rightPanelLoader: true,
      showDeletePopup: false,
      confirmDeleteName: "",
      /// visibleCharts: {}, // Track which charts are visible
      metricsValueResponse: {},
      bottomPanelData: "",
      chartData: "",
      incidentchartData: "",
      selectedChart: "Area", // Default chart type
      isCheckedIncidents: false, // Initial state of the checkbox
      incidentsPanelHeight: 90,
      incidentsPanelFullScreen: false,
      selectedTopMenu: "",
      showChartFullscreen: false,
      escapeMessage: true,
      toggleIncidentPanel: false,
      dateFilterStartDate: null,
      dateFilterEndDate: null,
      dateFilterShowStartCalendar: true, // Start date picker shown by default
      dateFilterShowEndCalendar: false,
      checkedStates: {},
      chartGridWidth: (() => {
        const screenWidth = window.innerWidth;
        if (screenWidth > 1450) return 414;
        else if (screenWidth > 1200) return 343;
        else return 293;
      })(),
      isLoading: false, // Loading state for API call
      hasMoreData: false, // Flag to indicate if more data can be loaded
      visibleCharts: new Set(), // Tracks visible charts
      resizeCounter: 0, // Counter to force chart reload on resize
      incidentStartDate: "",
      incidentEndDate: "",
      lastProcessedDate: "",
      pushDataList: [],
      integrationRequest: []
      ,
      incidentPanelState: "minimized", // "minimized", "half", "full"
      customDatePickerErr: "Default Date",
      metaDataResponse: [],
      showIncidentToast: false,
      watchListNameError: '',
      noData: false,
      noDataFound: false,
      inProgress: false,
      showLoader: false,
      progressStatus: 0,
      spinner: false,
      inputData: null,
      selectPartitionButton: false,
      page: 1,
      attributeList: [],
      attributeCount: 0,
      apiCount: 0,
      expandBottomStatPanel: false,

      allAttributeIdsForDataset: [], // Stores all attribute IDs for the selected dataset
      currentAttributePageIndex: 0,  // Tracks the current page of attributes loaded
      attributesPerLoad: 5,          // Number of attributes to load per API call
      isLoadingMore: false,          // Loading state for more data
      saveList: [],
      fullAttributeList: [],
      startIndex: 0,
      endIndex: 5,
      currentBottomPanelData: "",
      dataType: "Dataset",
      incidentData: null,
      blurLoader :false,
      pushtime: moment().format("YYYY-MM-DD HH:mm:ss"),
      switchRealTimeView: false,
      isBottomPanelLoading: false,
      showDatePopover: true, // Show date popover if navigated from switch
      //showDatePopover: switchmodal!== "" ? true : false, // Show date popover if navigated from switch
      windirectDataset:"",
    }
    this.chartRefs = {}; // Create references for chart containers
    this.observer = null; // Intersection Observer instance
    this.listRef = createRef(); // Reference to FixedSizeList
    this.socket = null;
    this.isLoaderRefreshInProgress = false;

    this.setAttribute = this.setAttribute.bind(this);
    this.handleCloseAutoCompleteModal = this.handleCloseAutoCompleteModal.bind(this);
    this.handleOpenAutoCompleteModal = this.handleOpenAutoCompleteModal.bind(this);
    this.swDropdownOpen = this.swDropdownOpen.bind(this);
    this.getMetaDatas = getMetaDatas.bind(this);
    this.getApi = getApi.bind(this);
    this.renderChart = this.renderChart.bind(this);
    this.initalAPILoad = this.initalAPILoad.bind(this);
    this.containerRef = createRef();
    this.handleDeleteModalOpen = this.handleDeleteModalOpen.bind(this);
    this.handleCloseDeletePopup = this.handleCloseDeletePopup.bind(this);
    this.handleDeleteWatchlist = this.handleDeleteWatchlist.bind(this);
    this.handleToggleIncidents = this.handleToggleIncidents.bind(this);
    this.handleIncidentScreenToggle = this.handleIncidentScreenToggle.bind(this)
    this.focusChart = this.focusChart.bind(this)
    ///this.toggleIncidentPanel = this.toggleIncidentPanel.bind(this)
    this.handleWatchlistChange = this.handleWatchlistChange.bind(this);
    this.handleSaveWatchlistCheckboxChange = this.handleSaveWatchlistCheckboxChange.bind(this);
    this.saveWatchListResponse = this.saveWatchListResponse.bind(this);
    this.renderchartView = this.renderchartView.bind(this);
    // this.customEndDate = this.customEndDate.bind(this)
    this.renderRow = this.renderRow.bind(this)
    this.forceChartRerender = this.forceChartRerender.bind(this)
    this.handleDateRange = this.handleDateRange.bind(this)
    this.receivePushData = this.receivePushData.bind(this)
    this.togglePanel = this.togglePanel.bind(this)
    this.setIncidentPanelState = this.setIncidentPanelState.bind(this)
    this.toggleIncidentPanel = this.toggleIncidentPanel.bind(this)
    this.customDateRangeSelect = this.customDateRangeSelect.bind(this)
    this.checkbox = this.checkbox.bind(this); // bind here
    this.calculateChartGridWidth = this.calculateChartGridWidth.bind(this); // bind here
    this.pushResponseData = this.pushResponseData.bind(this);
    this.closeToast = this.closeToast.bind(this);
    this.handleMonitorSwitchCancel = this.handleMonitorSwitchCancel.bind(this);


  }


  customDateRangeSelect = (mode) => {
    if (mode === "single") {
      if (!this.state.dateFilterStartDate) {
        this.setState({ customDatePickerErr: "Please select a start date." });
        return;
      }
    } else if (mode === "custom") {
      if (!this.state.dateFilterStartDate || !this.state.dateFilterEndDate) {
        this.setState({ customDatePickerErr: "Please select both start and end dates." });
        return;
      }
    }
    this.setState({});
    this.setState({
      selectedDate: null, 
      startDate: moment(this.state.dateFilterStartDate).format("Y-MM-DD"),
      endDate: mode === "single" ? moment(this.state.dateFilterStartDate).format("Y-MM-DD") : moment(this.state.dateFilterEndDate).format("Y-MM-DD"),
      selectedRange: "",
      customDatePickerErr: ""
    }, () => {

      const deploymentDate = moment(WINEDIRECT_REALTIME_DEPLOYMENT_DATE, "YYYY-MM-DD", true);
      const start = moment(this.state.dateFilterStartDate, "Y-MM-DD", true);
      let switchflag = false;
      if (deploymentDate.isValid()) {
        switchflag = !deploymentDate.isBefore(start, 'day');
      }

      this.setState({
           switchRealTimeView: switchflag
      })

      $("body").click()
      this.renderchartView("",
        this.state.selectedIntegrationName,
        this.state.selectedDatasetName,
        this.state.selectedDatasetAttrName,
        "",
        this.state.selectedIntegrationId,
        this.state.selectedDatasetId,
        this.state.selectedDatasetAttrId,
        this.state.selectedMetricsId,
        this.state.selectedLeftPanelType,
        null,this.state.selectedMeticsName)
    });

    // if {

    //   alert(this.state.dateFilterStartDate)
    //   alert(this.state.dateFilterEndDate)


    // }
    // Clear error message if validation passes
    //this.setState({ customDatePickerErr: "" });
    // Proceed with customDateRangeSelect
    //this.customDateRangeSelect(mode);
  };

 normalizeUrl(url) {
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return "https://" + url; // auto fix
  }
  return url;
}

  async receivePushData() {

    let requestParams = {
      "browser_tab_id": this.props.browserTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "user_id": this.state.userId
    }
    let webSocketUrlResponse = await getWebSocketUrl(requestParams)

    if (!webSocketUrlResponse) {
      this.setState({ errorOccurred: true });
      return;
    }

  if (webSocketUrlResponse.code === 200) {

    if (webSocketUrlResponse.type === "azure") {
      this.socket = new WebSocket(webSocketUrlResponse.response.url);

        this.socket.onopen = () => {};
        this.socket.onmessage = (event) => {
          const parsed = JSON.parse(event.data);
          const data = typeof parsed === "string" ? JSON.parse(parsed) : parsed;
          this.pushResponseData(data);
      };
      this.socket.onerror = () => {};
      this.socket.onclose = () => {};
    } 
    else {
     //C 
     console.log(" Connecting WebSocket...");
      const normalizedUrl = this.normalizeUrl(ui_service_ip);
     //C 
     console.log("normalizeUrl:", normalizedUrl);
      if (typeof normalizedUrl !== "string") {
        console.error(" ERROR: normalizeUrl returned non-string!", normalizedUrl);
        return;
      }
      const urlObj = new URL(normalizedUrl);

      const baseUrl = urlObj.origin;

      const realtimePath = typeof urlObj.pathname === "string" ? urlObj.pathname: "";

  const socketPath = `${realtimePath}/socket.io`; 

      //C
      console.log("baseUrl:", baseUrl);
      //C
      console.log("socketPath:", socketPath);
       this.socket = io(baseUrl, {
            path: socketPath,
            transports: ["polling"],
            query: {
              tab_id: this.props.browserTabId,
            },
          });

          console.log("MY TAB ID:", this.props.browserTabId);

          this.socket.on("connect", () => {
            console.log("CONNECTED - socket id:", this.socket.id);
            console.log("tab_id:", this.props.browserTabId);
          });

          this.socket.on("disconnect", (reason) => {
            console.log("DISCONNECTED reason:", reason);
          });

          this.socket.on("reconnect", () => {
            console.log("RECONNECTED - new socket id:", this.socket.id);
          });

          this.socket.onAny((eventName, ...args) => {
            console.log("ANY EVENT RECEIVED:", eventName, args);
          });

          this.socket.on("connect", () => {
            console.log("WebSocket CONNECTED");
          });

          // Realtime messages
          this.socket.on("realtime_messages", (payload) => {
            try {
              const data = typeof payload === "string" ? JSON.parse(payload) : payload;
              this.pushResponseData(data);
            } catch (err) {
              console.error("Invalid JSON payload:", err);
            }
          });

          // Disconnected
          this.socket.on("disconnect", () => {
            console.log("WebSocket DISCONNECTED");
          });

          // Connection error
          this.socket.on("connect_error", (err) => {
            console.error("WS ERROR:", err.message);
          });     
      // this.socket.on("disconnect", (reason) => {
      //   console.log("Socket.IO DISCONNECTED:", reason);
      // });

      // this.socket.on("connect_error", (err) => {
      //   console.error("Socket.IO ERROR:", err.message);
      // });
    
          // Cleanup
          return () => {
            if (this.socket) this.socket.disconnect();
          };


        }

    }
  }


  pushResponseData = (data) => {
      /*
          This log is for debugging purposes to check the response from the getWebSocketUrl API call.
          **/
          //C 
          console.log("Received WebSocket data:", data);
          if(typeof(data) === 'string'){
            data = JSON.parse(data)
          }
          if (data.ids_type === "dq_progress_completed") {
            const refreshData = data.data || {};
            if (refreshData.env_id === this.props.selectedEnvId &&
                this.isLoaderRefreshInProgress === false) {
              this.isLoaderRefreshInProgress = true;
              this.initalAPILoad().finally(() => {
                this.isLoaderRefreshInProgress = false;
              });
            }
            return;
          }
          let dataType = data.meta_data_id ? "Attribute" : "Dataset";

          if (data && data.latest_chart_data) {
            const latestData = data.latest_chart_data;

            this.setState(prevState => {
              let chartData = { ...prevState.chartData };
              let pushtime = moment().format("YYYY-MM-DD HH:mm:ss")

              //C
              console.log(chartData)

              for (let key in latestData) {

                const isDatasetKey = key.endsWith("_dt");
                const isAttributeKey = key.endsWith("_attr");
               
                //  Filter based on dataType
                if (dataType === "Dataset" && !isDatasetKey && !isAttributeKey) {
                  continue;
                }
                if (dataType === "Attribute" && !isAttributeKey) {
                  continue;
                }

                if (!chartData[key]) {
                  continue;
                }
             
                const existing = chartData[key];
                const latest = latestData[key];
                const lastIndex = existing.time.length - 1;
                let isDifferent = lastIndex === -1;

                if (!isDifferent) {
                  for (let field in existing) {
                    if (Array.isArray(existing[field]) && latest[field] !== undefined) {
                      const prevVal = existing[field][lastIndex];
                      const newVal = latest[field];

                      if (prevVal !== newVal) {
                        isDifferent = true;
                        break;
                      }
                    }
                  }
                } else {
                  console.log(" No previous data, first append");
                }

                if (isDifferent) {

                  for (let field in existing) {
                    if (Array.isArray(existing[field])) {
                      existing[field] = [
                        ...existing[field],
                        latest[field] !== undefined ? latest[field] : null
                      ];
                    }
                  }
                } else {
                  console.log(`No changes detected, skip append for key: ${key}`);
                }

              }

              //C
              console.log("Updated chartData:", chartData);
              return { chartData, dataType , pushtime};
            });
          }
     
         if (data && data.latest_tree_data) {
            const newTreeData = data.latest_tree_data;
            const existingTreeData = { ...this.state.metricsValueResponse };
            const integrationId = this.state.selectedIntegrationId;
            const datasetId = this.state.selectedDatasetId; 
            const datasetArray = existingTreeData.datasets[integrationId];
            const datasetIndex = datasetArray.findIndex(
              item => item.value === datasetId
            );

            if (datasetIndex !== -1) {
              const datasetMetrics = Object.entries(newTreeData)
                .filter(([key]) => key.startsWith(`${datasetId}_`) && key.endsWith("_dt"))
                .map(([, metric]) => ({
                  metrics_id: Number(metric.metric_id),
                  metrics_name: metric.name,
                  previous: metric.previous,
                  latest: metric.latest,
                  error: metric.error
                }));

              datasetArray[datasetIndex] = {
                ...datasetArray[datasetIndex],
                metrics: datasetMetrics,
                error: datasetMetrics.some(m => m.error)
              };
            }

            const attributeArray = existingTreeData.attributes?.[datasetId];

            if (Array.isArray(attributeArray)) {

             
              existingTreeData.attributes[datasetId] = attributeArray.map(attr => {
                const attrId = attr.value;

                const attrMetrics = Object.entries(newTreeData)
                  .filter(
                    ([key]) =>
                      key.startsWith(`${attrId}_`) && key.endsWith("_attr")
                  )
                  .map(([, metric]) => ({
                    metrics_id: Number(metric.metric_id),
                    metrics_name: metric.name,
                    previous: metric.previous,
                    latest: metric.latest,
                    error: metric.error
                  }));
                // replace only when metric exists
                if (attrMetrics.length > 0) {
                  return {
                    ...attr,
                    metrics: attrMetrics,
                    error: attrMetrics.some(m => m.error)
                  };
                }

                return attr;
              });
            }
            this.setState({metricsValueResponse : existingTreeData, dataType: dataType})
          }  

          /*
          if (data && data.bottom_panel_data) {
            const { bottom_panel_data, data_set_id, meta_data_id } = data;
            let bottompreviousdata = this.state.bottomPanelData || {};
            let dtKey = `${data_set_id}_dt`;
            let attrKey = meta_data_id ? `${meta_data_id}_attr` : null;

            // Update bottomPanelData with any new data
            if (bottom_panel_data[dtKey]) {
              bottompreviousdata[dtKey] = bottom_panel_data[dtKey];
            }
            if (attrKey && bottom_panel_data[attrKey]) {
              bottompreviousdata[attrKey] = bottom_panel_data[attrKey];
            }

            // Decide which key to use for currentBottomPanelData
            let currentKey = null;
            if (attrKey && bottompreviousdata[attrKey]) {
              currentKey = attrKey;
            } else if (bottompreviousdata[dtKey]) {
              currentKey = dtKey;
            }

            if (currentKey) {
              this.setState({
                bottomPanelData: bottompreviousdata,
                currentBottomPanelData: bottompreviousdata[currentKey],
                dataType: attrKey && currentKey === attrKey ? "Attribute" : "Dataset"
              });
            } else {
              this.setState({
                bottomPanelData: bottompreviousdata,
                currentBottomPanelData: null,
                dataType: "Dataset"
              });
            }
          }
          */

          if (data && data.bottom_panel_data) {
            const { bottom_panel_data, data_set_id } = data;

            let bottompreviousdata = { ...(this.state.bottomPanelData || {}) };
            //let  dtKey,attrKey; 
              let  selectedKey; 
               if(this.state.preSelectedAttribute === null){
                selectedKey = `${data_set_id}_dt`;
              }else {
                selectedKey = this.state.preSelectedAttribute.value+ "_attr";
              }
            Object.keys(bottom_panel_data).forEach((key) => {
              try {
                const value = bottom_panel_data[key];

                //  Check key validity
                if (!key || typeof key !== "string") {
                  console.warn("Invalid key in bottom_panel_data:", key);
                  return;
                }

                //  Check value existence
                if (!value || typeof value !== "object") {
                  console.warn(`Invalid value for key: ${key}`, value);
                  return;
                }

                //  Optional: check expected structure
                if (!value.chart_data) {
                  console.warn(`Missing chart_data for key: ${key}`);
                  // you can still store it OR skip
                  // return; // uncomment if you want to skip
                }

                //  Safe assignment
                bottompreviousdata[key] = value;

              } catch (err) {
                console.error(`Error processing key: ${key}`, err);
              }
            });
             this.setState({
              bottomPanelData: bottompreviousdata,
              currentBottomPanelData: bottompreviousdata[selectedKey],
              dataType: selectedKey && selectedKey.includes("_attr") ? "Attribute" : "Dataset",
            });
          }

              //}

            // if (data && data.latest_incident_data) {
            // this.setState(prevState => ({incidentData: [...data.latest_incident_data,...(prevState.incidentData || [])]}));
            //   }

            if (data && data.latest_incident_data) {
            this.setState(prevState => ({
              incidentData: [
                ...data.latest_incident_data,
                ...(prevState.incidentData || [])
              ]
            }));
          }

  }

  async renderchartView(envName, datasourceName, datasetName, attributeName, envId, datasourceId, datasetId, attributeId, id, type, currentIndex = null, title,isChild) {
    if(this.state.minDate===undefined || this.state.windirectDataset!==datasetId){

      let requestParams = {'data_set_id':Number(datasetId), 'tenant_id':this.props.teamId}
      let deployment = await getWindirectDeployment(requestParams)
      if(deployment && deployment.code === 200){
          WINEDIRECT_REALTIME_DEPLOYMENT_DATE = moment(deployment.data.rtd_deployment_date,"YYYY-MM-DD");
            this.setState({
              minDate: new Date(moment(deployment.data.created_time,"YYYY-MM-DD")),
              windirectDataset:datasetId
            })
      }
    }
    let fullAttributeList = [];
    if (type === "Dataset") {
      let metricData = this.state.metricsValueResponse;
      let datasetIdNum = Number(datasetId);

      let attributeArray = metricData?.attributes?.[datasetIdNum];
      if (Array.isArray(attributeArray)) {
        fullAttributeList = attributeArray
          .map(attr => attr?.value)
          .filter(v => typeof v === 'number')
          .sort((a, b) => a - b);
      } else {
        fullAttributeList = [];
      }


    const isSameDataset = this.state.selectedDatasetId === datasetId;
      this.setState({
        allAttributeIdsForDataset: fullAttributeList,
        fullAttributeList: fullAttributeList,
        currentAttributePageIndex: 0, // Start from the first page
        chartData: {}, // Clear existing chart data for a new dataset selection
        isLoadingMore: true, // Indicate loading for the initial set
        selectedDatasetId:"",
        selectedMetricsId:"",
        selectedMeticsName:"",
        currentBottomPanelData: "",
        startDate: isSameDataset ? this.state.startDate : "",
        endDate: isSameDataset ? this.state.endDate : "",
        dateFilterStartDate: isSameDataset ? this.state.dateFilterStartDate :  null,
        dateFilterEndDate: isSameDataset ? this.state.dateFilterEndDate : null,
        blurLoader:true,
        bottomPanelData:"",
        isBottomPanelLoading: true,
        selectedRange: isSameDataset ? this.state.selectedRange : "",
      }, async () => {

        const initialAttributeIds = fullAttributeList.slice(0, this.state.attributesPerLoad);
        const hasMore = fullAttributeList.length > this.state.attributesPerLoad;

        // Update hasMoreData before making the call
        this.setState({ hasMoreData: hasMore });

        // let selectedIds = initialAttributeIds

        $(".qd-rt_main-content").addClass("opacity-50");
        let requestParams = {
          "tab_type": 1,
          "tenant_id": this.props.teamId,
          "env_id": this.props.selectedEnvId,
          "start_date": this.state.startDate !== "" ? this.state.startDate : null,
          "end_date": this.state.endDate !== "" ? this.state.endDate : null,
          "integration_id": datasourceId,
          "data_set_id": Number(datasetId),
          "meta_data_id": initialAttributeIds, // Send only the initial chunk
          "menu_type": "monitor",
          "browser_tab_id": this.state.browserTabId,
          "session_id": this.state.browsersessionId,
          "user_id": this.props.userId,
          dateFilterStartDate: null,
          dateFilterEndDate: null,
          dateFilterShowStartCalendar: true,
          dateFilterShowEndCalendar: false,
          "additional_info": { "id": datasetId, "type": "dataset" },
          selected_ids: [datasetId],
          "type": "DatasetandAttribute",
          ids_type: "dataset"

        }

        if (this.state.isCheckedBoxPartition && isChild !== "") {
          requestParams["is_child"] = true;
        }
        let chartDataResponse = await this.getChartDataResponse(requestParams)
        if (chartDataResponse === undefined) {
          this.setState({ errorOccurred: true, isLoadingMore: false,blurLoader:false ,isBottomPanelLoading: false});
          $(".qd-rt_main-content").removeClass("opacity-50")
        } else {
          if (chartDataResponse !== null && chartDataResponse.code === 200) {
          let bottomPanelData = chartDataResponse.response.bottom_panel_data;
          let currentKey = Object.keys(bottomPanelData).find(
            key => key.startsWith(datasetId.toString() + "_dt")
          );
            $(".qd-rt_main-content").removeClass("opacity-50")
            this.setState(prevState => ({
              dataType: "Dataset",
              bottomPanelData: chartDataResponse.response.bottom_panel_data,
              currentBottomPanelData: chartDataResponse.response.bottom_panel_data[currentKey],
              chartData: chartDataResponse.response.chart_details, // Set initial chart data
              selectedDatasetId: datasetId,
              selectedDatasetName: datasetName,
              selectedIntegrationName: datasourceName,
              selectedLeftPanelType: type,
              selectedIntegrationId: datasourceId,
              incidentStartDate: chartDataResponse.response.start_date,
              incidentEndDate: chartDataResponse.response.end_date,
              lastProcessedDate: chartDataResponse.response.last_processed_time,
              minDate: new Date(moment(chartDataResponse.response.first_processed_time).format("Y-MM-DD")),
              maxDate: new Date(moment(chartDataResponse.response.last_processed_time).format("Y-MM-DD")),
              isCheckedIncidents: false,
              startDate: this.state.startDate ||  chartDataResponse.response.start_date,
              endDate:  moment().format("YYYY-MM-DD"),             
              selectedMeticsName: '',
              selectedDatasetAttrName: "",
              preSelectedAttribute: null,
              preSelectedDataset: { "label": datasetName, "value": datasetId },
              currentAttributePageIndex: 1, // Move to the next page for subsequent loads
              isLoadingMore: false, // Loading complete
              selectedDatasetAttrId: "",
              saveList: [],
              startIndex: 0,
              blurLoader:false,
              isBottomPanelLoading: false,
              dateFilterStartDate: moment(
                this.state.startDate || chartDataResponse.response.start_date,
                "YYYY-MM-DD"
              ).toDate(),
              dateFilterEndDate: moment(
                this.state.endDate || moment().format("YYYY-MM-DD"),
                "YYYY-MM-DD"
              ).toDate(),
            }));
          } else {
            this.setState({ isLoadingMore: false ,blurLoader:false,isBottomPanelLoading: false});
            $(".qd-rt_main-content").removeClass("opacity-50")

          }
        }
      });
    }
    else if (type === "Attribute" && attributeId !== undefined && attributeId !== null && attributeId !== "") {
      this.chartRefs = {}
      // For single attribute selection, we don't need pagination logic.
      // Clear allAttributeIdsForDataset and reset currentAttributePageIndex
      this.setState({
        allAttributeIdsForDataset: [attributeId], // Only this attribute
        currentAttributePageIndex: 0,
        hasMoreData: false,
        chartData: {}, // Clear existing chart data
        isLoadingMore: true,
        currentBottomPanelData: "",
        blurLoader:true,
        bottomPanelData:"",
        isBottomPanelLoading: true 
      }, async () => {
        $(".qd-rt_main-content").addClass("opacity-50");
        let requestParams = {
          "tab_type": 1,
          "tenant_id": this.props.teamId,
          "env_id": this.props.selectedEnvId,
          "start_date": this.state.startDate !== "" ? this.state.startDate : null,
          "end_date": this.state.endDate !== "" ? this.state.endDate : null,
          "integration_id": datasourceId,
          "data_set_id": Number(datasetId),
          "meta_data_id": [attributeId], // Only the selected attribute
          "menu_type": "monitor",
          "browser_tab_id": this.props.browserTabId,
          "session_id": this.props.browserSessionId,
          "user_id": this.props.userId,
          selectedMeticsName: '',
          type: "Attribute",
          selected_ids: [attributeId],
          ids_type: "dataset"
        }
        if (this.state.isCheckedBoxPartition && isChild !== "") {
          requestParams["is_child"] = true;
        }
        let chartDataResponse = await this.getChartDataResponse(requestParams)
        if (chartDataResponse === undefined) {
          this.setState({ errorOccurred: true, isLoadingMore: false,blurLoader:false  });
        } else {
          if (chartDataResponse !== null && chartDataResponse.code === 200) {
            $(".qd-rt_main-content").removeClass("opacity-50")
            let currentKey = Object.keys(chartDataResponse.response.bottom_panel_data)
            this.setState({
              dataType: "Attribute",
              bottomPanelData: chartDataResponse.response.bottom_panel_data,
              currentBottomPanelData: chartDataResponse.response.bottom_panel_data[currentKey[0]],
              chartData: chartDataResponse.response.chart_details,
              selectedDatasetId: datasetId,
              selectedDatasetName: datasetName,
              selectedIntegrationName: datasourceName,
              selectedDatasetAttrId: attributeId,
              selectedDatasetAttrName: attributeName,
              preSelectedAttribute: { "label": attributeName, "value": attributeId },
              selectedLeftPanelType: type,
              selectedIntegrationId: datasourceId,
              isCheckedIncidents: false,
              startDate: this.state.startDate,
              endDate: this.state.endDate,
              isLoadingMore: false,
              selectedMeticsName: '',
              blurLoader:false,
              isBottomPanelLoading: false 


            });
          }
          else {
            $(".qd-rt_main-content").removeClass("opacity-50")
            this.setState({
              bottomPanelData: {},
              chartData: {},
              selectedDatasetId: datasetId,
              selectedDatasetName: datasetName,
              selectedIntegrationName: datasourceName,
              selectedDatasetAttrId: attributeId,
              selectedDatasetAttrName: attributeName,
              preSelectedAttribute: { "label": attributeName, "value": attributeId },
              selectedLeftPanelType: type,
              selectedIntegrationId: datasourceId,
              isCheckedIncidents: false,
              startDate: this.state.startDate,
              endDate: this.state.endDate,
              isLoadingMore: false,
              blurLoader:false,
              isBottomPanelLoading: false 

            });
          }
        }
      });
    }
    else if (type === "Metrics") {
      this.setState({ selectedMeticsName: "" });
    }
    else if (type === undefined && title !== undefined) {
      let metricData = this.state.metricsValueResponse;
      let datasetIdNum = Number(datasetId);

      let attributeArray = metricData?.attributes?.[datasetIdNum];
      if (Array.isArray(attributeArray)) {
        fullAttributeList = attributeArray
          .map(attr => attr?.value)
          .filter(v => typeof v === 'number')
          .sort((a, b) => a - b);
      } else {
        fullAttributeList = [];
      }

      const isDatasetMetric = typeof id === "string" && id.startsWith("dataset_");
      let shouldCallApi = false;

      if (isDatasetMetric) {

        const prevMetricsId =id || this.state.selectedMetricsId ;
        if (prevMetricsId.startsWith("dataset_")) {
          shouldCallApi = true; 
        } 
        // else {
        //   shouldCallApi = true; 
        // }
      }
      if(title ==="Unique Rows"){
        title ="Unique Values"
      }
   this.setState({ selectedMeticsName: title, selectedMetricsId:id,pushtime: moment().format("YYYY-MM-DD HH:mm:ss")});
   if(shouldCallApi) {const isSameDataset = this.state.selectedDatasetId === datasetId;
      this.setState({
        allAttributeIdsForDataset: fullAttributeList,
        fullAttributeList: fullAttributeList,
        currentAttributePageIndex: 0, // Start from the first page
        chartData: {}, // Clear existing chart data for a new dataset selection
        isLoadingMore: true, // Indicate loading for the initial set
        selectedDatasetId:"",
        selectedMetricsId:"",
        selectedMeticsName:"",
        currentBottomPanelData: "",
        startDate: isSameDataset ? this.state.startDate : "",
        endDate: isSameDataset ? this.state.endDate : "",
        dateFilterStartDate: isSameDataset ? this.state.dateFilterStartDate :  null,
        dateFilterEndDate: isSameDataset ? this.state.dateFilterEndDate : null,
        blurLoader:true
      }, async () => {

        const initialAttributeIds = fullAttributeList.slice(0, this.state.attributesPerLoad);
        const hasMore = fullAttributeList.length > this.state.attributesPerLoad;

        // Update hasMoreData before making the call
        this.setState({ hasMoreData: hasMore });

        // let selectedIds = initialAttributeIds

        $(".qd-rt_main-content").addClass("opacity-50");
        let requestParams = {
          "tab_type": 1,
          "tenant_id": this.props.teamId,
          "env_id": this.props.selectedEnvId,
          "start_date": this.state.startDate !== "" ? this.state.startDate : null,
          "end_date": this.state.endDate !== "" ? this.state.endDate : null,
          "integration_id": datasourceId,
          "data_set_id": Number(datasetId),
          "meta_data_id": initialAttributeIds, // Send only the initial chunk
          "menu_type": "monitor",
          "browser_tab_id": this.state.browserTabId,
          "session_id": this.state.browsersessionId,
          "user_id": this.props.userId,
          dateFilterStartDate: null,
          dateFilterEndDate: null,
          dateFilterShowStartCalendar: true,
          dateFilterShowEndCalendar: false,
          "additional_info": { "id": datasetId, "type": "dataset" },
          selected_ids: [datasetId],
          "type": "DatasetandAttribute",
          ids_type: "dataset"

        }

        if (this.state.isCheckedBoxPartition && isChild !== "") {
          requestParams["is_child"] = true;
        }
        let chartDataResponse = await this.getChartDataResponse(requestParams)
        if (chartDataResponse === undefined) {
          this.setState({ errorOccurred: true, isLoadingMore: false,blurLoader:false });
        } else {
          if (chartDataResponse !== null && chartDataResponse.code === 200) {
          let bottomPanelData = chartDataResponse.response.bottom_panel_data;
          let currentKey = Object.keys(bottomPanelData).find(
            key => key.startsWith(datasetId.toString() + "_dt")
          );
            $(".qd-rt_main-content").removeClass("opacity-50")
            this.setState(prevState => ({
              dataType: "Dataset",
              bottomPanelData: chartDataResponse.response.bottom_panel_data,
              currentBottomPanelData: chartDataResponse.response.bottom_panel_data[currentKey],
              chartData: chartDataResponse.response.chart_details, // Set initial chart data
              selectedDatasetId: datasetId,
              selectedDatasetName: datasetName,
              selectedIntegrationName: datasourceName,
              selectedLeftPanelType: type,
              selectedIntegrationId: datasourceId,
              incidentStartDate: chartDataResponse.response.start_date,
              incidentEndDate: chartDataResponse.response.end_date,
              lastProcessedDate: chartDataResponse.response.last_processed_time,
              // minDate: new Date(moment(chartDataResponse.response.first_processed_time).format("Y-MM-DD")),
              // maxDate: new Date(moment(chartDataResponse.response.last_processed_time).format("Y-MM-DD")),
              isCheckedIncidents: false,
              // startDate: this.state.startDate || chartDataResponse.response.start_date,
              // endDate: this.state.endDate || chartDataResponse.response.end_date,
              selectedMeticsName: title,
              selectedDatasetAttrName: "",
              preSelectedAttribute: null,
              preSelectedDataset: { "label": datasetName, "value": datasetId },
              currentAttributePageIndex: 1, // Move to the next page for subsequent loads
              isLoadingMore: false, // Loading complete
              selectedDatasetAttrId: "",
              saveList: [],
              startIndex: 0,
              selectedMetricsId:id,
              blurLoader:false
            }));
          } else {
            this.setState({ isLoadingMore: false ,blurLoader:false});
          }
        }
      });}
    }
  }

  async focusChart(row) {


    if (this.state.incidentPanelState === "full"){
      this.setState({ incidentPanelState: "half" })
    }    
    if (row.Name.value.type === 2) {
      $(".qd-rt_main-content").addClass("opacity-50")
      let requestParams = {
        "tab_type": 1,
        "tenant_id": this.props.teamId,
        "env_id": this.props.selectedEnvId,
        // "start_date":"2025-01-01",
        // "end_date":"2025-01-29",
        "start_date": this.state.startDate !== "" ? this.state.startDate : null,
        "end_date": this.state.endDate !== "" ? this.state.endDate : null,
        "integration_id": this.state.selectedIntegrationId,
        "data_set_id": this.state.selectedDatasetId,
        "meta_data_id": [row.Name.value.id],
        "menu_type": "monitor",
        "browser_tab_id": this.props.browserTabId,
        "session_id": this.props.browserSessionId,
        "user_id": this.props.userId,
        dateFilterStartDate: null,
        dateFilterEndDate: null,
        dateFilterShowStartCalendar: true, // Start date picker shown by default
        dateFilterShowEndCalendar: false,
        selectedMeticsName: '',
        type: "Attribute",
          selected_ids: [row.Name.value.id],
          ids_type: "dataset"
        // "additional_info": { "id": 203, "type": "attribute" }
      }
      let chartDataResponse = await this.getChartDataResponse(requestParams)
      if (chartDataResponse === undefined) {
        this.setState({ errorOccurred: true });
      } else {
        if (chartDataResponse.code === 200) {
           const clsName = `Attribute-left-panel-div-Attribute-${row.Name.value.id}Attribute`;
            const targetDiv = document.getElementById(clsName);
            if (targetDiv) {
              // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
              const allLis = document.querySelectorAll('li.active');
              allLis.forEach(li => {
                const datasetPanelDiv = li.querySelector('#Dataset-left-panel');
                if (!datasetPanelDiv) {
                  li.classList.remove('active');
                }
              });

              // Traverse up to find the parent li element of the current target div
              let parentLi = targetDiv.parentNode;
              while (parentLi && parentLi.tagName !== 'LI') {
                parentLi = parentLi.parentNode;
              }

              // Add the 'active' class to the parent li of the current target div
              if (parentLi) {
                parentLi.classList.add('active');
              }
            }
          $(".qd-rt_main-content").removeClass("opacity-50")
          this.setState({
            bottomPanelData: chartDataResponse.response.bottom_panel_data,
            chartData: chartDataResponse.response.chart_details,
            selectedDatasetId: this.state.selectedDatasetId,
            selectedDatasetName: this.state.selectedDatasetName,
            selectedIntegrationName: this.state.selectedIntegrationName,
            selectedLeftPanelType: this.state.selectedLeftPanelType,
            selectedIntegrationId: this.state.selectedIntegrationId,
            selectedDatasetAttrName:row.Name.value.name,
            preSelectedAttribute:{"label" :row.Name.value.name, "value": row.Name.value.id},
            isCheckedIncidents: false,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            apiCount: 0,
            dataType: "Attribute",
            selectedDatasetAttrId:row.Name.value.id
          });
        }
        else{
          $(".qd-rt_main-content").removeClass("opacity-50")
        }
      }
    }
    else if (row.Name.value.type === 1) {
          let fullAttributeList = [];

            let metricData = this.state.metricsValueResponse;
      let datasetIdNum = Number(this.state.selectedDatasetId);

      let attributeArray = metricData?.attributes?.[datasetIdNum];
      if (Array.isArray(attributeArray)) {
        fullAttributeList = attributeArray
          .map(attr => attr?.value)
          .filter(v => typeof v === 'number')
          .sort((a, b) => a - b);
      } else {
        fullAttributeList = [];
      } 
      const initialAttributeIds = fullAttributeList.slice(0, this.state.attributesPerLoad);
        const hasMore = fullAttributeList.length > this.state.attributesPerLoad;

        // Update hasMoreData before making the call
        this.setState({ hasMoreData: hasMore });
        $(".qd-rt_main-content").addClass("opacity-50");
        let requestParams = {
          "tab_type": 1,
          "tenant_id": this.props.teamId,
          "env_id": this.props.selectedEnvId,
          "start_date": this.state.startDate !== "" ? this.state.startDate : null,
          "end_date": this.state.endDate !== "" ? this.state.endDate : null,
          "integration_id": this.state.selectedIntegrationId,
          "data_set_id": this.state.selectedDatasetId,
          "meta_data_id": initialAttributeIds, // Send only the initial chunk
          "menu_type": "monitor",
          "browser_tab_id": this.state.browserTabId,
          "session_id": this.state.browsersessionId,
          "user_id": this.props.userId,
          dateFilterStartDate: null,
          dateFilterEndDate: null,
          dateFilterShowStartCalendar: true,
          dateFilterShowEndCalendar: false,
          "additional_info": { "id": this.state.selectedDatasetId, "type": "dataset" },
          selected_ids: [this.state.selectedDatasetId],
          "type": "DatasetandAttribute",
          ids_type: "dataset"

        }

        if (this.state.isCheckedBoxPartition) {
          requestParams["is_child"] = true;
        }
        let chartDataResponse = await this.getChartDataResponse(requestParams)
        if (chartDataResponse === undefined) {
          this.setState({ errorOccurred: true, isLoadingMore: false,blurLoader:false });
        } else {
          if (chartDataResponse !== null && chartDataResponse.code === 200) {
          let bottomPanelData = chartDataResponse.response.bottom_panel_data;
          let currentKey = Object.keys(bottomPanelData).find(
            key => key.startsWith(this.state.selectedDatasetId.toString() + "_dt")
          );

      //     const selectedMetricId =row.Name.value.metrics_details[0].metrics_id
      //     let chartDetails = chartDataResponse.response.chart_details;

      //     let filteredChartData = chartDetails;

      //  //  alert(selectedMetricId)
      //   if (selectedMetricId) {
      //     filteredChartData = Object.keys(chartDetails)
      //       .filter(key => key.includes(`_${selectedMetricId}_dt`))
      //       .reduce((acc, key) => {
      //         acc[key] = chartDetails[key];
      //         return acc;
      //       }, {});
      //   }


      const selectedMetricIds = row.Name.value.metrics_details.map(
        item => item.metrics_id
      );

      let chartDetails = chartDataResponse.response.chart_details;
      let filteredChartData = chartDetails;

      if (selectedMetricIds && selectedMetricIds.length > 0) {
        filteredChartData = Object.keys(chartDetails)
          .filter(key =>
            selectedMetricIds.some(id =>
              key.includes(`_${id}_dt`)
            )
          )
          .reduce((acc, key) => {
            acc[key] = chartDetails[key];
            return acc;
          }, {});
      }

                    
          $(".qd-rt_main-content").removeClass("opacity-50")
            this.setState(prevState => ({
              pushtime: moment().format("YYYY-MM-DD HH:mm:ss"),
              dataType: "Dataset",
              bottomPanelData: chartDataResponse.response.bottom_panel_data,
              currentBottomPanelData: chartDataResponse.response.bottom_panel_data[currentKey],
              chartData:filteredChartData, // Set initial chart data
              selectedDatasetId: this.state.selectedDatasetId,
              selectedDatasetName: this.state.selectedDatasetName,
              selectedIntegrationName: this.state.selectedIntegrationName,
              selectedLeftPanelType: "Dataset",
              selectedIntegrationId: this.state.selectedIntegrationId,
              incidentStartDate: chartDataResponse.response.start_date,
              incidentEndDate: chartDataResponse.response.end_date,
              lastProcessedDate: chartDataResponse.response.last_processed_time,
              minDate: new Date(moment(chartDataResponse.response.first_processed_time).format("Y-MM-DD")),
              maxDate: new Date(moment(chartDataResponse.response.last_processed_time).format("Y-MM-DD")),
              isCheckedIncidents: false,
              startDate: this.state.startDate ||  chartDataResponse.response.start_date,
              endDate:  moment().format("YYYY-MM-DD"),             
              selectedMeticsName: '',
              selectedDatasetAttrName: "",
              preSelectedAttribute: null,
              preSelectedDataset: { "label": this.state.selectedDatasetName, "value": this.state.selectedDatasetId },
              currentAttributePageIndex: 1, // Move to the next page for subsequent loads
              isLoadingMore: false, // Loading complete
              selectedDatasetAttrId: "",
              saveList: [],
              startIndex: 0,
              blurLoader:false,
              isBottomPanelLoading: false 
            }));
          } else {
            this.setState({ isLoadingMore: false ,blurLoader:false});
          }
        
      }
    }
    else {
      if (this.listRef.current) {
        this.listRef.current.scrollToItem(0, "start");
      }
    }

  }

  // componentDidMount () {
  //   window.addEventListener('resize', this.handleChartGridResize())
  // }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
    }
    window.removeEventListener('resize', this.handleChartGridResize())
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener('keydown', this.handleEscKey);

  }

  handleEscKey = (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      // console.log('Exiting fullscreen mode');
      this.setState({showChartFullscreen : false});
      // your logic here
    }
  };

  handleEscapeMessageClose = () => {
    this.setState({ escapeMessage: false });
  };

  // Handle Dynamic Chart Grid Width
  calculateChartGridWidth = () => {
  const screenWidth = window.innerWidth;
  if (this.state.showChartFullscreen) return screenWidth;
  if (screenWidth > 1450) {
    return 414;
  } else if (screenWidth > 1200) {
    return 343;
  } else {
    return 293;
  }
};

  handleChartGridResize = () => {
  this.setState({ 
    chartGridWidth: this.calculateChartGridWidth(),
    resizeCounter: this.state.resizeCounter + 1
  });
  }

  handleIncidentToast = () => {
    this.setState({ showIncidentToast: true })
  }
  handleCloseIncidentToast = () => {
    this.setState({ showIncidentToast: !this.state.showIncidentToast })
  }

  // Handler for changing the start date
  handledateFilterStartDateChange = (date) => {
    this.setState({
      dateFilterStartDate: date,
      //dateFilterShowStartCalendar: false, // Hide start calendar after selection
    });
  };


  // Handler for changing the start date
  handledateFilterCustomStartDateChange = (date) => {
    this.toggleEndCalendar()
    this.setState({
      dateFilterStartDate: date,
      //dateFilterShowStartCalendar: false, // Hide start calendar after selection
    });
  };


  // Handler for changing the end date
  handledateFilterEndDateChange = (date) => {
    this.setState({
      dateFilterEndDate: date,
      //    dateFilterShowEndCalendar: false, // Hide end calendar after selection
    });
  };

  // Toggle start date picker
  toggleStartCalendar = () => {
    this.setState({
      dateFilterShowStartCalendar: true,
      dateFilterShowEndCalendar: false, // Hide end calendar if open
    });
  };

  // Toggle end date picker
  toggleEndCalendar = () => {
    this.setState({
      dateFilterShowEndCalendar: true,
      dateFilterShowStartCalendar: false, // Hide start calendar if open
    });
  };
handleMonitorSwitchConfirm = () => {
    browserHistory.push({
    pathname: '/monitor',
    state: { fromSwitch: true} // pass any data here
   });
};

handleMonitorSwitchCancel(){



              this.setState({ switchRealTimeView: false }, () => {
              this.renderchartView("",
                      this.state.selectedIntegrationName,
                      this.state.selectedDatasetName,
                      this.state.selectedDatasetAttrName,
                      "",
                      this.state.selectedIntegrationId,
                      this.state.selectedDatasetId,
                      this.state.selectedDatasetAttrId,
                      this.state.selectedMetricsId,
                      this.state.selectedLeftPanelType,
                      null,this.state.selectedMeticsName)
              });
}

  handleDateRange = (range) => {

    $('.qd_cr-wrap .qd_cr-btn').removeClass('active');
    // Add 'active' class to the clicked button
    $("#dateRanges_" + range).addClass('active');
    //  this.setState({ selectedRange: range });
    
    const rangeEndDate = moment().format("YYYY-MM-DD");
    let rangeStartDate = rangeEndDate;
    switch (range) {
      case "1D":
        rangeStartDate = moment(rangeEndDate).subtract(0, "days").format("Y-MM-DD");
        break;
      case "5D":
        rangeStartDate = moment(rangeEndDate).subtract(5, "days").format("Y-MM-DD");
        break;
      case "1M":
        rangeStartDate = moment(rangeEndDate).subtract(1, "months").format("Y-MM-DD");
        break;
      case "3M":
        rangeStartDate = moment(rangeEndDate).subtract(3, "months").format("Y-MM-DD");
        break;
      case "6M":
        rangeStartDate = moment(rangeEndDate).subtract(6, "months").format("Y-MM-DD");
        break;
      default:
        break;
    }


    // const deploymentDate = moment(WINEDIRECT_REALTIME_DEPLOYMENT_DATE, "DD-MM-YYYY");
    // const start = moment(rangeStartDate);
    // const end = moment(rangeEndDate);
    // let switchflag = false;
    // if (end.isBefore(deploymentDate, 'day') || start.isBefore(deploymentDate, 'day')) {
    //   switchflag = true;
    // }
    // // else if (start.isAfter(deploymentDate, 'day')) {
    // //   switchflag = true;
    // // }
    // else {
    //   switchflag = false;
    // }

    const deploymentDate = moment(WINEDIRECT_REALTIME_DEPLOYMENT_DATE, "YYYY-MM-DD", true);
    const start = moment(rangeStartDate, "Y-MM-DD", true);
    let switchflag = false;
    if (deploymentDate.isValid()) {
      switchflag = !deploymentDate.isBefore(start, 'day');
    }

    this.setState({
      startDate: rangeStartDate,
      endDate: rangeEndDate,
      selectedDate: null,
      selectedRange: range,
      switchRealTimeView: switchflag

    }, () => {
      if(switchflag === false){
      this.renderchartView("",
        this.state.selectedIntegrationName,
        this.state.selectedDatasetName,
        this.state.selectedDatasetAttrName,
        "",
        this.state.selectedIntegrationId,
        this.state.selectedDatasetId,
        this.state.selectedDatasetAttrId,
        this.state.selectedMetricsId,
        this.state.selectedLeftPanelType,
        null,this.state.selectedMeticsName)
      }
    });
  };

  handleIncidentScreenToggle = () => {
    this.setState((prevState) => ({
      incidentsPanelFullScreen: !prevState.incidentsPanelFullScreen,
    }));
  };

  // // Handler to incidents toggle the checkbox state
  handleToggleIncidents = () => {
    const filteredChartDetails = {};
    let id="";

    for (const key in this.state.chartData) {
      const details = this.state.chartData[key];
      if (
        // details !== undefined &&
        details.metric_threshold_error_status !== undefined &&
        details.metric_threshold_error_status.includes(true)
      ) {
        filteredChartDetails[key] = details;
         if(id !== "" && id !== key){
            let dummyKey = "dummy_"+key
            filteredChartDetails[dummyKey] = {};
        }
      }
      id = key
    }
    
    const hasIncidents = Object.keys(filteredChartDetails).length > 0;

    if (!hasIncidents) {
      // Temporarily enable the switch
      this.setState({ isCheckedIncidents: true }, () => {
        // After 2 seconds, disable it and show toast
        setTimeout(() => {
          this.setState({
            isCheckedIncidents: false,
            showIncidentToast: true
          });
        }, 200);
      });
    } else {
      // Incidents found, update the state normally
      this.setState({
        isCheckedIncidents: !this.state.isCheckedIncidents,
        incidentchartData: filteredChartDetails,
      });
    }
  };

  togglePanel = () => {
    this.setState((prevState) => {
      const newState =
        prevState.incidentPanelState === "minimized"
          ? "half"
          : prevState.incidentPanelState === "half"
            ? "full"
            : "minimized";
      return { incidentPanelState: newState };
    });
  };

  toggleIncidentPanel() {
    if (this.state.incidentPanelState === "full")
      this.setState({ incidentPanelState: "halffull" })
    else
      this.setState({ incidentPanelState: "full" })
  }

  setIncidentPanelState = (state) => {
    this.setState({
      incidentPanelState: state,
    })
  };

  toggleBottomStatPanel = () => {
    this.setState({ expandBottomStatPanel: !this.state.expandBottomStatPanel });
  }

  // Function to scroll grid to top
  scrollToTop = () => {
    if (this.gridRef) {
      this.gridRef.scrollTo({ scrollTop: 0 });
    }
  };

  renderChart(charttype) {
    // $('#topmenugraph').removeClass("open")
    // $('.qd-toolbar_dropdown-wrap').removeClass("open")
    // this.setState({ selectedChart: charttype, selectedTopMenu: "" }, function () {
      // this.forceChartRerender()
        this.setState({ selectedChart: charttype, chartTypes: {}, selectedTopMenu: "" }, function () {
    });
  }

  handleChartFullscreen = () => {
    this.setState({ showChartFullscreen: !this.state.showChartFullscreen,incidentPanelState:"minimized" });
  }

  getWatchListResponse() {
    let requestParams = {
      "tab_type": this.state.seletedTabId, // DQ Tab
      "tenant_id": this.state.teamId, // Team Id
      "env_id": this.props.selectedEnvId,
      "user_id": this.state.userId
    }
    return getWatchList(requestParams);
  }

  extractMultipleWatchlistIds(data) {
    if (
      typeof data !== 'object' ||
      data === null ||
      !data.result ||
      !data.result.watch_list ||
      !Array.isArray(data.result.watch_list)
    ) {
      return {};
    }

    const allWatchlistIds = {};

    data.result.watch_list.forEach(watchlistItem => {
      const watchlistId = watchlistItem.watch_list_id;
      const watchlistName = watchlistItem.watch_list_name;
      if (typeof watchlistId !== 'undefined') {
        const watchlistData = watchlistItem.watch_list_data || {};
        const attributes = watchlistData.attributes || {};
        const datasets = watchlistData.datasets || {};
        const integrations = watchlistData.integrations || [];

        const metaData_ids = [];
        for (const attributeGroup of Object.values(attributes)) {
          if (Array.isArray(attributeGroup)) {
            attributeGroup.forEach(attribute => {
              if (attribute && typeof attribute.value !== 'undefined') {
                metaData_ids.push(attribute.value);
              }
            });
          }
        }

        for (const datasetGroup of Object.values(datasets)) {
          if (Array.isArray(datasetGroup)) {
            datasetGroup.forEach(dataset => {
              if (dataset && typeof dataset.value !== 'undefined') {
                metaData_ids.push(dataset.value);
              }
            });
          }
        }

        if (Array.isArray(integrations)) {
          integrations.forEach(integration => {
            if (integration && typeof integration.value !== 'undefined') {
              metaData_ids.push(integration.value);
            }
          });
        }

        allWatchlistIds[watchlistId] = {
          watchlist_id: watchlistId,
          watchlist_name: watchlistName,
          metadata_ids: [...new Set(metaData_ids)].sort((a, b) => a - b),
        };
      }
    });

    return allWatchlistIds;
  }

  //save watchlist API
  async saveWatchListResponse(metricsValueResponse) {
    let checkedStates = this.state.checkedStates || {};

    // Validate child datasets have their parent datasets selected
    const childDatasetErrors = [];
    metricsValueResponse.datasets.forEach(dataset => {
      if (dataset.is_child_dataset && dataset.parent_data_set_id) {
        const childDatasetKey = `Partition-${dataset.value}`;
        const parentDatasetKey = `Dataset-${dataset.parent_data_set_id}`;
        
        // If child dataset is selected but parent is not
        if (checkedStates[childDatasetKey]?.checked && !checkedStates[parentDatasetKey]?.checked) {
          childDatasetErrors.push(
            `Child dataset "${dataset.label}" (ID: ${dataset.value}) requires parent dataset (ID: ${dataset.parent_data_set_id}) to be selected.`
          );
        }
      }
    });
    
    // If there are validation errors, show alert and return
    if (childDatasetErrors.length > 0) {
      alert("Watchlist Creation Error:\n\n" + childDatasetErrors.join("\n\n"));
      return;
    }

    // Validate attribute/dataset relationship in a simple way
    const selectedDatasetIds = new Set();
    const selectedAttributeIds = new Set();

    Object.entries(checkedStates).forEach(([key, node]) => {
      if (!node?.checked) return;
      const [, id] = key.split("-");
      if (!id) return;
      if (node.type === "Dataset" || node.type === "Partition") selectedDatasetIds.add(id);
      if (node.type === "Attribute" || node.type === "Partition Attribute") selectedAttributeIds.add(id);
    });

    const attributeToDatasetMap = {};
    (metricsValueResponse.attributes || []).forEach((attribute) => {
      if (attribute?.value != null && attribute?.data_set_id != null) {
        attributeToDatasetMap[String(attribute.value)] = String(attribute.data_set_id);
      }
    });

    const attributeError = [...selectedAttributeIds].find((attrId) => {
      const dsId = attributeToDatasetMap[String(attrId)];
      return dsId && !selectedDatasetIds.has(dsId);
    });

    if (attributeError) {
      console.error(`Watchlist Creation Error:\n\nAttribute ${attributeError} needs its dataset selected.`);
      return;
    }

    const datasetError = [...selectedDatasetIds].find((datasetId) => {
      const datasetAttributes = Object.entries(attributeToDatasetMap)
        .filter(([, dsId]) => dsId === datasetId)
        .map(([attrId]) => attrId);
      if (datasetAttributes.length === 0) return false;
      return !datasetAttributes.some((attrId) => selectedAttributeIds.has(attrId));
    });

    if (datasetError) {
      console.error(`Watchlist Creation Error:\n\nDataset ${datasetError} has attributes available but none are selected.`);
      return;
    }

    let watchListData = {
      attributes: {},
      datasets: {},
      integrations: []
    };

    // Track integrations that will be marked as checked due to selected datasets
    const selectedIntegrations = new Set();

    // Process attributes
    metricsValueResponse.attributes.forEach(attribute => {
      const { data_set_id, label, value } = attribute;
      const key = data_set_id ? data_set_id.toString() : "unknown";
      const attrUniqueId = `Attribute-${value}`;
      const partitionAttrUniqueId = `PartitionAttribute-${value}`;

      if (checkedStates[attrUniqueId]?.checked || checkedStates[partitionAttrUniqueId]?.checked) {
        if (!watchListData.attributes[key]) {
          watchListData.attributes[key] = [];
        }
        watchListData.attributes[key].push({ label, value, status_code: true });
      }
    });
    // Build integration map
    const integrationMap = new Map();
    metricsValueResponse.integrations.forEach(integration => {
      integrationMap.set(integration.value, integration);
    });

    // Process datasets and associate them to integrations
    metricsValueResponse.datasets.forEach(dataset => {
      const datasetUniqueId = `Dataset-${dataset.value}`;
      const partitionDatasetUniqueId = `Partition-${dataset.value}`;

      if (checkedStates[datasetUniqueId]?.checked === true || checkedStates[partitionDatasetUniqueId]?.checked === true) {
        const { value, label, is_child_dataset, parent_data_set_id } = dataset;
        let assignedIntegrationId = null;

        // Find the integration this dataset belongs to
        for (const integration of integrationMap.values()) {
          if (integration.data_set_ids?.includes(value)) {
            assignedIntegrationId = integration.value;
            break;
          }
        }

        if (assignedIntegrationId !== null) {
          selectedIntegrations.add(assignedIntegrationId);

          if (!watchListData.datasets[assignedIntegrationId]) {
            watchListData.datasets[assignedIntegrationId] = [];
          }

          const datasetEntry = {
            label,
            value,
            status_code: true,
            ...(is_child_dataset && {
              is_child_dataset: true,
              parent_data_set_id
            })
          };

          watchListData.datasets[assignedIntegrationId].push(datasetEntry);
        }
      }
    });

  // Add only selected integrations (ones that have at least one selected dataset)
  metricsValueResponse.integrations.forEach(integration => {
    const integrationId = integration.value;

    if (selectedIntegrations.has(integrationId)) {
      watchListData.integrations.push({
        label: integration.label,
        value: integration.value,
        status_code: true,
        is_checked: true
      });

      // Ensure dataset array exists
      if (!watchListData.datasets[integrationId]) {
        watchListData.datasets[integrationId] = [];
        }
      }
    });

    // Prepare input params
    const inputParams = {
      tab_type: this.state.seletedTabId,
      tenant_id: this.state.teamId,
      env_id: this.props.selectedEnvId,
      user_id: this.state.userId,
      watch_list_name: this.state.watchListName,
      watch_list_data: watchListData,
    };

    try {
      if (this.state.selectedWatchListId && this.state.editWatchlist) {
        // Update existing watchlist
        inputParams.watch_list_id = this.state.selectedWatchListId;
        const response = await updateWatchList(inputParams);

        if (response.code === 200) {
          this.handleWishListClose();
          const watchListResponse = await this.getWatchListResponse();
          if (watchListResponse?.code === 200) {
            const watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse);
            this.setState({
              watchListInformation: watchListResponse.result.watch_list,
              watchListMapping,
              selectedWatchlistName: this.state.watchListName // Update selected name to the new name
            });
            
            // Reload left panel and right panel charts with updated watchlist
            this.handleWatchlistChange(this.state.watchListName, this.state.selectedWatchListId);
          } else {
            this.setState({ watchListInformation: '' });
          }

          this.showToast("success", "Watchlist successfully updated!");
        } else {
          this.showToast("error", response.message);
        }
      } else {
      // Save new watchlist
      const response = await saveWatchList(inputParams);
        if (response.code === 200) {
          this.handleWishListClose();
          const watchListResponse = await this.getWatchListResponse();
          if (watchListResponse?.code === 200) {
            const watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse);
            // Find the newly created watchlist ID
            const newWatchlist = watchListResponse.result.watch_list.find(
              wl => wl.watch_list_name === this.state.watchListName
            );
            this.setState({
              watchListInformation: watchListResponse.result.watch_list,
              watchListMapping,
              selectedWatchlistName: this.state.watchListName, // Select the new watchlist
              selectedWatchListId: newWatchlist?.watch_list_id || null // Set the new watchlist ID
            });
            
            // Reload left panel and right panel charts with new watchlist
            if (newWatchlist?.watch_list_id) {
              this.handleWatchlistChange(this.state.watchListName, newWatchlist.watch_list_id);
            }
          } else {
            this.setState({ watchListInformation: '' });
          }

          this.showToast("success", "Watchlist successfully saved!");
        } else {
          if (response.message === "Watchlist name already exists in the tenant.") {
            this.setState({ watchListNameError: "Duplicate Watchlist name detected." });
            this.showToast("error", "The watchlist name already exists in the environment");
          } else {
            this.showToast("error", response.message);
          }
        }
      }
    } catch (error) {
      console.error("Save/Update Watchlist Error:", error);
      this.showToast("error", "An error occurred while saving/updating the watchlist.");
    }
  }


  //delete watchlist 
  deleteWatchListResponse = async () => {
    const { selectedWatchListId, userId } = this.state;
    let requestParams = {
      tab_type: 1,
      tenant_id: this.state.teamId,
      user_id: userId,
      env_id: this.props.selectedEnvId,
      watch_list_id: selectedWatchListId,
    };

    return deleteWatchList(requestParams)
  };

  getAllMetaDataResponse() {
    let requestParams = {
      "tab_type": this.state.seletedTabId,
      "tenant_id": this.state.teamId, // team id,
      "env_id": this.props.selectedEnvId
    }
    return getAllMetaData(requestParams);
  }

  getAllInterationsResponse() {
    let requestParams = {
      "tab_type": this.state.seletedTabId,
      "tenant_id": this.state.teamId, // team id,
      "env_id": this.props.selectedEnvId
    }
    return getAllEnvironmentIntegrations(requestParams);
  }

  getEditWatchlistResponse() {
    let requestParams = {

      "tab_type": 1,
      "tenant_id": this.state.teamId,
      "user_id": this.state.userId,
      "env_id": this.props.selectedEnvId,
      "watch_list_id": this.state.selectedWatchListId

    }
    return getEditWatchList(requestParams)
  }

  getProgressInfoResponse(integration_id) {

    let requestParams = {
      "tenant_id": this.state.teamId, // team id,
      "integration_id": integration_id,
      "mode":"realtime"
    }
    return getProgressInfo(requestParams);
  }

  getMetricsValueResponse = async (integrationId, watchListId, partition,startDate,endDate) => {

    // Safely access selectedWatchListId and provide a default value
    const selectedWatchListId = watchListId;  // Default to an empty string if undefined

    let requestParams;
    this.setState({ selectedIntegrationId: integrationId  || this.state.selectedIntegrationId});

    if (selectedWatchListId !== "" && selectedWatchListId !== undefined && integrationId === undefined) {
      // Case when watch list ID is selected and integration ID is undefined
      requestParams = {
        "tenant_id": this.state.teamId,
        "env_id": this.props.selectedEnvId,
        "watch_list_id": selectedWatchListId,
        "start_date":  null,
        "end_date":  null,
        "user_id": this.state.userId,
        "tab_type": this.state.seletedTabId,
        ...(partition && { "is_partitions": true })
      };
    } else {
      const integId = this.state.initialIntegrationId || integrationId;
      // Case when integration ID is passed
      requestParams = {
        "tenant_id": this.state.teamId,
        "env_id": this.props.selectedEnvId,
        "integration_id":  integId,
       "start_date": null,
        "end_date": null,
        "user_id": this.state.userId,
        "tab_type": this.state.seletedTabId,
        ...(partition && { "is_partitions": true })
      };
    }



    try {
      // Await the API response
      const response = await getMetricsValue(requestParams);  // Use await to wait for the response
      if (response && response.data) {
        const apiData = response.data;

            // If no datasets are found, reset bottom panel
        if (apiData.status === "No Datasets found") {
          this.setState({
            metricsValueResponse: apiData,
            inputData: {},
            currentBottomPanelData: "",
            bottomPanelData: "",
            preSelectedDataset: null,
            noDatasetFound : true
          });
          return;
        }


         const isEmpty =
  Object.keys(apiData.attributes).length === 0 &&
  Object.keys(apiData.datasets).length === 0 


  if(isEmpty){

          this.setState({
            metricsValueResponse:[],
            currentBottomPanelData: "",
            bottomPanelData: "",
            //noDatasetFound : true,
            isLoading:false,
            chartData:[]
          });
         
      return

  } 

        const inputData = this.transformMetricsValueResponse(apiData);

        this.setState({
          metricsValueResponse: response.data,  // Store the response data in the state
          inputData: inputData,  // Store the transformed data
          noDatasetFound:false
          // metaDataResponse: inputData,  // Store the transformed data for further use

        },() => {
          if (this.state.initialIntegrationId) {
            this.setState({ initialIntegrationId: null }, () => {
              if (this.props.onIntegrationConsumed) {
                this.props.onIntegrationConsumed();
              }
            });
          }
        });
      } else {
        console.error("No data in API response");
      }
    } catch (error) {
      console.error("Error in API call:", error);
    }
  };

  transformMetricsValueResponse = (originalData) => {
    const transformedAttributes = [];
    const transformedDatasets = [];
    const allAttributeValues = [];
    const integrationId = originalData?.integrations?.[0]?.value;

    // 1. Process attributes
    for (const dataSetId in originalData.attributes) {
      originalData.attributes[dataSetId].forEach(attr => {
        transformedAttributes.push({
          data_set_id: parseInt(dataSetId, 10),
          label: attr.label,
          value: attr.value
        });
        allAttributeValues.push(attr.value);
      });
    }

    // Sort attributes as in your desired output
    transformedAttributes.sort((a, b) => {
      if (a.data_set_id !== b.data_set_id) {
        return a.data_set_id - b.data_set_id;
      }
      return a.value - b.value;
    });

    // 2. Process datasets
    const dataSetIds = [];
    if (originalData.datasets.hasOwnProperty(integrationId)) {
      originalData.datasets[integrationId].forEach(dataset => {
        const attributeIds = originalData.attributes[dataset.value].map(attr => attr.value);
        transformedDatasets.push({
          attribute_ids: attributeIds.sort((a, b) => a - b),
          integration_id: integrationId,
          label: dataset.label,
          value: dataset.value
        });
        dataSetIds.push(dataset.value);
      });
    }

    // Sort datasets by value in descending order
    transformedDatasets.sort((a, b) => b.value - a.value);

    // 3. Process integrations
    // const envId = originalData.environments !==undefined && originalData.environments[0].value;
    const integrationLabel = originalData?.integrations[0]?.label;
    const transformedIntegrations = [{
      data_set_ids: dataSetIds.sort((a, b) => b - a),
      env_id: this.state.selectedEnvId ,
      label: integrationLabel,
      value: integrationId
    }];

    // 4. Create other fields
    const disabledAttributes = [...allAttributeValues, ...allAttributeValues].sort((a, b) => a - b);
    const disabledIntegration = disabledAttributes.map(() => integrationId);

    return {
      attributes: transformedAttributes,
      datasets: transformedDatasets,
      disabled_attributes: disabledAttributes,
      disabled_datasets: [],
      disabled_integration: disabledIntegration,
      environments: originalData.environments,
      integrations: transformedIntegrations
    };
  };

  async getChartDataResponse(requestParams) {
    let response = await getChartData(requestParams);
    if (response.code === 401) {
      return null
    }

  let chart_details = response.response.chart_details || {};
  let bottom_panel_data = response.response.bottom_panel_data || {};
  let commonDict = {};
  let metaDatakeys = Object.keys(chart_details);
  let firstMetaData = metaDatakeys.length > 0 ? metaDatakeys[0].split("_")[0] : null;
  let metaDataKey = null;

  if (this.state.chartData && Object.keys(this.state.chartData).length > 0 && firstMetaData) {
    let dummyKey = `dummyKey_${firstMetaData}`;
    commonDict[dummyKey] = {};
  }

    for (const metadataId in chart_details) {
      let keyList = metadataId.split("_")
      if (metaDataKey === null) {
        metaDataKey = keyList[0]
      }
      let dummyKey = `dummyKey_${metaDataKey}`;
      metaDataKey = keyList[0]
      if (firstMetaData !== metaDataKey) {
        firstMetaData = keyList[0]
        dummyKey = `dummyKey_${metaDataKey}`;
        commonDict[dummyKey] = {};
      }

      // Recency Metric 
      let recencyMetric = keyList[0] + "_" + 408 + "_" + keyList[2]

      if (chart_details.hasOwnProperty(recencyMetric)) {
        commonDict[recencyMetric] = chart_details[metadataId]
      }
      commonDict[metadataId] = chart_details[metadataId]
      if (metaDatakeys.length === 1) {
        dummyKey = `dummyKey_${keyList[0]}`;
        commonDict[dummyKey] = {};
      }
    }
    response.response.chart_details = commonDict;
    response.response.bottom_panel_data = bottom_panel_data;
    return response;
  }

  getChartDataResponseOld(requestParams) {
    return getChartData(requestParams);
  }
integrationResposne(){
    let requestParams = {
      // "tab_type": this.state.seletedTabId,
      "tenant_id": this.state.teamId, // team id,
      // "env_id": this.props.selectedEnvId
    }
    return getIntegration(requestParams);
  
}
    async initalAPILoad() {
    try {
    this.setState({ showLoader: true, errorOccurred: false,blurLoader:true });

    //let chartDataResponse = await this.getChartDataResponse()
    let watchListResponse = await this.getWatchListResponse()
    let AllInterationsResponse = await this.getAllInterationsResponse()
    let progressResponse = await this.integrationResposne();
    // let meticsValueResponse = await this.getMetricsValueResponse()
    //let integrationResponse;
    // let metaDataResponse = await this.getAllMetaDataResponse()
    //  if (metaDataResponse === undefined || metaDataResponse === null) {
    //       this.setState({ errorOccurred: true });
    //     } else {
    //       if (metaDataResponse.code === 200) {
    //         this.setState({ metaDataResponse: metaDataResponse.data, inputData: metaDataResponse.data });
    //       }
    //     }
    // let chartDataResponse = await this.getChartDataResponse()
    let watchlistRequest;
    let integrationRequest = AllInterationsResponse;
    // let integrationRequest;
    // let chartRequest;

    // bottomPanelData
    if (integrationRequest.integrations.length === 1) {
         const integrationId = integrationRequest.integrations[0].value;
      const progressInfo = await this.getProgressInfoResponse(integrationId);
      if (progressInfo === undefined) {
        this.setState({ errorOccurred: true });
      } else if (progressInfo !== null && progressInfo.code === 200) {
        this.setState({ progressStatus: progressInfo.progress_percentage });

        if (progressInfo.progress_percentage !== 100) {
          this.setState({ inProgress: true, showLoader: false,blurLoader:false });
          return
        } else {
          this.setState({ inProgress: false, showLoader: false ,blurLoader:false});
        }
      }
      }
    if (watchListResponse === undefined) {
      this.setState({ errorOccurred: true });
    } else {
      if (watchListResponse.code === 200) {
        let watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse)
        this.setState({ watchListMapping: watchListMapping });
        watchlistRequest = watchListResponse.result.watch_list;
        if (watchlistRequest.length > 0) {
          this.setState({ watchListInformation: watchlistRequest, leftPanelLoader: false,blurLoader:false });
        }
        else {
          this.setState({ watchListInformation: '', leftPanelLoader: false ,blurLoader:false});
        }
      }
      else {
        this.setState({ watchListInformation: '', leftPanelLoader: false ,blurLoader:false});
      }
    }

   if (AllInterationsResponse === undefined || AllInterationsResponse === null) {
        this.setState({ errorOccurred: true });
} else {
  if (AllInterationsResponse.code === 200) {
    const selectedEnvId = this.props.selectedEnvId; 
    const allIntegrations = progressResponse?.integrations || [];
    const integrationOptions = allIntegrations
      .filter(
        (integration) =>
          integration.env_id === selectedEnvId &&
          integration.discovery_status !== "initialised"
      )
      .map((integration) => ({
        label: integration.integration_name,
        value: integration.integration_id
      }));

    if (integrationRequest.integrations && integrationRequest.integrations.length > 0) {
      this.setState({ integrationRequest: integrationOptions });

    } else {
      this.setState({ errorOccurred: true });
    }
  } else {
    this.setState({
      errorOccurred: true,blurLoader:false
      // integrationRequest: AllInterationsResponse.integrations
    });
  }
}
if (!progressResponse || progressResponse.code !== 200) {
  this.setState({ errorOccurred: true,blurLoader:false });
  return;
}

const integrations = progressResponse.integrations || [];

const envIntegrations = integrations.filter(
  (integration) => integration.env_id === this.props.selectedEnvId
);

if (envIntegrations.length === 0) {
  this.setState({ inProgress: false, showLoader: false,blurLoader:false });
  return;
}

const allInitialised = envIntegrations.every(
  (integration) => integration.discovery_status === "initialised"
);

if (!allInitialised) {
  this.setState({ inProgress: false, showLoader: false,blurLoader:false });
  return;
}

for (const integration of envIntegrations) {
  const integrationId = integration.integration_id;
  const progressInfo = await this.getProgressInfoResponse(integrationId);

  if (!progressInfo) {
      this.setState({ errorOccurred: true });
    continue;
  }

  if (progressInfo.code === 200) {
    const percentage = progressInfo.progress_percentage;
    this.setState({ progressStatus: percentage });

    if (percentage !== 100) {
      this.setState({ inProgress: true, showLoader: false ,blurLoader:false});
      } else {
      this.setState({ inProgress: false, showLoader: false,blurLoader:false });
      }
    }
}
 this.setState({ showLoader: false,blurLoader:false });
  } catch (err) {
    console.error("Error during initial load:", err);
    this.setState({ errorOccurred: true, showLoader: false,blurLoader:false });
  }
  }

  handleClickOutside = (event) => {

    // const dropdowns = document.querySelectorAll(".qd-toolbar_dropdown-wrap");
    // dropdowns.forEach((dropdown) => {
    //   if (!dropdown.contains(event.target)) {
    //     dropdown.classList.remove("show");
    //   }
    // });

  };

  setAttribute(pmid) {
          let meta = pmid.split("_");
          let attributeId = Number(meta[0]);
          let integrationId = this.state.selectedIntegrationId;

          let datasetArray = this.state.metricsValueResponse?.datasets?.[integrationId] || [];          
          let datasetObj = datasetArray.find(d => d.value === this.state.selectedDatasetId);
          let datasetValue = datasetObj?.value;
          let attributesList = this.state.metricsValueResponse?.attributes?.[datasetValue] || [];
          let finalData = attributesList.find(item => item.value === attributeId);
          let attributeName = finalData?.label || "";
          let metaDataId = `${attributeId}_attr`;

          this.setState({
                  currentBottomPanelData: this.state.bottomPanelData[metaDataId],
                  dataType: "Attribute",
                  selectedDatasetAttrName: attributeName,
                  preSelectedAttribute: { "label": attributeName, "value": attributeId },
                });

  }

  componentDidMount() {
const self = this; // Store component context
// Check for incident panel state in props.data
if (this.props.data && this.props.data.incidentPanelState) {
  this.setState({ incidentPanelState: this.props.data.incidentPanelState });
}

(function () {
  let scrollTimer = null;
  let lastChartKey = null;
  // const observerMap = new Map(); // Unused - kept for potential future use

  // Unused functions - kept for potential future use
  // function findChartId(el) {
  //   let current = el;

  //   while (current && current !== document.body) {
  //     if (current.dataset?.chartId) {
  //       return current.dataset.chartId;
  //     }
  //     current = current.parentElement;
  //   }

  //   const widget = el.closest(
  //     ".qd-rt_chart-container, .chart-widget, .row, .w-100"
  //   );

  //   if (widget) {
  //     const chartEl = widget.querySelector("[data-chart-id]");
  //     if (chartEl) return chartEl.dataset.chartId;
  //   }

  //   return null;
  // }

  // function observeHalfVisible(targetDiv, onVisible) {
  //   if (observerMap.has(targetDiv)) return;

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
  //         onVisible(entry.target);
  //       }
  //     },
  //     { threshold: [0.15] } //  25% visible
  //   );

  //   observer.observe(targetDiv);
  //   observerMap.set(targetDiv, observer);
  // }

  document.addEventListener(
    "scroll",
    function (event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const isScrollable =
        target.scrollHeight > target.clientHeight ||
        target.scrollWidth > target.clientWidth;

//      console.log(isScrollable);

      if (!isScrollable) return;

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        // Find all charts with data-chart-id attribute
        const allCharts = target.querySelectorAll("[data-chart-id]");
        if (!allCharts || allCharts.length === 0) return;

        // Find the most visible chart in the viewport
        let maxVisibleArea = 0;
        let mostVisibleChartId = null;

        allCharts.forEach(chartElement => {
          const rect = chartElement.getBoundingClientRect();
          const containerRect = target.getBoundingClientRect();

          // Calculate visible area within the container
          const visibleTop = Math.max(rect.top, containerRect.top);
          const visibleBottom = Math.min(rect.bottom, containerRect.bottom);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);

          const visibleLeft = Math.max(rect.left, containerRect.left);
          const visibleRight = Math.min(rect.right, containerRect.right);
          const visibleWidth = Math.max(0, visibleRight - visibleLeft);

          const visibleArea = visibleHeight * visibleWidth;

          if (visibleArea > maxVisibleArea) {
            maxVisibleArea = visibleArea;
            mostVisibleChartId = chartElement.dataset.chartId;
          }
        });

        if (!mostVisibleChartId) return;

//        console.log("Most visible chart detected:", mostVisibleChartId);

        const metaParts = mostVisibleChartId.split("_");
        if (metaParts.length < 3) return;

        const id = metaParts[0];
        const typeSuffix = metaParts[2];
        const chartKey = `${id}_${typeSuffix}`;

        if (typeSuffix === "attr") {
          const clsName = `Attribute-left-panel-div-Attribute-${id}Attribute`;
          const targetDiv = document.getElementById(clsName);
          if (!targetDiv) return;

          // Only skip if it's the same chart AND already highlighted
          const parentLi = targetDiv.closest("li");
          if (chartKey === lastChartKey && parentLi?.classList.contains("active")) {
            return;
          }
          
          lastChartKey = chartKey;

          // Remove active except Dataset panel
          document.querySelectorAll("li.active").forEach(li => {
            if (!li.querySelector("#Dataset-left-panel")) {
              li.classList.remove("active");
            }
          });

          // Find and highlight parent LI
          if (parentLi) {
            parentLi.classList.add("active");
            
            // Scroll into view if needed
            const leftPanel = parentLi.closest("ul, .left-panel");
            if (leftPanel) {
              // Use getBoundingClientRect for zoom-aware calculations
              const liRect = parentLi.getBoundingClientRect();
              const panelRect = leftPanel.getBoundingClientRect();
              
              // Check if element is outside the visible area
              const isAboveView = liRect.top < panelRect.top;
              const isBelowView = liRect.bottom > panelRect.bottom;

              if (isAboveView || isBelowView) {
                parentLi.scrollIntoView({ behavior: "smooth", block: "nearest" });
              }
            }
            // Call setAttribute with the component context
            self.setAttribute(mostVisibleChartId);
          }
        }
        else {

        const clsName = `Dataset-left-panel-div-Dataset-${id}Dataset`;
        const targetDiv = document.getElementById(clsName);
        if (targetDiv) {
          // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
          const allLis = document.querySelectorAll('li.active');
          allLis.forEach(li => {
            const datasetPanelDiv = li.querySelector('#Dataset-left-panel');
            if (!datasetPanelDiv) {
              li.classList.remove('active');
            }
          });

          // Traverse up to find the parent li element of the current target div
          let parentLi = targetDiv.parentNode;
          while (parentLi && parentLi.tagName !== 'LI') {
            parentLi = parentLi.parentNode;
          }

          // Add the 'active' class to the parent li of the current target div
          if (parentLi) {
            parentLi.classList.add('active');
          }
        }

        }
      }, 40);
    },
    true // capture phase
  );
})();





    //this.initializeObserver();
    //document.addEventListener("click", this.handleClickOutside);
    window.addEventListener('resize', this.handleChartGridResize())
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener('keydown', this.handleEscKey);
    this.receivePushData()
    let storedWatchlist = JSON.parse(sessionStorage.getItem("selectedWatchlist"));
    if (storedWatchlist && storedWatchlist.watchListName !== "All" && this.props.data === undefined) {
      this.setState(
        {
          selectedWatchlistName: storedWatchlist.watchListName,
          selectedWatchListId: storedWatchlist.watchListId,
          environment_id:storedWatchlist.selectedEnvId
        },
        () => {
        
          this.getMetricsValueResponse(undefined, this.state.selectedWatchListId);
        }
      );
    }

    this.initalAPILoad()


    $('body').click((event) => {
      $('.rt-dropdown_backdrop').removeClass("show");
      const container = $('.qd-toolbar-col');
      //  Check if the clicked element is not the container or a descendant of it.
      if (!container.is(event.target) && container.has(event.target).length === 0) {
        this.setState({ selectedTopMenu: event });
      }
      const watchlistcontainer = $('.metric-list-dropdown');
      // Check if the clicked element is not the watchlistcontainer or a descendant of it.
      if (!watchlistcontainer.is(event.target) && watchlistcontainer.has(event.target).length === 0) {
        //this.setState({ selectedTopMenu: "" });
        $(".metric-list-dropdown").removeClass("open")
      }
    });
  }

 async componentDidUpdate(prevProps, prevState) {
     if (prevProps.selectedDatasetId !== this.props.selectedDatasetId ||prevProps.selectedEnvId !== this.props.selectedEnvId) {
        await this.initalAPILoad();

    if (prevProps.selectedEnvId !== this.props.selectedEnvId) {

      //  let metaDataResponse = await this.getAllMetaDataResponse();

      // if (!metaDataResponse || metaDataResponse.code !== 200) {
      //   this.setState({
      //     errorOccurred: true,
      //     isLoadingMetaData: false,
      //   });
      // } else {
      //   this.setState({
      //     metaDataResponse: metaDataResponse.data,
      //     inputData: metaDataResponse.data,
      //     isLoadingMetaData: false,
      //   });
      // }

      if (prevState.metricsValueResponse !== this.state.metricsValueResponse) {
        this.setState({metricsValueResponse:this.state.metricsValueResponse})
        

      }
      sessionStorage.removeItem("selectedWatchlist");
      this.setState({ selectedWatchlistName: "All",integrationRequest:this.state.integrationRequest,selectedWatchListId:"" ,isCheckedBoxPartition:false,startDate:"",endDate:"",metaDataResponse: [],inputData:null});

      // const { integrationRequest } = this.state;
      // if (integrationRequest?.length > 0) {
      //   const firstIntegrationId = integrationRequest[0].value;
      //   // this.getMetricsValueResponse(firstIntegrationId, undefined,this.state.isCheckedBoxPartition);
      // }

    }
    }
    else if (prevState.selectedMeticsName !== this.state.selectedMeticsName) {
      return true
    }
    if(this.state.selectedChart === "renderBarGrid"){
      this.setState({selectedChart: prevState.selectedChart})
    }
  }

  initializeObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const chartId = entry.target.dataset.chartId;
            this.setState((prevState) => ({
              visibleCharts: { ...prevState.visibleCharts, [chartId]: true },
            }));
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    Object.values(this.chartRefs).forEach((ref) => {
      if (ref.current) this.observer.observe(ref.current);
    });
  };

  swDropdownOpen(event) {
    this.setState({ selectedTopMenu: event });
    $('.rt-dropdown_backdrop').addClass("show");
    this.MenuScrollFix(event);
  }

  MenuScrollFix(event) {
    let divposition = window.scrollX + document.querySelector('#' + event).getBoundingClientRect().left
    let divpositionright = window.scrollX + document.querySelector('#' + event).getBoundingClientRect().right
    if ($(window).width() < divposition + $('#' + event + " > div:nth-child(2)").width()) {
      $('#' + event + " > div:nth-child(2)").css("right", function () {
        return $(window).width() - divpositionright;
      });
    } else {
      $('#' + event + " > div:nth-child(2)").css("left", function () {
        return $(this).parent().position().left
      });
    }
  }

  DropdownOpen(event) {
    $('.metric-list-dropdown').toggleClass("open");
    $('.rt-dropdown_backdrop').addClass("show");
  }

  handleDeleteModalOpen() {
    this.setState({ showDeletePopup: true });
  }

  // Close the delete modal
  handleCloseDeletePopup() {
    this.setState({ showDeletePopup: false, confirmDeleteName: "" });
  }

  handleDeleteWatchlist = async (selectedWatchlistName) => {
  let { confirmDeleteName, selectedIntegrationId } = this.state;
  // const { watch_list_name: selectedWatchlistName, watch_list_id: selectedWatchlistId } = selectedWatchlist;

  // Validate name confirmation
    if (confirmDeleteName.trim() !== selectedWatchlistName.trim()) {
      this.setState({ errors: "Name does not match." });
      return;
    }

    try {
    // Delete API call using watchlist ID
      const deleteWatchListResponse = await this.deleteWatchListResponse();

    if (deleteWatchListResponse?.code !== 200) {
      throw new Error(deleteWatchListResponse?.message || "Failed to delete watchlist.");
    }

    this.showToast("success", deleteWatchListResponse.message);
    sessionStorage.removeItem("selectedWatchlist");

    // Fetch the updated watchlists
    const watchListResponse = await this.getWatchListResponse();

      if (watchListResponse?.code === 200) {
      const updatedWatchlist = watchListResponse.result.watch_list || [];
      const watchListMapping = await this.extractMultipleWatchlistIds(watchListResponse);

      let newSelectedWatchList = { watchListName: "All", watchListId: null };

        if (updatedWatchlist.length > 0) {
        // If any watchlists remain, pick the first
        newSelectedWatchList = {
          watchListName: updatedWatchlist[0].watch_list_name,
          watchListId: updatedWatchlist[0].watch_list_id
        };
      }

      // Update session storage
        sessionStorage.setItem("watchListInformation", JSON.stringify(updatedWatchlist));
        sessionStorage.setItem("selectedWatchlist", JSON.stringify(newSelectedWatchList));

      // Update state
        this.setState({
          watchListInformation: updatedWatchlist,
        watchListMapping: watchListMapping,
        selectedWatchlistName: newSelectedWatchList.watchListName,
        selectedWatchListId: newSelectedWatchList.watchListId
      });

      // Load metrics: Watchlist ID first, Integration ID only if no watchlists left
      const { watchListId } = newSelectedWatchList;
      this.getMetricsValueResponse(
        watchListId ? undefined : selectedIntegrationId,
        watchListId || undefined
      );

      } else if (watchListResponse?.code === 401) {
     let id = this.state.integrationRequest[0].value
      this.getMetricsValueResponse(id, undefined);

      // Unauthorized: reset everything
      sessionStorage.removeItem("selectedWatchlist");
        this.setState({
        watchListInformation: [],
        selectedWatchlistName: "All",
        selectedWatchListId: null
          });
    } else {
        throw new Error(watchListResponse?.message || "Failed to fetch updated watchlist.");
      }

    } catch (error) {
      console.error("Error during delete or fetching watchlist:", error);
      this.showToast("error", error.message || "An error occurred while deleting the watchlist.");

    // Reset to All on failure
      this.setState({
        watchListInformation: [],
        selectedWatchlistName: "All",
      selectedWatchListId: null
      });

      sessionStorage.removeItem("watchListInformation");
      sessionStorage.setItem("selectedWatchlist", JSON.stringify({ watchListName: "All", watchListId: null }));
      
     

    // this.getMetricsValueResponse(selectedIntegrationId, undefined);

    } finally {
    // Cleanup state
      this.setState({
        showDeletePopup: false,
        confirmDeleteName: "",
      errors: null
      });
    }
  };




  // Handle watchlist change
  handleWatchlistChange = (watchlistName, watch_list_id, callback) => {
    // Update the state with the selected watchlist details
    this.setState(
      {
        selectedWatchlistName: watchlistName,
        selectedWatchListId: watch_list_id,
        blurLoader : true,
        isCheckedBoxPartition:this.state.isCheckedBoxPartition
      },
      async () => {
        sessionStorage.setItem("selectedWatchlist", JSON.stringify({
          watchListName: watchlistName,
          watchListId: watch_list_id,
          selectedEnvId:this.props.selectedEnvId
        }));

        // After state update, fetch metrics
        try {
          const integrationId = watchlistName?.toLowerCase() === "all"
            ? this.state.integrationRequest[0].value
            : undefined;

          let metricsValueResponse = await this.getMetricsValueResponse(integrationId, watch_list_id,this.state.isCheckedBoxPartition);

          if (!metricsValueResponse) {
            this.setState({ errorOccurred: true });
            return;
          }

          if (metricsValueResponse.code === 200) {
             this.renderchartView("",
        this.state.selectedIntegrationName,
        this.state.selectedDatasetName,
        "",
        "",
        this.state.selectedIntegrationId,
        this.state.selectedDatasetId,
        this.state.selectedDatasetAttrId,
        "",
        this.state.selectedLeftPanelType,
        null)
            this.setState({
              metricsValueResponse: metricsValueResponse.data,
              errorOccurred: false,
              blurLoader :false
            });
          } else {
            this.setState({ errorOccurred: true,blurLoader :false });
          }
        } catch (error) {
          console.error("Error fetching metrics value response:", error);
          this.setState({ errorOccurred: true,blurLoader :false });
        } finally {
        this.setState({ blurLoader: false });
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
      }
    );
  };

  //handle create watchlist and edit watchlist
handleWishListShow = async (isEditing = false, selectedWatchlistName) => {
  try {
    this.setState({
      isLoadingMetaData: true,
      errorOccurred: false,
      watchListOpen: true,
      watchListName: "",
      watchListNameError: "",
    });

    if (
      !this.state.metaDataResponse ||
      (Array.isArray(this.state.metaDataResponse) &&
        this.state.metaDataResponse.length === 0)
    ) {
      let metaDataResponse = await this.getAllMetaDataResponse();

      if (!metaDataResponse || metaDataResponse.code !== 200) {
        this.setState({
          errorOccurred: true,
          isLoadingMetaData: false,
        });
      } else {
        this.setState({
          metaDataResponse: metaDataResponse.data,
          inputData: metaDataResponse.data,
          isLoadingMetaData: false,
        });
      }
    } else {
      this.setState({
        isLoadingMetaData: false,
      });
    }

    let checkedStates = {};
    let childIds = []; 
    if (isEditing) {
      let EditWatchlistResponse = await this.getEditWatchlistResponse();
      const watchlistData = EditWatchlistResponse.data[0].watch_list_data;

      // Handle attributes
      Object.keys(watchlistData.attributes).forEach((key) => {
        watchlistData.attributes[key].forEach((attribute) => {
          checkedStates[`Attribute-${attribute.value}`] = {
            checked: true,
            type: "Attribute",
          };
        });
      });

      // Handle datasets
      Object.keys(watchlistData.datasets).forEach((key) => {
        watchlistData.datasets[key].forEach((dataset) => {
          checkedStates[`Dataset-${dataset.value}`] = {
            checked: true,
            type: "Dataset",
          };

          //  PARTITION DATASET
      if (dataset.is_child_dataset) {
        const parentId = dataset.parent_data_set_id;
        const childId = dataset.value;

            // store partition dataset id
            if (!childIds.includes(childId)) {
              childIds.push(childId);
            }

        checkedStates[`Partition-${childId}`] = {
          checked: true,
          type: "Partition",
        };

        // Add Partition Group
        checkedStates[`PartitionGroup-partition-group-${parentId}`] = {
          checked: true,
          type: "Partition Group",
        };

        // Check if attributes exist for this partition dataset
        const partitionAttrs = watchlistData.attributes[childId];
        if (partitionAttrs && Array.isArray(partitionAttrs)) {
          partitionAttrs.forEach((attr) => {
            checkedStates[`PartitionAttribute-${attr.value}`] = {
              checked: true,
              type: "Partition Attribute",
            };
          });
        }
      }
        });
      });

      // Handle integrations / datasources
      watchlistData.integrations.forEach((integration) => {
        checkedStates[`Datasource-${integration.value}`] = {
          checked: integration.is_checked,
          type: "Datasource",
        };
      });
    }

    this.setState({
      watchListOpen: true,
      editWatchlist: isEditing,
      watchListName: isEditing ? selectedWatchlistName : "",
      watchListNameError: "",
      checkedStates,
      partitionDatasetIds: childIds, 
    });
  } catch (error) {
    console.error("Error loading watchlist for edit:", error);
  }
};

  // save watchist
  handleWishListClose = () => {
    this.setState({
      watchListOpen: !this.state.watchListOpen,
      saveWatchListSearchText: "",
      watchListNameError: "",
    })
  }
  //watchlist name change
handleWatchlistNameChange = (event) => {
  const watchListName = event.target.value;
  let watchListNameError = "";
  if (!watchListName.trim()) {
    watchListNameError = "Watchlist name is required.";
  }
  else if (watchListName.length > 25) {
    watchListNameError = "Watchlist name cannot exceed 25 characters.";
  } 
  else {
    const validPattern = /^[a-zA-Z0-9](?!.*[ _-]{2,})[a-zA-Z0-9 _-]*[a-zA-Z0-9]$/;
    
    if (!validPattern.test(watchListName)) {
      watchListNameError = "Special characters are not allowed.";
    }
  }

  this.setState({ watchListName, watchListNameError });
};

// Trigger validation when user clicks "Save" without entering a name
  handleSaveClick = () => {
    const watchListName = (this.state.watchListName || "").trim();

    if (!watchListName) {
      this.setState({ watchListNameError: "Watchlist name is required." });
      return;
    }

    if (watchListName.toLowerCase() === "all") {
      this.setState({ watchListNameError: "Watchlist name cannot be 'All'." });
      return;
    }

    if (this.state.watchListNameError) {
      return;
    }

    this.saveWatchListResponse(this.state.metaDataResponse);
  };


  //watchlist search
  handleWatchlistSearch = (e) => {
    const searchText = e.target.value;

    this.setState({ saveWatchListSearchText: searchText });
  }

handleSaveWatchlistCheckboxChange = (event, type, uniqueId, childNodes) => {

  const normalizeKey = (type, id) => {
    const cleanedType = (type || "")
      .replace(/\s+/g, "")
      .replace(/partitiongroup/i, "PartitionGroup")
      .replace(/partitionattribute/i, "PartitionAttribute")
      .replace(/partition/i, "Partition");
    return `${cleanedType}-${id}`;
  };

  const nodeKey = normalizeKey(type, uniqueId);

  this.setState((prevState) => {
    const updatedCheckedStates = { ...prevState.checkedStates };
    const currentChecked = updatedCheckedStates[nodeKey]?.checked || false;
    const newChecked = typeof event?.target?.checked === "boolean" ? event.target.checked : !currentChecked;
// Helper: collect all leaf-level checkable keys from children recursively
    const collectCheckableKeys = (nodes) => {
      let result = [];
      let nodeArr = nodes;
      if (nodeArr && !Array.isArray(nodeArr)) nodeArr = Object.values(nodeArr);
      if (!Array.isArray(nodeArr)) return result;
      nodeArr.forEach((node) => {
        if (!node?.type || !node?.id) return;
        const nt = (node.type || "").replace(/\s/g, "");
        const key = `${nt}-${node.id}`;
        if (["Attribute", "Partition", "PartitionAttribute", "Dataset"].includes(nt)) {
          result.push(key);
        }
      let childArr = node.childNodes;
        if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
        if (childArr && childArr.length > 0) {
          result = result.concat(collectCheckableKeys(childArr));
        }
      });
      return result;
    };

  // Helper: collect ALL descendant keys (including groups) for unchecking
    const collectAllDescendantKeys = (nodes) => {
      let result = [];
      let nodeArr = nodes;
      if (nodeArr && !Array.isArray(nodeArr)) nodeArr = Object.values(nodeArr);
      if (!Array.isArray(nodeArr)) return result;
      nodeArr.forEach((node) => {
        if (!node?.type || !node?.id) return;
        const nt = (node.type || "").replace(/\s/g, "");
        const key = `${nt}-${node.id}`;
        result.push(key);
        let childArr = node.childNodes;
        if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
        if (childArr && childArr.length > 0) {
          result = result.concat(collectAllDescendantKeys(childArr));
        }
      });
      return result;
    };

   // Check if parent is currently in indeterminate state (some but not all children checked)
    const checkableKeys = collectCheckableKeys(childNodes || []);
    const checkedCount = checkableKeys.filter(
      (key) => updatedCheckedStates[key] && updatedCheckedStates[key].checked
    ).length;
    const isCurrentlyIndeterminate = checkedCount > 0 && checkedCount < checkableKeys.length;

    // RULE: If parent is in indeterminate state and user clicks it => uncheck ALL nested children
    // Note: clicking an indeterminate checkbox makes browser send checked=true,
    // so we only check isCurrentlyIndeterminate regardless of newChecked value
    if (isCurrentlyIndeterminate) {
      // Uncheck all descendants
      const allDescendantKeys = collectAllDescendantKeys(childNodes || []);
      allDescendantKeys.forEach((key) => {
        delete updatedCheckedStates[key];
      });
      // Also uncheck this node itself
      delete updatedCheckedStates[nodeKey];
    }
 // RULE: If Datasource is checked directly, only check the Datasource and its
    // immediate Dataset children, NOT deeper nested attributes/partitions
    else if (type === "Datasource" && newChecked) {
      updatedCheckedStates[nodeKey] = { checked: newChecked, type };
      // Only check immediate Dataset children (shallow, no cascade)
      let dsChildren = childNodes || [];
      if (dsChildren && !Array.isArray(dsChildren)) dsChildren = Object.values(dsChildren);
      if (Array.isArray(dsChildren)) {
        dsChildren.forEach((node) => {
          if (!node?.type || !node?.id) return;
          const nt = (node.type || "").replace(/\s/g, "");
          if (nt === "Dataset") {
            const childKey = normalizeKey(node.type, node.id);
            updatedCheckedStates[childKey] = { checked: true, type: node.type };
          }
        });
      }
    }
    // RULE: If Datasource is unchecked, also uncheck all its descendants
    else if (type === "Datasource" && !newChecked) {
      delete updatedCheckedStates[nodeKey];
      const allDescendantKeys = collectAllDescendantKeys(childNodes || []);
      allDescendantKeys.forEach((key) => {
        delete updatedCheckedStates[key];
      });
    }
    // RULE: If Dataset is checked directly, only check the Dataset itself, NOT its children
    else if (type === "Dataset" && newChecked) {
      updatedCheckedStates[nodeKey] = { checked: newChecked, type };
      // Do NOT cascade to children — Dataset alone is checked
    }
    // RULE: If Dataset is unchecked, also uncheck all its children
    else if (type === "Dataset" && !newChecked) {
      delete updatedCheckedStates[nodeKey];
      // Also uncheck all children
      const allDescendantKeys = collectAllDescendantKeys(childNodes || []);
      allDescendantKeys.forEach((key) => {
        delete updatedCheckedStates[key];
      });
    }
    else {
      // Toggle current node
      updatedCheckedStates[nodeKey] = { checked: newChecked, type };

      // Recursive child toggle for non-Dataset types
      const updateChildNodes = (nodes) => {
        let nodeArr = nodes;
        if (nodeArr && !Array.isArray(nodeArr)) nodeArr = Object.values(nodeArr);
        if (!Array.isArray(nodeArr)) return;
        nodeArr.forEach((node) => {
          // If current node is "Partition Group", allow its "Partition" children to toggle
          if (type.toLowerCase() === "partition group" || type.toLowerCase() === "partition") {
            const childKey = normalizeKey(node.type, node.id);
            updatedCheckedStates[childKey] = {
              checked: newChecked,
              type: node.type,
            };
            let childArr = node.childNodes;
            if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
            if (Array.isArray(childArr) && childArr.length > 0) {
              updateChildNodes(childArr);
            }
          }
          // If current node is "Attribute Group", allow its "Attribute" children to toggle
          else if (type.toLowerCase() === "attribute group") {
            const childKey = normalizeKey(node.type, node.id);
            updatedCheckedStates[childKey] = {
              checked: newChecked,
              type: node.type,
            };
            let childArr = node.childNodes;
            if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
            if (Array.isArray(childArr) && childArr.length > 0) {
              updateChildNodes(childArr);
            }
          } else {
            // For other node types, skip partition-level nodes
            if (node.type?.toLowerCase().includes("partition")) return;

            const childKey = normalizeKey(node.type, node.id);
            updatedCheckedStates[childKey] = {
              checked: newChecked,
              type: node.type,
            };

            let childArr = node.childNodes;
            if (childArr && !Array.isArray(childArr)) childArr = Object.values(childArr);
            if (Array.isArray(childArr) && childArr.length > 0) {
              updateChildNodes(childArr);
            }
          }
        });
      };

      if (Array.isArray(childNodes) && childNodes.length > 0) {
        updateChildNodes(childNodes);
      }
    }

    // Clean up: remove all false checked states
    Object.keys(updatedCheckedStates).forEach((key) => {
      if (updatedCheckedStates[key]?.checked === false) {
        delete updatedCheckedStates[key];
      }
    });


     // Clean up: remove dataset if partition exists with same ID
    Object.keys(updatedCheckedStates).forEach((key) => {
      if (key.startsWith("Partition-")) {
        const id = key.split("-")[1];
        const datasetKey = `Dataset-${id}`;
        if (updatedCheckedStates[datasetKey]) {
          delete updatedCheckedStates[datasetKey];
        }
      }
    });
    (prevState.partitionDatasetIds || []).forEach((partitionId) => {
      const datasetKey = `Dataset-${partitionId}`;
      if (updatedCheckedStates[datasetKey]) {
        delete updatedCheckedStates[datasetKey];
      }
    });
    
    return { checkedStates: updatedCheckedStates };
  });
};



  handleFixedSizeGridScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (scrollTop + clientHeight >= scrollHeight - 50) {  // && !this.state.isLoading
      //this.fetchData();
      // alert(1)
    }
  };


  getChartDataRequestParams = (attibuteList) => {
    return {
      "tab_type": 1,
      "tenant_id": this.props.teamId,
      "env_id": this.props.selectedEnvId,
      "start_date": this.state.startDate !== "" ? this.state.startDate : null,
      "end_date": this.state.endDate !== "" ? this.state.endDate : null,
      "integration_id": this.state.selectedIntegrationId,
      "data_set_id": this.state.selectedDatasetId,
      "meta_data_id": attibuteList,
      "menu_type": "monitor",
      "browser_tab_id": this.props.browserTabId,
      "session_id": this.props.browserSessionId,
      "user_id": this.props.userId,
      selectedMeticsName: '',
      type: "Attribute",
      ids_type: "dataset"

      // page: page
    }
  }

  /** Scroll to the top of the list */
  scrollToTop = () => {
    if (this.listRef.current) {
      this.listRef.current.scrollToItem(0, "start");
    }
  };

  /** Scroll to a specific chart ID */
  scrollToChart = (chartId) => {
    const index = this.state.chartIds.indexOf(chartId);
    if (index !== -1 && this.listRef.current) {
      const rowIndex = Math.floor(index / 2);
      this.listRef.current.scrollToItem(rowIndex, "start");
    }
  };

    handleItemsRendered = ({ visibleStartIndex, visibleStopIndex }) => {
    
   const visibleCharts = new Set();
    const { chartData, incidentchartData, isCheckedIncidents } = this.state;

    let chartDetails;
    let chartIds = null;
    if (typeof chartData === 'object' && chartData !== null && incidentchartData !== null) {
      if (isCheckedIncidents) {
        chartDetails = incidentchartData
      } else {
        chartDetails = chartData;
      }

      chartIds = Object.keys(chartDetails).filter((data) => !data.startsWith("dummy"));
      let metaDataId;
      if (chartIds.length === 1) {
        let metaParts = chartIds[0].split("_");
        let id = String(metaParts[0]);   
        let typeSuffix = metaParts[2];       
        if (typeSuffix === "attr") {
          metaDataId = `${id}_attr`;
        } 
        else {
          metaDataId = `${id}_dt`;
        }
        if(this.state.bottomPanelData[metaDataId] !== undefined){
            this.setState({ currentBottomPanelData: this.state.bottomPanelData[metaDataId] })
            metaDataId = chartIds[0].split("_")
            let type = metaDataId[metaDataId.length - 1]; 
            if(type === "dt"){
                metaDataId = chartIds[0].split("_")
                metaDataId = `${String(metaDataId[0])}_dt`
                this.setState({dataType: "Dataset", currentBottomPanelData: this.state.bottomPanelData[metaDataId]})
            }
            else if(type === "attr"){
            
                let attributeId = Number(metaDataId[0]);  
                let datasetValue = this.state.selectedDatasetId;
                let attributesList = this.state.metricsValueResponse?.attributes?.[datasetValue] || [];
                let finalData = attributesList.find(item => item.value === attributeId);             
                let attributeName = finalData?.label || "";

              metaDataId = `${String(metaDataId[0])}_attr`

                this.setState({
                  currentBottomPanelData: this.state.bottomPanelData[metaDataId],
                  dataType: "Attribute",
                  selectedDatasetAttrName: attributeName
                });
                return
            }
        }
      }

      if (chartIds === undefined || chartIds.length === 0) {
        return null
      }

      if (chartIds !== null && chartIds[visibleStopIndex] !== undefined && chartDetails[chartIds[visibleStopIndex]] !== undefined && chartIds[visibleStopIndex].includes("_attr")) {
        const clsName = `Attribute-left-panel-div-Attribute-${chartDetails[chartIds[visibleStopIndex]].id}Attribute`;        
        
        
        const targetDiv = document.getElementById(clsName);
        if (targetDiv) {
          // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
          const allLis = document.querySelectorAll('li.active');
          allLis.forEach(li => {
            const datasetPanelDiv = li.querySelector('#Dataset-left-panel');
            if (!datasetPanelDiv) {
             // li.classList.remove('active');   // commetted new logic
            }
          });

          // Traverse up to find the parent li element of the current target div
          let parentLi = targetDiv.parentNode;
          while (parentLi && parentLi.tagName !== 'LI') {
            parentLi = parentLi.parentNode;
          }

          // Add the 'active' class to the parent li of the current target div
          if (parentLi) {
           // parentLi.classList.add('active');  //  commetted new logic
          }
        }
          let meta = chartIds[visibleStopIndex].split("_");
          let attributeId = Number(meta[0]);
          // let ds = chartIds[0].split("_");
          // let datasetId = Number(ds[0]);
          // let integrationId = this.state.selectedIntegrationId;

          // let datasetArray = this.state.metricsValueResponse?.datasets?.[integrationId] || [];          
          // let datasetObj = datasetArray.find(d => d.value === this.state.selectedDatasetId);
          // let datasetValue = datasetObj?.value;
          // let attributesList = this.state.metricsValueResponse?.attributes?.[datasetValue] || [];
          // let finalData = attributesList.find(item => item.value === attributeId);
          // let attributeName = finalData?.label || "";
          metaDataId = `${attributeId}_attr`;
                 // Commented new logic 
                // this.setState({
                //   currentBottomPanelData: this.state.bottomPanelData[metaDataId],
                //   dataType: "Attribute",
                //   selectedDatasetAttrName: attributeName,
                //   preSelectedAttribute: { "label": attributeName, "value": attributeId },
                // });
      }
      else if (chartIds !== null && chartIds[visibleStopIndex] !== undefined && chartDetails[chartIds[visibleStopIndex]] !== undefined) {
        const clsName = `Dataset-left-panel-div-Dataset-${chartDetails[chartIds[visibleStopIndex]].id}Dataset`;
        const targetDiv = document.getElementById(clsName);
        if (targetDiv) {
          // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
          const allLis = document.querySelectorAll('li.active');
          allLis.forEach(li => {
            const datasetPanelDiv = li.querySelector('#Dataset-left-panel');
            if (!datasetPanelDiv) {
             // li.classList.remove('active');
            }
          });

          // Traverse up to find the parent li element of the current target div
          let parentLi = targetDiv.parentNode;
          while (parentLi && parentLi.tagName !== 'LI') {
            parentLi = parentLi.parentNode;
          }

          // Add the 'active' class to the parent li of the current target div
          if (parentLi) {
           // parentLi.classList.add('active');
          }
        }

        metaDataId = chartIds[0].split("_")
        metaDataId = `${String(metaDataId[0])}_dt`
        this.setState({dataType: "Dataset", currentBottomPanelData: this.state.bottomPanelData[metaDataId]})
      }

      if(this.state.dataType === "Dataset"){
          this.setState({
                    selectedDatasetAttrName: "",
                    preSelectedDataset : this.state.selectedDatasetName,
                    preSelectedAttribute :null
                  });
      }
      for (let index = visibleStartIndex; index <= visibleStopIndex; index++) {
        const chartIndex1 = index * 2;
        const chartIndex2 = index * 2 + 1;
        if (chartIds[chartIndex1]) {
          visibleCharts.add(chartIds[chartIndex1]);
        }
        if (chartIds[chartIndex2]) {
          visibleCharts.add(chartIds[chartIndex2]);
        }
      }
      this.setState({ visibleCharts });
    }
  };


  Row = ({ index, style }) => {

    // Normalize virtualized row style to avoid occasional 4px overshoot from react-window
    // Create a shallow copy so we don't mutate the incoming object used by react-window
    const itemStyle = { ...style };
    try {
      // If height is numeric, trim a small delta to counter rounding/layout differences
      let h = typeof itemStyle.height === 'number' ? itemStyle.height : parseInt(itemStyle.height, 10);
      if (!Number.isNaN(h) && h > 0) {
        // Subtract 4px only when height is larger than a minimal threshold to avoid negative values
        const adjusted = Math.max(0, Math.round(h) - 6);
        itemStyle.height = adjusted;
        // If top is numeric, nudge top by 2px to keep vertical alignment centered (optional)
        if (typeof itemStyle.top === 'number') {
          itemStyle.top = Math.max(0, Math.round(itemStyle.top) + 4);
        }
      }
    } catch (e) {
      // fallback: leave style unchanged on any error
    }

    // Debugging: uncomment if you need to inspect the adjusted style
    // console.log('original style', style, 'adjusted style', itemStyle);

    let { chartData, isLoadingMore, hasMoreData, incidentchartData, isCheckedIncidents } = this.state;
    // Ensure chartKeys are always filtered for dummy data

    if (typeof chartData === 'object' && chartData !== null && typeof incidentchartData === 'object' && incidentchartData !== null) {
      if (isCheckedIncidents) {
        chartData = incidentchartData
      }
    }

    if (this.state.selectedMeticsName !== "") {
      if(this.state.selectedDatasetAttrId === ""){
        // Filter for dataset-level charts only (exclude attributes)
        chartData = Object.fromEntries(
                Object.entries(chartData)
                  .filter(([key, value]) => value.name === this.state.selectedMeticsName && !key.endsWith("_attr"))
              );
      } else {
        // Filter for specific attribute within dataset
        chartData = Object.fromEntries(
                Object.entries(chartData)
                  .filter(([key, value]) => value.name === this.state.selectedMeticsName && key.includes(this.state.selectedDatasetAttrId))
              );
      }
    }

    // Get all chart keys and filter out dummies
    let allChartKeys = Object.keys(chartData);
    let realChartKeys = allChartKeys.filter((key) => !key.startsWith("dummy"));
    
    // Calculate total charts at dataset level and attribute level
    let datasetLevelCharts = realChartKeys.filter((key) => key.includes("_dt"));
    let attributeLevelCharts = realChartKeys.filter((key) => key.includes("_attr"));
    
    // Group attribute charts by attribute ID (first part before underscore)
    let attributeGroups = {};
    attributeLevelCharts.forEach((key) => {
      let attrId = key.split("_")[0]; // e.g., "60" from "60_23_attr"
      if (!attributeGroups[attrId]) {
        attributeGroups[attrId] = [];
      }
      attributeGroups[attrId].push(key);
    });
    
    // Group dataset charts by dataset ID (first part before underscore)
    let datasetGroups = {};
    datasetLevelCharts.forEach((key) => {
      let datasetId = key.split("_")[0]; // e.g., "7" from "7_17_dt"
      if (!datasetGroups[datasetId]) {
        datasetGroups[datasetId] = [];
      }
      datasetGroups[datasetId].push(key);
    });
    
    // NEW APPROACH: Map row index to actual chart indices
    // Build the mapping on first access or when chartData changes
    const cacheKey = realChartKeys.join(',');
    if (!this._rowToChartMap || this._rowToChartCacheKey !== cacheKey) {
      this._rowToChartCacheKey = cacheKey;
      this._rowToChartMap = [];
      
      let chartIdx = 0;
      while (chartIdx < realChartKeys.length) {
        let metricId1 = realChartKeys[chartIdx];
        let metricId2 = realChartKeys[chartIdx + 1];
        
        if (!metricId1) break;
        
        if (!metricId2) {
          // Last chart - render alone
          this._rowToChartMap.push({ metricId1, metricId2: null });
          break;
        }
        
        let id1 = metricId1.split("_")[0];
        let id2 = metricId2.split("_")[0];
        let type1 = metricId1.split("_")[2]; // "dt" or "attr"
        let type2 = metricId2.split("_")[2]; // "dt" or "attr"
        
        // RULE 1: If both are from the same ID (dataset or attribute), pair them together
        if (id1 === id2) {
          this._rowToChartMap.push({ metricId1, metricId2 });
          chartIdx += 2;
        } 
        // RULE 2: If both are dataset-level charts (_dt), pair them together
        else if (type1 === "dt" && type2 === "dt") {
          this._rowToChartMap.push({ metricId1, metricId2 });
          chartIdx += 2;
        }
        // RULE 3: If current chart is attribute-level (_attr), render it alone (each attribute gets own row)
        else if (type1 === "attr") {
          this._rowToChartMap.push({ metricId1, metricId2: null });
          chartIdx += 1;
        }
        // RULE 4: Otherwise, render current chart alone
        else {
          this._rowToChartMap.push({ metricId1, metricId2: null });
          chartIdx += 1;
        }
      }
    }
    
    // Get chart IDs for this row
    let rowMapping = this._rowToChartMap[index] || { metricId1: null, metricId2: null };
    let metricId1 = rowMapping.metricId1;
    let metricId2 = rowMapping.metricId2;
    
    let chart1 = chartData[metricId1];
    let chart2 = metricId2 ? chartData[metricId2] : null;
    
    let metaDataList;
    let metaData1;

    if (this.state.inputData !== undefined && this.state.inputData !== null && Array.isArray(this.state.inputData.attributes)) {
      metaDataList = this.state.inputData?.attributes??[].filter(
        (data) => data.data_set_id === this.state.selectedDatasetId
      );
      if (chart1 !== undefined && metricId1?.includes("_attr")) {
        metaData1 = metaDataList.find((data) => Number(data.value) === Number(chart1.id));
      } else {
        metaData1 = undefined;
      }
    }

    const totalRows = Math.ceil(realChartKeys.length / 2);

    // Trigger loading more items when approaching the end (3 rows before the end)
    if (index === totalRows - 2 &&this.state.hasMoreData === true) {
      this.loadMoreItems();
    }

    let metaDataId1;
    if (metricId1 !== undefined && metricId1 !== null) {
      metaDataId1 = metricId1.split("_")[0];
    }

    // For title rendering, check if this is the start of a new attribute/dataset group
    // Compare with the first chart of the previous row
    let prevRowMetricId1 = this._rowToChartMap[index - 1]?.metricId1;
    let shouldRenderTitle = 
                            this.state.selectedDatasetAttrId === "" &&
                            metricId1 && 
                            metricId1.includes("_attr") &&  // Only for attribute-level charts
                            (index === 0 || (prevRowMetricId1 && metricId1.split("_")[0] !== prevRowMetricId1.split("_")[0]));

    // Handle 'No Data Found' or initial loading state
    if (Object.keys(chartData).length === 0 
    // && !isLoadingMore
    ) {
      return (
        <div className="qd-rt_chart-widget-row" style={style}>
          <div style={{ flex: 1, boxSizing: "border-box", textAlign: "center", marginTop: "73px" }}>
             No data found
          </div>
        </div>
      );
    }
    if (realChartKeys.length === 0 && isLoadingMore) {
      return (
        <div className="qd-rt_chart-widget-row" style={style}>
          <div style={{ flex: 1, boxSizing: "border-box", textAlign: "center", marginTop: "73px" }}>
            <Load />
          </div>
        </div>
      );
    }

    const numRows = this._rowToChartMap ? this._rowToChartMap.length : 0;
    const isActualChartRow = index < numRows;
    const showLoadingRowIndicator = index === numRows && isLoadingMore && hasMoreData;
    
    // Debug logging - uncomment to troubleshoot
    // if (index <= 5) {
    //   const chart1KeysLength = chart1 ? Object.keys(chart1).length : 0;
    //   const willActuallyRender = isActualChartRow && chart1 !== undefined && chart1KeysLength > 0;
    //   console.log(`Row ${index} [Chart1Keys=${chart1KeysLength}, WillRender=${willActuallyRender}]:`, {
    //     chartIndex1, metricId1, 
    //     hasChart1: !!chart1,
    //     chart1KeysLength,
    //     isActualChartRow,
    //     conditionCheck: {
    //       isActualChartRow,
    //       chart1NotUndefined: chart1 !== undefined,
    //       chart1KeysGtZero: chart1KeysLength > 0,
    //       finalResult: willActuallyRender
    //     }
    //   });
    // }

    // jQuery usage
    $(".w-100 > div:nth-child(1) > div:nth-child(1)").css("height", "");
    return (
      <>
        {isActualChartRow && chart1 !== undefined && Object.keys(chart1).length > 0 && (
          <div
            className="qd-rt_chart-widget-row"
            style={{
              ...itemStyle,
            }}            
            //  style={{ width: '100%', height:
            // dt.length ==4 || dt.length ==3 ? 
            //   ($(".qd-rt_main-content").height()-(40+$(".qd-toolbar").height()+11)/2)+"px" :
            //   $(".qd-rt_main-content").height()-(40+$(".qd-toolbar").height()+11)+"px"
            //  }}

            // style={
            //     dt.length ==4 || dt.length ==3 ?
            //     {width: '100%', height: ($(".qd-rt_main-content").height()-(40+$(".qd-toolbar").height()+11)/2)+"px"}
            //     :
            //     {...style}
          >
            {shouldRenderTitle && metaData1 && realChartKeys.length > 1 && (
              <div className="qd-rt_chart-widget-title" style={{ width: '100%' }}>
                <hr />
                <div className="qd-rt_cw-title-inner">
                  <Breadcrumb className="chart-widget_breadcrumb">
                    <Breadcrumb.Item className="cw_breadcrumb-item">
                      <FontAwesomeIcon icon={faLayerGroup} />
                      {this.state.selectedDatasetName}
                    </Breadcrumb.Item>
                    {   metaDataId1 !== undefined 
                      && 
                        <Breadcrumb.Item className="cw_breadcrumb-item">
                          <FontAwesomeIcon icon={faTag} />
                          {normalizeAttributeName(metaData1.label || metaDataId1)}
                        </Breadcrumb.Item>
                    }
                  
                  </Breadcrumb>
                </div>
              </div>
            )}

            {/* Render chart1 if it exists (metricId1 is already from filtered realChartKeys) */}
            {metricId1 && chart1 && Object.keys(chart1).length > 0 &&
              this.renderChartCell(metricId1, chart1, index, 0)
            }

            {/* Render chart2 only if it exists, or render empty space if metricId2 was nulled by boundary check */}
            {metricId2 && chart2 && Object.keys(chart2).length > 0 ? (
              this.renderChartCell(metricId2, chart2, index, 1)
            ) : ""}
          </div>
        )}
        {showLoadingRowIndicator && (
          <div className="qd-rt_chart-widget-row has-spinner-loader" style={{ ...itemStyle, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: '#f0f0f0' }}>
            {/* <p>Loading more charts...</p> You can replace this with an actual spinner component */}
            <Load />
          </div>
        )}
      </>
    );
  };

  async loadMoreItems() {
    const { fullAttributeList, saveList } = this.state;

    // Prevent re-triggering if already loading
    if (this.state.isLoadingMore) {
      return;
    }

    // Determine the next batch of attribute IDs to fetch
    let getList = [];
    let newSaveList = [...saveList];
    let newStartIndex = this.state.startIndex;
    let newEndIndex = this.state.endIndex;

    // This block is directly from your provided loadMoreData
    if (newSaveList.length < fullAttributeList.length) {
      newStartIndex = this.state.startIndex;
      newEndIndex = newStartIndex + 5; // Assuming your old 'endIndex' was 2 steps ahead of 'startIndex'
      getList = fullAttributeList.slice(newStartIndex, newEndIndex);
      
      newSaveList = newSaveList.concat(getList);

      // Update the state variables used for slicing for the next call
      this.setState({
        startIndex: newEndIndex, // Next startIndex is current endIndex
        endIndex: newEndIndex + 5 // Next endIndex for next iteration
      });
    }

    if (getList.length === 0) {
      this.setState({ hasMoreData: false });
      return;
    }

    this.setState({ isLoadingMore: true });
    // let selectedIds = newSaveList
    try {
      const requestParams = this.getChartDataRequestParams(getList);
      requestParams["selected_ids"] = [this.state.selectedDatasetId]
      const isChild = this.state.selectedDatasetName?.includes("$");
       if (this.state.isCheckedBoxPartition && isChild) {
          requestParams["is_child"] = true;
        }
      const chartDataResponse = await this.getChartDataResponse(requestParams);
      if (chartDataResponse && chartDataResponse.code === 200) {
        let newFetchedCharts = chartDataResponse.response.chart_details || {};
        let newBPData = chartDataResponse.response.bottom_panel_data || {};

        // Merge new charts with existing chartData
        const updatedChartData = {
          ...this.state.chartData,
          ...newFetchedCharts,
        };

        // If in incident mode, update incidentchartData with new incidents from loaded data
        let updatedIncidentChartData = { ...this.state.incidentchartData };
        if (this.state.isCheckedIncidents) {
          // Filter new fetched charts for incidents
          for (const key in newFetchedCharts) {
            const details = newFetchedCharts[key];
            if (
              details.metric_threshold_error_status !== undefined &&
              details.metric_threshold_error_status.includes(true)
            ) {
              updatedIncidentChartData[key] = details;
            }
          }
        }

        this.setState(prevState => ({
          chartData: updatedChartData,
          bottomPanelData: {
            ...prevState.bottomPanelData,
            ...newBPData,
          },
          chartKeys: Object.keys(updatedChartData),
          incidentchartData: updatedIncidentChartData, // Update incident data as well
          saveList: newSaveList, // Update saveList
          // Determine hasMoreData based on whether we fetched all available attributes
          hasMoreData: newSaveList.length < fullAttributeList.length,
          isLoadingMore: false,
        }));
      } else {
        console.error("Error fetching more chart data:", chartDataResponse);
        this.setState({ isLoadingMore: false, hasMoreData: false });
      }
    } catch (error) {
      console.error("Error in loadMoreItems (API call):", error);
      this.setState({ isLoadingMore: false, hasMoreData: false });
    }
  }

  renderRow = ({ index, style }) => {
    const { chartData } = this.state;
    const chartKeys = Object.keys(chartData);

    let visibleChart = this.state.visibleCharts


    // if (typeof chartData === 'object' && chartData !== null && incidentchartData !== null) {
    //   if (isCheckedIncidents) {
    //     chartDetails = incidentchartData
    //   } else {
    //     chartDetails = chartData;
    //   }
    //   if (this.state.selectedMeticsName !== "") {
    //     chartDetails = Object.fromEntries(
    //       Object.entries(chartDetails)
    //         .filter(([key, value]) => value.name === this.state.selectedMeticsName)
    //     );
    //   }
    //   chartIds = Object.keys(chartDetails);
    // }



    if (visibleChart !== null && visibleChart !== undefined && visibleChart.length !== 0) {
      // let highLightId = visibleChart[0].startsWith("dummy") ? visibleChart[0] : visibleChart[1]
    }

    const startIndex = index * 2;
    const metricId1 = chartKeys[startIndex];
    const metricId2 = chartKeys[startIndex + 1];
    const chart1 = chartData[metricId1];
    const chart2 = chartData[metricId2];

    let metaDataList;
    let metaData1;

    if (this.state.inputData !== null) {
      metaDataList = this.state.inputData['attributes'].filter(
        (data) => data.data_set_id === this.state.selectedDatasetId
      );

      if (chart1 !== undefined) {
        metaData1 = metaDataList.find((data) => Number(data.value) === Number(chart1.id));
      }
    }

    let chartIds = Object.keys(chartData);
    chartIds = chartIds.filter((data) => !data.startsWith("dummy"))

    // if( index === chartIds.length - 1 && this.state.hasMoreData === true ){
    //   this.loadMoreData();
    // }



    if (metaData1 !== undefined) {
      const clsName = `Attribute-left-panel-div-${metaData1.value}Attribute`;
      const targetDiv = document.getElementById(clsName);
      if (targetDiv) {
        // Remove active class from all li elements EXCEPT the one containing div with id 'Dataset-left-panel'
        const allLis = document.querySelectorAll('li.active');
        allLis.forEach(li => {
          const datasetPanelDiv = li.querySelector('#Dataset-left-panel');
          if (!datasetPanelDiv) {
            li.classList.remove('active');
          }
        });

        // Traverse up to find the parent li element of the current target div
        let parentLi = targetDiv.parentNode;
        while (parentLi && parentLi.tagName !== 'LI') {
          parentLi = parentLi.parentNode;
        }

        // Add the 'active' class to the parent li of the current target div
        if (parentLi) {
          parentLi.classList.add('active');
        }
      }
    }
    let metaDataId1;
    if (metricId1 !== undefined) {
      metaDataId1 = metricId1.split("_")[0];
    }
    const shouldRenderTitle = metricId1 !== undefined && (index === 0 || (metricId1 && chartKeys[startIndex - 1] && metricId1.split("_")[0] !== chartKeys[startIndex - 1].split("_")[0]));

    if ((chartData !== undefined && Object.keys(chartData).length === 0) || (chartKeys.length === 0)) {
      return (
        <div className="qd-rt_chart-widget-row" style={style}>
          <div style={{ flex: 1, boxSizing: "border-box", textAlign: "center", marginTop: "73px" }}>
            No Data Found
          </div>
        </div>
      );
    }
    let rowClass = "qd-rt_chart-widget-row"
    if (index === chartIds.length) {
      rowClass = rowClass + " has-spinner-loader"
    }
    $(".w-100 > div:nth-child(1) > div:nth-child(1)").css("height", "");

    return (
      <>
        {chart1 !== undefined && chart2 !== undefined && Object.keys(chart1).length > 0
          &&
          // ?
          <div
            className={rowClass}
            style={{
              ...style,
            }}
          >

            {shouldRenderTitle && metaData1 && chartIds.length > 1 && (
              <div className="qd-rt_chart-widget-title">
                <hr />
                <div className="qd-rt_cw-title-inner">
                  <Breadcrumb className="chart-widget_breadcrumb">
                    <Breadcrumb.Item className="cw_breadcrumb-item">
                      <FontAwesomeIcon icon={faLayerGroup} />
                      {this.state.selectedDatasetName}
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="cw_breadcrumb-item">
                      <FontAwesomeIcon icon={faTag} />
                      {metaData1.label || metaDataId1}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              </div>
            )}

            {!(metricId1?.startsWith('dummy'))
              &&
              chart1 && Object.keys(chart1).length > 0
              &&
              this.renderChartCell(metricId1, chart1, index, 0)
            }

            {!(metricId2?.startsWith('dummy'))
              &&
              chart2 && Object.keys(chart2).length > 0
              && this.renderChartCell(metricId2, chart2, index, 1)
              // :
            }
          </div>
          // :

          //   index === chartIds.length && chartIds.length > 4
          //     && 
          //     <>
          //     <div
          //       className={rowClass}
          //       style={{
          //         ...style,
          //         position:'relative'
          //       }}
          //     >
          //     <div className="Loader" style={{ height: "100%", width: "100%" }}>
          //       <div style={{ textAlign: "center", lineHeight: "300px" }}>
          //          <div className="d-flex align-items-center justify-content-center p-2 h-100">
          //             <div className="spinner-border text-info" role="status">
          //                 <span className="sr-only">Loading...</span>
          //             </div>
          //        </div>
          //       </div>
          //     </div>
          // </div>
          // </>
        }
      </>
    );
  };

  renderChartCell = (chartId, chartData, rowIndex, colIndex) => {

    if (!chartId) return null;

    if (!this.chartRefs[chartId]) {
      this.chartRefs[chartId] = createRef();
    }

    return (
      <div
        ref={this.chartRefs[chartId]}
        data-chart-id={chartId}
        style={{
          flex: 1,
          // minHeight: "calc(100% - 40px)",
          minHeight: "270px",
          boxSizing: "border-box",
        }}
      >
        {chartId ? (
          <Suspense
            fallback={
              <div className="qd-rt_chart-widget" style={{ height: "100%" }}>
                <Load />
              </div>
            }
          >
            <div className="qd-rt_chart-widget" style={{ height: "100%" }}>
              <ChartComponent
                  key={`${this.state.pushtime}-${chartId}-${this.state.isCheckedIncidents}-${this.state.showChartFullscreen}-${this.state.resizeCounter}-${this.state.selectedMetricsId}`}
                  chartType={this.state.chartTypes[chartId] || this.state.selectedChart}
                  onChartTypeChange={(type) => this.setState({ chartTypes: { ...this.state.chartTypes, [chartId]: type } })}
                  chartIndex={rowIndex}
                  lastProcessedDate={this.state.lastProcessedDate}
                  chartColIndex={colIndex}
                  // chartType={this.state.selectedChart}
                  selectedDatasetName={this.state.selectedDatasetName}
                  selectedDatasetAttrName={this.state.selectedDatasetAttrName}
                  realdata={chartData}
                  dataType={this.state.dataType}
                  data={[
                    { time: "2023-01-01", value: 100 },
                    { time: "2023-01-02", value: 105 },
                    { time: "2023-01-03", value: 110 },
                  ]}
                  theme="light"
                />
            </div>
          </Suspense>
        ) : (
          <div className="qd-rt_chart-widget" style={{ height: "100%" }}>
            <div style={{ textAlign: "center", lineHeight: "300px" }}>
              <Load />
            </div>
          </div>
        )}
      </div>
    );
  };


  /** Force re-render by updating visibleCharts */
  forceChartRerender = () => {
    this.chartRefs = {}
    // visibleCharts: new Set(),
    // this.setState((prevState) => ({
    //   visibleCharts: { ...prevState.visibleCharts }, // Ensure a new object reference
    // }));

    this.setState((prevState) => ({
      visibleCharts: new Set(), // Ensure a new object reference
    }));
  };

  showToast(status, msg) {
    this.setState({
      toastStatus: true,
      toastMsg: msg,
      toastClass: status === "success" ? "toast floating-top-toast toast-success" : "toast floating-top-toast toast-danger",
      toastIcon: status === "success" ? faCheckCircle : faTimes,
      toastHeading: status === "success" ? "Success!" : "Error!"
    });

    // Auto close after 3 seconds
    setTimeout(() => {
      this.setState({ toastStatus: false });
    }, 3000);
  }

  closeToast() {
    this.setState({ toastStatus: false });
  }



  handleCaptureClick = () => {
    if (this.containerRef.current) {
      html2canvas(this.containerRef.current).then((canvas) => {
        // Convert the canvas to a data URL
        const imgData = canvas.toDataURL('image/png');

        // Create a temporary anchor element for downloading
        const link = document.createElement('a');
        link.href = imgData;
        link.download = 'screenshot.png'; // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up
      });
    }
  };



  handleCloseAutoCompleteModal() {
    this.setState({ autocompletemodal: false })
  }

async handleOpenAutoCompleteModal() {
  this.setState({ isLoadingMetaData: true });
      if (!this.state.metaDataResponse || (Array.isArray(this.state.metaDataResponse) && this.state.metaDataResponse.length === 0))   {
    try {
       let metaDataResponse = await this.getAllMetaDataResponse()
     if (metaDataResponse === undefined || metaDataResponse === null) {
          this.setState({ errorOccurred: true });
        } else {
          if (metaDataResponse.code === 200) {
            this.setState({ metaDataResponse: metaDataResponse.data, inputData: metaDataResponse.data,isLoadingMetaData: false});
          }
        }
    } catch (error) {
      this.setState({
        errorOccurred: true,
        isLoadingMetaData: false,
      });
    }
  } else {
    this.setState({
      isLoadingMetaData: false,
    });
  }

    this.setState({ autocompletemodal: true })
  }
  checkbox = (field) => {

    this.setState((prevState) => ({
      [field]: !prevState[field], // Toggle the checkbox state
    }));
  };

  handlePartitionChange = async (e) => {
    const isChecked = e.target.checked;

    this.setState({ loading: true, isCheckedBoxPartition: isChecked,blurLoader:true });

    $(".qd-rt_main-content").addClass("opacity-50");

    try {
      if (this.state.selectedWatchListId) {
        await this.getMetricsValueResponse(undefined, this.state.selectedWatchListId, isChecked);
      } else {
        await this.getMetricsValueResponse(this.state.selectedIntegrationId,undefined,isChecked);
      }    
    } catch (error) {
      console.error("Error during API call in handlePartitionChange:", error);
      this.setState({ errorOccurred: true });
    } finally {
      setTimeout(() => {
        this.setState({ loading: false,blurLoader:false });
        $(".qd-rt_main-content").removeClass("opacity-50");
      }, 100);
    }
  };


  handleSelectPartitionToggle = (isChecked) => {


  this.setState({
    selectPartitionButton: isChecked,
    // checkedStates: updatedCheckedStates
  });
  };

  clearCheckedStates = () => {
    const filteredStates = Object.entries(this.state.checkedStates).reduce((acc, [key, value]) => {
      if (
        value.type !== 'Partition' &&
        value.type !== 'Partition Group' &&
        value.type !== 'Partition Attribute'
      ) {
        acc[key] = value;
      }
      return acc;
    }, {});

    this.setState({ checkedStates: filteredStates });
  };

  render() {
    //incidentPanelState

    const deploymentMonth = moment(WINEDIRECT_REALTIME_DEPLOYMENT_DATE, "YYYY-MM-DD").format("MMM DD");
    const { chartData, incidentchartData, isCheckedIncidents, minDate, maxDate, selectedChart, selectedRange, inputData } = this.state; //visibleCharts,
    const { dateFilterStartDate, dateFilterEndDate, dateFilterShowStartCalendar, dateFilterShowEndCalendar } = this.state;
    // const { hasMoreData } = this.state; //isLoading,
     const isParttioncheck = this.state.metaDataResponse && typeof this.state.metaDataResponse === "object" && Object.keys(this.state.metaDataResponse).length > 0;
     let partitionError=false;
     if(isParttioncheck){
        if(this.state.metaDataResponse.datasets.filter(ds =>  parseInt(ds.value) === parseInt(this.state.selectedDatasetId)  &&  parseInt(ds.value) === parseInt(this.state.selectedDatasetId) && ds.is_child_dataset===true ).length > 0){
            if(this.state.isCheckedBoxPartition===false || this.state.isCheckedBoxPartition===undefined){
               partitionError = true;
            }
        }
      }

    let latest_env = this.state.integration_details;
    let chartDetails;
    let chartIds = "";
    if (typeof chartData === 'object' && chartData !== null && incidentchartData !== null) {
      if (isCheckedIncidents) {
        chartDetails = incidentchartData
      }
      else {
        chartDetails = chartData;
      }
      if (this.state.selectedMeticsName !== "") {
        chartDetails = Object.fromEntries(
          Object.entries(chartDetails)
            .filter(([key, value]) => value.name === this.state.selectedMeticsName)
        );
      }
      chartIds = Object.keys(chartDetails);
      chartIds = chartIds.filter((data) => !data.startsWith("dummy"))
    }

    let latest_env_name;
    if (latest_env && latest_env.length > 0) {
      let sorted_details = latest_env.sort((a, b) => new Date(b.created_time) - new Date(a.created_time));
      let latestEntry = sorted_details[0];
      latest_env_name = latestEntry.env_name;
    }

    let { watchListInformation, selectedWatchlistName } = this.state;
    //let datasourceData = this.props.monitorModule.dqPreview;
    let { watchListName } = this.state;
    let checkedStates = this.state.checkedStates || {};
    
    // Log checked states for debugging
    // if (this.state.watchListOpen) {
    //   console.log("=== Watchlist Validation Debug ===");
    //   console.log("Checked States Keys:", Object.keys(checkedStates));
    //   console.log("Checked States:", checkedStates);
    //   console.log("MetaData Integrations:", this.state.metaDataResponse?.integrations?.length || 0);
    //   console.log("MetaData Datasets:", this.state.metaDataResponse?.datasets?.length || 0);
    // }

    const metaDataResponse = this.state.metaDataResponse || {};
    const selectedDatasetIds = new Set();
    const selectedAttributeIds = new Set();
    const hasObjectEntries = value => value && typeof value === "object" && Object.keys(value).length > 0;
    const hasDqData = hasObjectEntries(this.state.chartData) || hasObjectEntries(this.state.bottomPanelData);
    const shouldShowBlockingLoader = this.state.showLoader === true && !hasDqData;
    const shouldShowBlockingProgress = this.state.inProgress === true && !hasDqData;

    Object.entries(checkedStates).forEach(([key, node]) => {
      if (!node?.checked) return;
      const [, id] = key.split("-");
      if (!id) return;
      if (node.type === "Dataset" || node.type === "Partition") selectedDatasetIds.add(id);
      if (node.type === "Attribute" || node.type === "Partition Attribute") selectedAttributeIds.add(id);
    });

    const isDataSourceSelected = Object.keys(checkedStates).some(
      key => checkedStates[key].type === "Dataset" && checkedStates[key].checked === true
    );

    const attributeToDatasetIdMap = {};
    (metaDataResponse.attributes || []).forEach((attribute) => {
      if (attribute?.value != null && attribute?.data_set_id != null) {
        attributeToDatasetIdMap[String(attribute.value)] = String(attribute.data_set_id);
      }
    });

    const isAttributeHierarchyValid = [...selectedAttributeIds].every((attrId) => {
      const parentDatasetId = attributeToDatasetIdMap[String(attrId)];
      return !parentDatasetId || selectedDatasetIds.has(parentDatasetId);
    });

    const isDatasetHasRequiredAttributeSelected = [...selectedDatasetIds].every((datasetId) => {
      const datasetAttrs = Object.entries(attributeToDatasetIdMap)
        .filter(([, dsId]) => dsId === datasetId)
        .map(([attrId]) => attrId);
      if (datasetAttrs.length === 0) return true;
      return datasetAttrs.some((attrId) => selectedAttributeIds.has(attrId));
    });

    // Check if all selected child datasets have their parent datasets selected
    const isPartitionSelectionValid = (() => {
      // Collect all datasets from the metadata
      let allDatasets = [];
      
      if (Array.isArray(metaDataResponse.datasets)) {
        allDatasets = metaDataResponse.datasets;
      } else if (Array.isArray(metaDataResponse.integrations)) {
        // If datasets are nested under integrations
        metaDataResponse.integrations.forEach(integration => {
          if (Array.isArray(integration.datasets)) {
            allDatasets = allDatasets.concat(integration.datasets);
          }
        });
      }
      
      // If no datasets found, validation passes (nothing to validate)
      if (allDatasets.length === 0) {
        return true;
      }
      
      // Check each partition/child dataset
      for (const dataset of allDatasets) {
        if (dataset.is_child_dataset && dataset.parent_data_set_id) {
          const childDatasetKey = `Partition-${dataset.value}`;
          const parentDatasetKey = `Dataset-${dataset.parent_data_set_id}`;
          
          // If partition is selected but parent is not, validation fails
          if (checkedStates[childDatasetKey]?.checked && !checkedStates[parentDatasetKey]?.checked) {
            console.log(`Partition validation failed: ${childDatasetKey} selected but ${parentDatasetKey} not selected`);
            return false;
          }
        }
      }
      return true;
    })();

    const isWatchListNameValid = watchListName && watchListName.trim().toLowerCase() !== "" && watchListName.trim().toLowerCase() !== "all" && !this.state.watchListNameError;

    const isSaveDisabled = !(isWatchListNameValid && isDataSourceSelected && isPartitionSelectionValid && isAttributeHierarchyValid && isDatasetHasRequiredAttributeSelected);

    let preSelectedDataset = this.state.preSelectedDataset
    let preSelectedDatasource = { "value": this.state.selectedIntegrationId, "label": this.state.selectedIntegrationName }
    let advancdedpreselectedDataset = { "value": this.state.selectedDatasetId, "label": this.state.selectedDatasetName } 
    let advancdedpreselectedEnv  = { "value": this.state.selectedEnvId, "label": this.state.selectedEnvName }


    let preSelectedAttribute = this.state.preSelectedAttribute;
    //  if(this.state.preSelectedAttribute!==null){
    //     preSelectedAttribute = this.state.preSelectedAttribute
    //  }

    let datasourceData = ""
    return (<>
      {
        shouldShowBlockingLoader
        //  && this.state.noData === false 
         ? (
          <div className="portlet w-100 h-100 d-flex align-items-center justify-content-center">
            <div className="portlet-body">
              <Load />
            </div>
          </div>
        ) 
        : shouldShowBlockingProgress
          ? (
            <ProgressStatus
              addOnClass="portlet w-100 h-100 d-flex align-items-center justify-content-center"
              progressStatus={this.state.progressStatus}
            />
          ) 
          : 
          (
            <>
              {this.state.integrationRequest !== undefined && this.state.integrationRequest.length !== 0 &&
                <div id="asideSlider" className="qd-rt_aside" >
                  {/* Menu Aside */}
                  <div className='qd-rt_menu-aside'>
                    <div className="qd-rt_tree-wrap" style={{ height: this.state.expandBottomStatPanel === true ? 'calc(100% - (80% - 100px))' : 'calc(100% - 46px)' }}>
                      <div className="qd-rt_aside-header">
                        <div className="caption p-0">
                          <div className="metric-list-dropdown" onClick={this.DropdownOpen.bind(this, "topmenuduration")}>
                            {!IS_NONE_CHECK.includes(selectedWatchlistName) && selectedWatchlistName && selectedWatchlistName.toString().length >= 15 ? (
                              <RcTooltip
                                placement="top"
                                overlay={renderTooltipSummary(selectedWatchlistName)}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <button className="btn dropdown-toggle">{selectedWatchlistName.substring(0, 15) + "..."}
                                </button>
                              </RcTooltip>
                            ) : (
                              <button className="btn dropdown-toggle">{selectedWatchlistName}</button>
                            )}
                            <div className="dropdown-menu">
                              <div className="dropdown-header">
                                <label>Your Lists</label>
                              </div>
                              <div className={`dropdown-item ${selectedWatchlistName === "All" ? "active" : ""}`} onClick={() => { this.setState({ selectedWatchlistName: "All", selectedWatchlistId: null }); this.handleWatchlistChange("All") }}>All <span className="menu-badge"></span></div>
                              {Array.isArray(watchListInformation) && watchListInformation.slice().sort((a, b) => a.watch_list_name.localeCompare(b.watch_list_name)).map((watchlist) => (
                                <div key={watchlist._id} className={`dropdown-item ${selectedWatchlistName === watchlist.watch_list_name ? "active" : ""}`} onClick={() => {
                                  this.handleWatchlistChange(watchlist.watch_list_name, watchlist.watch_list_id);
                                  this.setState({ selectedWatchListId: watchlist.watch_list_id, selectedWatchlistName: watchlist.watch_list_name });
                                }}>{watchlist.watch_list_name}{" "}
                                  <span className="menu-badge">{watchlist.dataset_count + watchlist.attribute_count}</span>
                                </div>))}
                            </div>
                          </div>
                        </div>
                        <div className="actions">
                          <RcTooltip
                            placement="top"
                            overlay={
                              <span>Create a list</span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                          >
                            <button className="btn action-btn" onClick={() => this.handleWishListShow(false)}>
                              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.5 12.5H6V11.5H11.5V6H12.5V11.5H18V12.5H12.5V18H11.5V12.5Z" fill="#484848" />
                              </svg>
                            </button>
                          </RcTooltip>
                          <Dropdown alignRight className="wishlist-dropdown">
                            <RcTooltip
                              placement="top"
                              overlay={
                                <span>Settings</span>
                              }
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <Dropdown.Toggle variant="" id="dropdown-basic" className="action-btn dropdown-caret-hide">
                                <i>
                                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 18.5385C11.725 18.5385 11.4896 18.4406 11.2938 18.2447C11.0979 18.0489 11 17.8135 11 17.5385C11 17.2635 11.0979 17.0281 11.2938 16.8322C11.4896 16.6364 11.725 16.5385 12 16.5385C12.275 16.5385 12.5104 16.6364 12.7063 16.8322C12.9021 17.0281 13 17.2635 13 17.5385C13 17.8135 12.9021 18.0489 12.7063 18.2447C12.5104 18.4406 12.275 18.5385 12 18.5385ZM12 13C11.725 13 11.4896 12.9021 11.2938 12.7062C11.0979 12.5104 11 12.275 11 12C11 11.725 11.0979 11.4896 11.2938 11.2937C11.4896 11.0979 11.725 11 12 11C12.275 11 12.5104 11.0979 12.7063 11.2937C12.9021 11.4896 13 11.725 13 12C13 12.275 12.9021 12.5104 12.7063 12.7062C12.5104 12.9021 12.275 13 12 13ZM12 7.46149C11.725 7.46149 11.4896 7.36357 11.2938 7.16774C11.0979 6.9719 11 6.73649 11 6.46149C11 6.18649 11.0979 5.95107 11.2938 5.75524C11.4896 5.5594 11.725 5.46149 12 5.46149C12.275 5.46149 12.5104 5.5594 12.7063 5.75524C12.9021 5.95107 13 6.18649 13 6.46149C13 6.73649 12.9021 6.9719 12.7063 7.16774C12.5104 7.36357 12.275 7.46149 12 7.46149Z" fill="#484848" />
                                  </svg>
                                </i>
                              </Dropdown.Toggle>
                            </RcTooltip>
                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => this.handleWishListShow(true, selectedWatchlistName)}
                                disabled={selectedWatchlistName === "All"} >
                                <i>
                                  <svg id="icon_rename" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <rect id="Rectangle_2979" data-name="Rectangle 2979" width="24" height="24" fill="none" />
                                    <g id="Group_5099" data-name="Group 5099" transform="translate(2.302 17.34) rotate(-45)">
                                      <path id="Union_12" data-name="Union 12" d="M19.626,6.162l-16.1-.04A.5.5,0,0,1,3.2,6L.176,3.427a.5.5,0,0,1,0-.763L3.2.117A.5.5,0,0,1,3.524,0l16.1.007A1.721,1.721,0,0,1,21.267,1.8V4.374a1.721,1.721,0,0,1-1.639,1.788Zm0-1a.727.727,0,0,0,.638-.788V1.8a.727.727,0,0,0-.639-.788h-1.2V5.159Zm-2.2-.005V1.007h-1.1V5.154Zm-2.1-.005V3.581H4.937V5.126ZM1.274,3.049,3.709,5.123h.228V1h-.23Zm14.057-.468V1.006L4.937,1V2.581Z" fill="currentColor" />
                                    </g>
                                  </svg>
                                </i>
                                Edit
                              </Dropdown.Item>
                              <Dropdown.Item onClick={this.handleDeleteModalOpen} disabled={selectedWatchlistName === "All"}>
                                <i>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <g id="icon_clear-list" transform="translate(-1951 -3066)">
                                      <g id="Group_5101" data-name="Group 5101" transform="translate(534.081 1515.731)">
                                        <path id="Union_13" data-name="Union 13" d="M-530.43-1496.732a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h6.605a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5Zm-3.15-1.565a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h11.737a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5Zm7.212-2.6a.5.5,0,0,1-.354-.146l-4.739-4.739a.5.5,0,0,1-.147-.354.5.5,0,0,1,.147-.354l10.1-10.1a.5.5,0,0,1,.354-.147.5.5,0,0,1,.354.147l6.431,6.43a.5.5,0,0,1,0,.707l-8.4,8.4a.5.5,0,0,1-.354.146Zm6.574-4.452,4.507-4.451-5.724-5.724-4.489,4.487Z" transform="translate(1953 3069)" fill="currentColor" />
                                      </g>
                                      <rect id="Rectangle_2983" data-name="Rectangle 2983" width="24" height="24" transform="translate(1951 3066)" fill="none" />
                                    </g>
                                  </svg>
                                </i>
                                Delete List
                              </Dropdown.Item>
                              <Form noValidate name="delete-deployment">
                                {/* Modal Delete Confirmation */}
                                <Modal show={this.state.showDeletePopup} centered size="sm">
                                  <Modal.Body className="p-0">
                                    <div className="modal_confirmation-alert">
                                      <div className="confirmation-alert_img">
                                        <Image src="logo" />
                                      </div>
                                      <div className="confirmation-alert_text">
                                        <h4>Delete Watchlist</h4>
                                        <p>
                                          Please confirm the name of the watchlist to delete:{" "}
                                          <strong>{selectedWatchlistName || "My_Deployment"}</strong>
                                        </p>
                                      </div>
                                      <div className="confirmation-alert_form">
                                        <Form.Group controlId="watchlist-name" className='mx-auto' style={{ width: '85%' }}>
                                          {/* <Form.Label>
                                                    Deployment Name <span style={{ color: "red" }}>*</span>
                                                  </Form.Label> */}
                                          <InputGroup bsPrefix="icon-input-group">
                                            <Form.Control
                                              type="text"
                                              placeholder="Enter watchlist name to confirm"
                                              className="mb-3 text-center pl-3 font-weight-medium"
                                              value={this.state.confirmDeleteName}
                                              onChange={(e) =>
                                                this.setState({ confirmDeleteName: e.target.value })
                                              }
                                            />
                                          </InputGroup>
                                        </Form.Group>
                                        {this.state.errors && (
                                          <div className="alert alert-danger text-left">
                                            <i className="text-danger mr-2">
                                              <FontAwesomeIcon icon={faExclamationTriangle} />
                                            </i>
                                            {this.state.errors}
                                          </div>
                                        )}
                                        <div className="alert alert-danger text-left">
                                          <i className="text-danger mr-2">
                                            <FontAwesomeIcon icon={faExclamationTriangle} />
                                          </i>
                                          Deleting this watchlist is irreversible. Only the watchlist will be deleted, Data Assets and its datapoints will not be affected.                                        </div>
                                        <div className="confirmation-alert_action">
                                          <button
                                            type="button"
                                            onClick={this.handleCloseDeletePopup}
                                            className="btn btn-outline btn-grey btn-circle mr-2"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            type="button"
                                            onClick={() => this.handleDeleteWatchlist(selectedWatchlistName)}
                                            className="btn btn-primary btn-circle mr-2"
                                            disabled={
                                              this.state.confirmDeleteName !== selectedWatchlistName
                                            }
                                          >
                                            <FontAwesomeIcon icon={faCheck} />
                                            Confirm
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </Modal.Body>
                                </Modal>
                              </Form>
                              <Dropdown.Divider />
                              <Dropdown.Header className="text-uppercase">Customize Columns</Dropdown.Header>
                              <Dropdown.Item href="#/action-1">
                                <Form.Check
                                  type="checkbox"
                                  id="customControlAutosizing1"
                                  label="Arrow Indicator"
                                  checked={this.state.arrowIndicator}
                                  onClick={() => this.checkbox('arrowIndicator')}
                                />
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-2">
                                <Form.Check
                                  type="checkbox"
                                  id="customControlAutosizing2"
                                  label="New Value"
                                  checked={this.state.newValue}
                                  onClick={() => this.checkbox('newValue')}
                                />
                              </Dropdown.Item>
                              <Dropdown.Item href="#/action-3">
                                <Form.Check
                                  type="checkbox"
                                  id="customControlAutosizing3"
                                  label="Old Value"
                                  checked={this.state.oldValue}
                                  onClick={() => this.checkbox('oldValue')}
                                />
                              </Dropdown.Item>
                              {/* <Dropdown.Divider /> */}
                              {/* <Dropdown.Header className="text-uppercase">Sort</Dropdown.Header>
                                    <Dropdown.Item href="#/action-4">
                                      <Form.Check
                                        type="radio"
                                        id="top_10"
                                        label="Top 10 Issues"
                                        custom
                                        checked
                                      />
                                    </Dropdown.Item>
                                    <Dropdown.Item href="#/action-5">
                                      <Form.Check
                                        type="radio"
                                        id="top_5"
                                        label="Top 5 Issues"
                                        custom
                                      />
                                    </Dropdown.Item> */}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <Modal
                          size="md"
                          show={this.state.watchListOpen}
                          onHide={this.handleWishListClose}
                          className="modal-tree-view"
                          centered
                        >
                          <Modal.Header closeButton>
                            <h5 className="modal-title">{this.state.editWatchlist ? "Edit a List" : "Create a New List"}
                            </h5>
                          </Modal.Header>
                          <Modal.Body className="p-0">
                            <div className="modal-tree-view__top">
                              <Form.Group>
                                <Form.Control
                                  size="lg"
                                  type="text"
                                  placeholder="Enter name of the list"
                                  value={this.state.watchListName}
                                  onChange={this.handleWatchlistNameChange}
                                  isInvalid={!!this.state.watchListNameError}
                                  maxLength={20}
                                />
                                <Form.Control.Feedback type="invalid">
                                  {this.state.watchListNameError}
                                </Form.Control.Feedback>
                              </Form.Group>

                              <div className="qd-search-bar has-btn-close qd-search-bar--bg-gray">
                                <div className="input-group">
                                  <div className="input-group-prepend">
                                    <button id="button-addon4" type="button" className="btn">
                                      <svg className='d-block' width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7" />
                                        <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7" />
                                      </svg>
                                    </button>
                                  </div>
                                  <input type="search" placeholder="Search..." className="form-control h-100" value={this.state.saveWatchListSearchText} onChange={this.handleWatchlistSearch} />
                                </div>
                                {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>}
                              </div>
                            </div>
                            { this.state.watchListOpen && <RealTimeLeftPanel
                              leftPanelLoader={this.state.leftPanelLoader}
                              renderchartView={this.renderchartView}
                              metaData={this.state.metaData}
                              latest_env_name={latest_env_name}
                              selectedEnv={this.state.selectedEnv}
                              datasourceData={datasourceData}
                              isRedirect={this.state.isRedirect}
                              isNodeHasActions={false}
                              filteredData={this.state.filteredData}
                              subString={this.state.subString}
                              searchCount={this.state.searchCount}
                              clearSearch={this.clearSearch}
                              isNoResult={this.state.isNoResult}
                              autoCompleteData={this.state.autoCompleteData}
                              originalData={this.state.nestedData}
                              metaDataResponse={this.state.metaDataResponse}
                              nestedData={Object.values(this.state.newData).length === 0 ? (this.state.isNoResult ? this.state.newData : this.state.nestedData) : this.state.newData}
                              initialSelection={this.state.initialSelection}
                              isSearchHappened={this.state.isSearchHappened}
                              showCustomCheckbox={true}
                              showSearchFilter={false}
                              saveWatchListSearchText={this.state.saveWatchListSearchText}
                              isChecked={this.state.isChecked}
                              buildNestedStructure={this.buildNestedStructure}
                              handleCheckboxChange={this.handleCheckboxChange}
                              arrowIndicator={this.state.arrowIndicator}
                              newValue={this.state.newValue}
                              oldValue={this.state.oldValue}
                              handleSaveWatchlistCheckboxChange={this.handleSaveWatchlistCheckboxChange}
                              checkedStates={this.state.checkedStates}
                              watchListOpen={this.state.watchListOpen}
                              selectedEnvId={this.props.selectedEnvId}
                              selectedWatchlistId={this.state.selectedWatchListId}
                              selectPartitionButton={this.state.selectPartitionButton}
                              clearCheckedStates={this.clearCheckedStates}
                               isLoadingMetaData = {this.state.isLoadingMetaData}
                            />}
                          </Modal.Body>
                          <Modal.Footer className='justify-content-between flex-nowrap'>
                            {/* <button className="btn btn-outline btn-grey btn-circle" onClick={this.handleWishListClose}>Cancel</button>
                                <button className="btn btn-primary btn-circle" name = "save_watchlist" onClick={() => this.handleSaveClick()}  disabled={(this.state.watchListName !== '' && this.state.watchListName.toLowerCase() === "all") ||isSaveDisabled}><FontAwesomeIcon icon={faCheck} /> Save</button> */}
                            {/* //className="justify-content-between"> for partition */}
                            <div className="custom-control custom-switch custom-switch-sm text-muted">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="selectPartition"
                                onChange={(e) => this.handleSelectPartitionToggle?.(e.target.checked)}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="selectPartition"
                                style={{ cursor: "pointer" }}
                              >
                                <span className='ml-2 d-inline-block'>Automatically apply selection to <strong>partitions and their attributes</strong> </span>
                              </label>
                            </div>
                            <div className='flex-shrink-0'>
                              <button className="btn btn-outline btn-grey btn-circle mr-2" onClick={this.handleWishListClose}>Cancel</button>
                              <button className="btn btn-primary btn-circle" name="save_watchlist" onClick={() => this.handleSaveClick()} disabled={isSaveDisabled}><FontAwesomeIcon icon={faCheck} /> Save</button>
                            </div>
                          </Modal.Footer>
                        </Modal>
                        <div className={this.state.metricListRename ? "rename-input-box has-btn-close" : "rename-input-box d-none"}>
                          <Form.Control type="text" placeholder="Enter Name" />
                          <button className="btn btn-clear" title="clear"><i className="icon-close"></i></button>
                        </div>
                      </div>
                      <div className="qd-rt_aside-body">
                        <div className="qd-rt_tree-view">
                          {this.state.leftPanelLoader === true ? <Load /> :
                            //
                            <RealTimeLeftPanel
                              inProgress={this.state.spinner}
                              AllInterationsResponse={this.state.integrationRequest}
                              renderchartView={this.renderchartView}
                              metaData={this.state.metaData}
                              latest_env_name={latest_env_name}
                              selectedEnv={this.state.selectedEnv}
                              datasourceData={datasourceData}
                              isRedirect={this.state.isRedirect}
                              filteredData={this.state.filteredData}
                              subString={this.state.subString}
                              searchCount={this.state.searchCount}
                              clearSearch={this.clearSearch}
                              isNoResult={this.state.isNoResult}
                              autoCompleteData={this.state.autoCompleteData}
                              originalData={this.state.nestedData}
                              nestedData={Object.values(this.state.newData).length === 0 ? (this.state.isNoResult ? this.state.newData : this.state.nestedData) : this.state.newData}
                              initialSelection={this.state.initialSelection}
                              isSearchHappened={this.state.isSearchHappened}
                              metricsValueResponse={this.state.metricsValueResponse}
                              showCustomCheckbox={false}
                              isNodeHasActions={true}
                              showSearchFilter={true}
                              arrowIndicator={this.state.arrowIndicator}
                              newValue={this.state.newValue}
                              oldValue={this.state.oldValue}
                              getMetricsValueResponse={this.getMetricsValueResponse}
                              // handleSaveWatchlistCheckboxChange ={this.handleSaveWatchlistCheckboxChange}
                              checkedStates={this.state.checkedStates}
                              selectedEnvId={this.props.selectedEnvId}
                              selectedWatchlistId={this.state.selectedWatchListId}
                              isPartitionChecked = {this.state.isCheckedBoxPartition}
                              noDatasetFound = {this.state.noDatasetFound}
                              viewIncidentData = {this.props.data}
                            />
                          }
                        </div>
                      </div>
                    </div>
                    <div className={this.state.expandBottomStatPanel === true ? "qd-rt-stat qd-rt-stat--is-expanded" : "qd-rt-stat"} style={{ height: this.state.expandBottomStatPanel === true ? 'calc(100% - (20% + 100px))' : '40px' }}>
                      {this.state.currentBottomPanelData !== "" && this.state.currentBottomPanelData !== undefined ?
                        <>
                          <div className="qd-rt-stat__head">
                            <div className="qd-rt-stat-wrap">
                              <div className="icon-circle">
                                {this.state.dataType === "Attribute" ?
                                  <FontAwesomeIcon icon={faTag}></FontAwesomeIcon>
                                  :
                                  <FontAwesomeIcon icon={faLayerGroup}></FontAwesomeIcon>
                                }
                                {/* <FontAwesomeIcon icon={faLayerGroup}></FontAwesomeIcon> */}
                                {/* Add this Icon for Attribute level */}
                                {/* <FontAwesomeIcon icon={faTag}></FontAwesomeIcon> */}
                              </div>
                              <div className="content-stack">
                                {this.state.dataType === "Attribute" ?
                                  <><h4>{normalizeAttributeName(this.state.selectedDatasetAttrName)}</h4>
                                    <ol className="qd-rt-breadcrum">
                                      <li className="qd-rt-breadcrum-item"><span>{this.props.selectedEnvName}</span></li>
                                      <li className="qd-rt-breadcrum-item"><span>{this.state.selectedIntegrationName}</span></li>
                                      <li className="qd-rt-breadcrum-item"><span>{this.state.selectedDatasetName}</span></li>
                                    </ol></> :
                                  <>
                              <RcTooltip placement="top" overlay={<span>{this.state.selectedDatasetName}</span>} trigger={this.state.selectedDatasetName && this.state.selectedDatasetName.length > 28? ["hover"]: []}>
                                <h4 style={{cursor: this.state.selectedDatasetName && this.state.selectedDatasetName.length > 28 ? "pointer" : "default", display: "inline-block"}}>
                                  {(() => {
                                    const name = this.state.selectedDatasetName || "";
                                    const maxLength = 28;
                                    const isTruncated = name.length > maxLength;

                                    const displayName = isTruncated
                                      ? name.substring(0, maxLength) + " [....]"
                                      : name;

                                    return displayName;
                                  })()}
                                </h4>
                              </RcTooltip>
                                    <ol className="qd-rt-breadcrum">
                                      <li className="qd-rt-breadcrum-item"><span>{this.props.selectedEnvName}</span></li>
                                      <li className="qd-rt-breadcrum-item"><span>{this.state.selectedIntegrationName}</span></li>
                                    </ol>
                                  </>
                                }
                              </div>
                              <div class="action" onClick={this.toggleBottomStatPanel}>
                                <RcTooltip
                                  placement="top"
                                  overlay={
                                    <span>{this.state.expandBottomStatPanel === true ? "Collapse the panel" : "Expand the panel"}</span>
                                  }
                                  arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                >
                                  <button class="btn">
                                    <i>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 15L12 9L6 15" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                      </svg>
                                    </i>
                                  </button>
                                </RcTooltip>
                              </div>
                            </div>
                            <div class="alert alert-sm moniker-alert text-body mb-0 tw-rounded-full tw-px-[10]" role="alert">
                              <p className='m-0'>
                                <i className='mr-1'>
                                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.99775 12.6347C8.30388 12.6347 7.67094 12.4589 7.09894 12.1074C6.52694 11.7559 6.08563 11.285 5.775 10.6946C5.70675 10.5735 5.6945 10.4461 5.73825 10.3125C5.78213 10.1789 5.86731 10.0873 5.99381 10.0378C6.10081 9.98831 6.20988 9.9885 6.321 10.0384C6.432 10.0883 6.51781 10.1681 6.57844 10.2778C6.81369 10.7186 7.147 11.0725 7.57837 11.3396C8.00975 11.6068 8.48363 11.7403 9 11.7403C9.75688 11.7403 10.4028 11.4728 10.9378 10.9378C11.4728 10.4028 11.7403 9.75688 11.7403 9C11.7403 8.24313 11.4728 7.59719 10.9378 7.06219C10.4028 6.52719 9.75688 6.25969 9 6.25969C8.5875 6.25969 8.20094 6.34619 7.84031 6.51919C7.47981 6.69231 7.16013 6.93269 6.88125 7.24031H7.6875C7.81663 7.24031 7.92344 7.28256 8.00794 7.36706C8.09244 7.45144 8.13469 7.55813 8.13469 7.68712C8.13469 7.81625 8.09244 7.92313 8.00794 8.00775C7.92344 8.09238 7.81663 8.13469 7.6875 8.13469H6.04331C5.85119 8.13469 5.69019 8.06969 5.56031 7.93969C5.43031 7.80981 5.36531 7.64881 5.36531 7.45669V5.8125C5.36531 5.68338 5.40756 5.57656 5.49206 5.49206C5.57644 5.40756 5.68313 5.36531 5.81213 5.36531C5.94125 5.36531 6.04812 5.40756 6.13275 5.49206C6.21737 5.57656 6.25969 5.68338 6.25969 5.8125V6.59288C6.62219 6.21688 7.03925 5.91831 7.51087 5.69719C7.9825 5.47594 8.47888 5.36531 9 5.36531C10.0086 5.36531 10.8666 5.71894 11.5738 6.42619C12.2811 7.13344 12.6347 7.99137 12.6347 9C12.6347 10.0086 12.2811 10.8666 11.5738 11.5738C10.8666 12.2811 10.0079 12.6347 8.99775 12.6347ZM3.98081 15.375C3.60194 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.3981 2.625 14.0192V11.8125C2.625 11.6531 2.67894 11.5195 2.78681 11.4116C2.89469 11.3039 3.02831 11.25 3.18769 11.25C3.34719 11.25 3.48075 11.3039 3.58838 11.4116C3.69613 11.5195 3.75 11.6531 3.75 11.8125V14.0192C3.75 14.0769 3.77406 14.1298 3.82219 14.1778C3.87019 14.2259 3.92306 14.25 3.98081 14.25H6.1875C6.34688 14.25 6.4805 14.3039 6.58838 14.4118C6.69613 14.5197 6.75 14.6533 6.75 14.8127C6.75 14.9722 6.69613 15.1058 6.58838 15.2134C6.4805 15.3211 6.34688 15.375 6.1875 15.375H3.98081ZM14.0192 15.375H11.8125C11.6531 15.375 11.5195 15.3211 11.4116 15.2132C11.3039 15.1053 11.25 14.9717 11.25 14.8123C11.25 14.6528 11.3039 14.5192 11.4116 14.4116C11.5195 14.3039 11.6531 14.25 11.8125 14.25H14.0192C14.0769 14.25 14.1298 14.2259 14.1778 14.1778C14.2259 14.1298 14.25 14.0769 14.25 14.0192V11.8125C14.25 11.6531 14.3039 11.5195 14.4118 11.4116C14.5197 11.3039 14.6533 11.25 14.8127 11.25C14.9722 11.25 15.1058 11.3039 15.2134 11.4116C15.3211 11.5195 15.375 11.6531 15.375 11.8125V14.0192C15.375 14.3981 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.3981 15.375 14.0192 15.375ZM2.625 6.1875V3.98081C2.625 3.60194 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.60194 2.625 3.98081 2.625H6.1875C6.34688 2.625 6.4805 2.67894 6.58838 2.78681C6.69613 2.89469 6.75 3.02831 6.75 3.18769C6.75 3.34719 6.69613 3.48075 6.58838 3.58838C6.4805 3.69613 6.34688 3.75 6.1875 3.75H3.98081C3.92306 3.75 3.87019 3.77406 3.82219 3.82219C3.77406 3.87019 3.75 3.92306 3.75 3.98081V6.1875C3.75 6.34688 3.69606 6.4805 3.58819 6.58838C3.48031 6.69613 3.34669 6.75 3.18731 6.75C3.02781 6.75 2.89425 6.69613 2.78662 6.58838C2.67887 6.4805 2.625 6.34688 2.625 6.1875ZM14.25 6.1875V3.98081C14.25 3.92306 14.2259 3.87019 14.1778 3.82219C14.1298 3.77406 14.0769 3.75 14.0192 3.75H11.8125C11.6531 3.75 11.5195 3.69606 11.4116 3.58819C11.3039 3.48031 11.25 3.34669 11.25 3.18731C11.25 3.02781 11.3039 2.89425 11.4116 2.78662C11.5195 2.67887 11.6531 2.625 11.8125 2.625H14.0192C14.3981 2.625 14.7188 2.75625 14.9813 3.01875C15.2438 3.28125 15.375 3.60194 15.375 3.98081V6.1875C15.375 6.34688 15.3211 6.4805 15.2132 6.58838C15.1053 6.69613 14.9717 6.75 14.8123 6.75C14.6528 6.75 14.5192 6.69613 14.4116 6.58838C14.3039 6.4805 14.25 6.34688 14.25 6.1875Z" fill="#5F6368" />
                                  </svg>
                                </i>
                                Last profiled at <strong>  {this.state.lastProcessedDate
                                  ? (() => {
                                      const lastTime = this.state.lastProcessedDate;
                                      const date = new Date(lastTime + " GMT"); // Convert to GMT
                                      const day = String(date.getUTCDate()).padStart(2, "0");
                                      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
                                      const year = date.getUTCFullYear();
                                      const hours = String(date.getUTCHours()).padStart(2, "0");
                                      const minutes = String(date.getUTCMinutes()).padStart(2, "0");
                                      const seconds = String(date.getUTCSeconds()).padStart(2, "0");
                                      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} GMT`;
                                    })()
                                  : "-"}
                              </strong>
                              </p>
                            </div>
                          </div>
                          <Scrollbars className="custom-scrollbar"
                            autoHeightMin={0}
                            style={{ height: 'calc(100% - 66px)' }}
                            autoHeightMax="100%"
                            thumbMinSize={30}
                            universal={true}
                          >

                            {this.state.dataType === "Dataset" && this.state.currentBottomPanelData 
                              ?
                              <div style={{ paddingBottom: '10px' }}>
                                <div className="qd-rt-stat__body clearfix">
                                  <h6 className="qd-rt-stat__title">DQ issues</h6>
                                  <div className="qd-rt-summary">
                                    <div className="qd-rt-summary_item">
                                      <span className="qd-rt-summary_label">Total No. of issues in the dataset</span>
                                      <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["total_issues"]}</strong>
                                    </div>
                                    <div className="qd-rt-summary_item">
                                      <span className="qd-rt-summary_label">No. of attributes having issues</span>
                                      {/* <strong className="qd-rt-summary_value">3</strong> */}
                                      <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["attributes_with_issues_count"]}/{this.state.currentBottomPanelData["total_attributes"]}</strong>
                                    </div>
                                    {this.state.currentBottomPanelData["partitions_with_issues_count"] !== 0 && <div className="qd-rt-summary_item">
                                      <span className="qd-rt-summary_label">No. of partitions having issues</span>
                                      {/* <strong className="qd-rt-summary_value">NA</strong> */}
                                      <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["partitions_with_issues_count"]}/{this.state.currentBottomPanelData["total_partitions"]}</strong>

                                    </div>}
                                  </div>
                            <h6 className="qd-rt-stat__title">
                              {Object.keys(this.state.currentBottomPanelData.metric_id_count_map || {}).length > 0
                                && `${Object.keys(this.state.currentBottomPanelData.metric_id_count_map).length} DQ issue${
                                    Object.keys(this.state.currentBottomPanelData.metric_id_count_map).length > 1 ? "s" : ""
                                  } identified at attribute level`}
                            </h6>

                            <div className="qd-rt-summary">
                              {this.state.currentBottomPanelData.metric_id_count_map &&
                              Object.keys(this.state.currentBottomPanelData.metric_id_count_map).length > 0 && (
                                Object.entries(this.state.currentBottomPanelData.metric_id_count_map).map(
                                  ([metricName, count]) => (
                                    <div className="qd-rt-summary_item" key={metricName}>
                                      <span className="qd-rt-summary_label">
                                        Attributes having {metricName.toLowerCase()} issue
                                      </span>
                                      <strong className="qd-rt-summary_value">{count}</strong>
                                    </div>
                                  )
                                )
                              ) }
                                  </div>

                                  {this.state.currentBottomPanelData.top_three_attributes_with_issues !== undefined && this.state.currentBottomPanelData.top_three_attributes_with_issues.length > 0
                                    &&
                                    <>
                                      <h6 className="qd-rt-stat__title">Top 3 Attributes having <strong>DQ issues</strong></h6>
                                       <ul className="top-issue-list">
                                          {this.state.currentBottomPanelData.top_three_attributes_with_issues.map(attrId => {
                                            const datasetId = this.state.selectedDatasetId;
                                            const attributesForDataset =
                                              this.state.metricsValueResponse?.attributes?.[datasetId] || [];

                                            const matchedAttr = attributesForDataset.find(attr => attr.value === attrId);
                                            const label = matchedAttr ? matchedAttr.label : `Attribute ID: ${attrId}`;

                                            return (
                                              <li key={attrId} className="top-issue-list__item">
                                                <span className="label">
                                                  <i className="mr-1">
                                                    <FontAwesomeIcon icon={faTag} />
                                                  </i>
                                                  {label}
                                                </span>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                    </>
                                  }
                                  {this.state.currentBottomPanelData.top_three_partitions_with_issues && this.state.currentBottomPanelData.top_three_partitions_with_issues.length > 0 && (
                                      <>
                                        <h6 className="qd-rt-stat__title">
                                          Top 3 <strong>Partitions</strong> having DQ issues
                                        </h6>
                                        <ul className="top-issue-list">
                                          {this.state.currentBottomPanelData.top_three_partitions_with_issues.map(
                                            (partitionLabel) => (
                                              <li key={partitionLabel} className="top-issue-list__item">
                                                <span className="label">
                                                  <i className="mr-1">
                                                    <FontAwesomeIcon icon={faLayerGroup} />
                                                  </i>
                                                  {normalizeChildDatasetName(partitionLabel)}
                                                </span>
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </>
                                    )}


                                  <h6 className="qd-rt-stat__title">Chart Summary</h6>
                                  {/* <HistogramChart
                                    metrics={this.state.currentBottomPanelData !== undefined && this.state.currentBottomPanelData.chart_data}
                                  /> */}
                                  <ParetoChart
                                    data = {this.state.currentBottomPanelData !== undefined && this.state.currentBottomPanelData.chart_data}
                                    width={300} height={300} 
                                    />  
                                  <br />
                                  <br />
                                  <br />
                                </div>
                                {/* 
                              <div className="qd-rt-stat__body clearfix">
                                <h6 className="qd-rt-stat__title">DQ issues</h6>
                                <div className="qd-rt-summary">
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">Total No. of issues in the dataset</span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["total_issues"]}</strong>
                                  </div>
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">No. of attributes having issues</span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["attributes_with_issues_count"]}/{this.state.currentBottomPanelData["total_attributes"]}</strong>
                                  </div>
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">No. of partitions having issues</span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["partitions_with_issues_count"]}/{this.state.currentBottomPanelData["total_partitions"]}</strong>
                                  </div>
                                </div>
                                <h6 className="qd-rt-stat__title">{this.state.currentBottomPanelData["total_issues"]} DQ issues identified:{this.state.currentBottomPanelData["attributes_with_issues_count"]}/{this.state.currentBottomPanelData["total_attributes"]} Attributes have errors</h6>
                                <div className="qd-rt-summary d-none">
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">Attributed have <strong>fillrate issue</strong></span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["attributes_with_issues_count"]}</strong>
                                  </div>
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">Attributed have <strong>accuracy issues</strong></span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["attributes_with_issues_count"]}</strong>
                                  </div>
                                  <div className="qd-rt-summary_item">
                                    <span className="qd-rt-summary_label">Attributed has <strong>custom metric issue</strong></span>
                                    <strong className="qd-rt-summary_value">{this.state.currentBottomPanelData["attributes_with_issues_count"]}</strong>
                                  </div>
                                </div>

                              </div> */}
                              </div>
                              :

                              <div style={{ paddingBottom: '10px' }}>
                                <div className="qd-rt-stat__body clearfix">
                                  <ul className="rt-stat-tags mb-5px">
                                    <li className='rt-stat-tag rt-stat-tag--light-blue'>
                                      <span className="value">{this.state.currentBottomPanelData.type}</span>
                                      <label>Type</label>
                                    </li>
                                    <li className='rt-stat-tag rt-stat-tag--light-blue'>
                                      <span className="value">{this.state.currentBottomPanelData.business_rule === null ? "NA" : this.state.currentBottomPanelData.business_rule}</span>
                                      <label>Bussiness rule</label>
                                    </li>
                                  </ul>
                                  <ul className="rt-stat-tags">
                                    <li className='rt-stat-tag'>
                                      <span className="value">{this.state.currentBottomPanelData.null_values}</span>
                                      <label>Null Values</label>
                                    </li>
                                    <li className='rt-stat-tag'>
                                      <span className="value">{this.state.currentBottomPanelData.unique_values}</span>
                                      <label>Unique Values</label>
                                    </li>
                                    <li className='rt-stat-tag'>
                                      <span className="value">{this.state.currentBottomPanelData.duplicate}</span>
                                      <label>Duplicate</label>
                                    </li>
                                  </ul>

                                {Array.isArray(this.state.currentBottomPanelData?.metrics_with_issue) && this.state.currentBottomPanelData.metrics_with_issue.length > 0 &&                                  
                                 <h6 className="qd-rt-stat__title">Data quality issues in this attribute</h6>
                                 }
                                {Array.isArray(this.state.currentBottomPanelData?.metrics_with_issue) && this.state.currentBottomPanelData.metrics_with_issue.length > 0 &&
                                    <>
                                   {this.state.currentBottomPanelData.metrics_with_issue.map((metric, index) => (
                                        <>
                                          <div className="qd-rt-summary_item">
                                            <span className="qd-rt-summary_label">{metric}</span>
                                            <strong className="qd-rt-summary_value"></strong>
                                          </div>
                                        </>
                                      ))}
                                    </>
                                    // :
                                    // <>
                                    //   <div className="qd-rt-summary_item mb-4">
                                    //     NA
                                    //     {/* <span className="qd-rt-summary_label">{key}</span> */}
                                    //     {/* <strong className="qd-rt-summary_value">{value}/12</strong> */}
                                    //   </div>
                                    // </>
                                  }
                                  <h6 className="qd-rt-stat__title">No. Partitions having DQ errors in the attributes:</h6>
                                  <ul className="rt-stat-tags">
                                    <li className="rt-stat-tag">
                                      <span className="value">{this.state.currentBottomPanelData.partitions_with_issues_count}</span>
                                      <label>Partitions</label>
                                    </li>
                                  </ul>
                                  <h6 className="qd-rt-stat__title d-none">Top 3 partitions having issues in</h6>
                                    {this.state.currentBottomPanelData?.top_three_partitions_with_issues?.length > 0 
                                    ?
                                    <>
                                      <ul class="top-issue-list top-issue-list--vertical d-none">
                                        {this.state.currentBottomPanelData.top_three_partitions_with_issues.map((data) => {
                                          return (
                                            <li className='top-issue-list__item'>
                                              <span className='label'>
                                                <i className='mr-1'>
                                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 7.94595L2.29089 5.46934C1.90304 5.29333 1.90304 4.70693 2.29089 4.53092L7.75069 2.05431C7.82898 2.01852 7.9141 2 8.0002 2C8.0863 2 8.17126 2.01852 8.24955 2.05431L13.7089 4.53116C14.0967 4.70716 14.0967 5.29333 13.7089 5.46934L12.0398 6.2265C11.7292 6.07773 11.3869 6 11.0258 6C10.3872 6 9.80749 6.2429 9.35844 6.6918C9.06563 6.98466 8.86039 7.3332 8.75313 7.71741L8.24939 7.94595C8.09005 8.01837 7.90971 8.01837 7.75037 7.94595ZM8.67696 8.58519L8.55929 8.63852C8.38204 8.7189 8.19389 8.75968 8.00004 8.75968C7.80619 8.75968 7.6182 8.7189 7.4408 8.63852L3.65271 6.92128L2.29089 7.53838C1.90304 7.71415 1.90304 8.30008 2.29089 8.47586L7.75037 10.9506C7.90971 11.0228 8.09005 11.0228 8.24939 10.9506L9.17956 10.529V9.82247C9.11967 9.74811 9.06384 9.66984 9.01225 9.58777C8.81352 9.27158 8.70837 8.929 8.67696 8.58519ZM9.17956 11.3573L8.55929 11.6385C8.38204 11.7189 8.19389 11.7596 8.00004 11.7596C7.80619 11.7596 7.6182 11.7189 7.4408 11.6385L3.6475 9.91888L2.29089 10.5337C1.90304 10.7094 1.90304 11.2953 2.29089 11.4711L7.75037 13.9459C7.90971 14.018 8.09005 14.018 8.24939 13.9459L8.78015 13.7053C8.70528 13.474 8.66671 13.2289 8.66671 12.9744C8.66671 12.5554 8.7699 12.1354 9.0033 11.7534C9.02917 11.7111 9.05619 11.6697 9.08435 11.6293C9.11479 11.5856 9.14652 11.543 9.17956 11.5016V11.3573Z" fill="#78829D" />
                                                    <path d="M11.0256 14C10.7436 14 10.5021 13.8996 10.3013 13.6987C10.1004 13.4979 10 13.2564 10 12.9744C10 12.7778 10.047 12.6026 10.141 12.4487C10.235 12.2949 10.359 12.1709 10.5128 12.0769V9.24359C10.359 9.14957 10.235 9.02778 10.141 8.87821C10.047 8.72863 10 8.55556 10 8.35897C10 8.07692 10.1004 7.83547 10.3013 7.63462C10.5021 7.43376 10.7436 7.33333 11.0256 7.33333C11.3077 7.33333 11.5491 7.43376 11.75 7.63462C11.9509 7.83547 12.0513 8.07692 12.0513 8.35897C12.0513 8.55556 12.0043 8.72863 11.9103 8.87821C11.8162 9.02778 11.6923 9.14957 11.5385 9.24359V10.7179L13.5897 10.0385V9.24359C13.4359 9.14957 13.312 9.02778 13.2179 8.87821C13.1239 8.72863 13.0769 8.55556 13.0769 8.35897C13.0769 8.07692 13.1773 7.83547 13.3782 7.63462C13.5791 7.43376 13.8205 7.33333 14.1026 7.33333C14.3846 7.33333 14.6261 7.43376 14.8269 7.63462C15.0278 7.83547 15.1282 8.07692 15.1282 8.35897C15.1282 8.55556 15.0812 8.72863 14.9872 8.87821C14.8932 9.02778 14.7692 9.14957 14.6154 9.24359V10.0256C14.6154 10.2479 14.5513 10.4487 14.4231 10.6282C14.2949 10.8077 14.1239 10.9316 13.9103 11L11.5385 11.7949V12.0769C11.6923 12.1709 11.8162 12.2949 11.9103 12.4487C12.0043 12.6026 12.0513 12.7778 12.0513 12.9744C12.0513 13.2564 11.9509 13.4979 11.75 13.6987C11.5491 13.8996 11.3077 14 11.0256 14Z" fill="#78829D" />
                                                  </svg>
                                                </i>{data}</span>
                                            </li>
                                          )
                                        })}
                                      </ul>
                                    </>
                                    :
                                    <>
                                      <ul class="top-issue-list top-issue-list--vertical d-none">
                                        NA
                                        {/* {this.state.currentBottomPanelData.top_three_partitions_with_issues.map((data) =>{
                                        return(
                                          <li className='top-issue-list__item'>
                                            <span className='label'>
                                              <i className='mr-1'>
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 7.94595L2.29089 5.46934C1.90304 5.29333 1.90304 4.70693 2.29089 4.53092L7.75069 2.05431C7.82898 2.01852 7.9141 2 8.0002 2C8.0863 2 8.17126 2.01852 8.24955 2.05431L13.7089 4.53116C14.0967 4.70716 14.0967 5.29333 13.7089 5.46934L12.0398 6.2265C11.7292 6.07773 11.3869 6 11.0258 6C10.3872 6 9.80749 6.2429 9.35844 6.6918C9.06563 6.98466 8.86039 7.3332 8.75313 7.71741L8.24939 7.94595C8.09005 8.01837 7.90971 8.01837 7.75037 7.94595ZM8.67696 8.58519L8.55929 8.63852C8.38204 8.7189 8.19389 8.75968 8.00004 8.75968C7.80619 8.75968 7.6182 8.7189 7.4408 8.63852L3.65271 6.92128L2.29089 7.53838C1.90304 7.71415 1.90304 8.30008 2.29089 8.47586L7.75037 10.9506C7.90971 11.0228 8.09005 11.0228 8.24939 10.9506L9.17956 10.529V9.82247C9.11967 9.74811 9.06384 9.66984 9.01225 9.58777C8.81352 9.27158 8.70837 8.929 8.67696 8.58519ZM9.17956 11.3573L8.55929 11.6385C8.38204 11.7189 8.19389 11.7596 8.00004 11.7596C7.80619 11.7596 7.6182 11.7189 7.4408 11.6385L3.6475 9.91888L2.29089 10.5337C1.90304 10.7094 1.90304 11.2953 2.29089 11.4711L7.75037 13.9459C7.90971 14.018 8.09005 14.018 8.24939 13.9459L8.78015 13.7053C8.70528 13.474 8.66671 13.2289 8.66671 12.9744C8.66671 12.5554 8.7699 12.1354 9.0033 11.7534C9.02917 11.7111 9.05619 11.6697 9.08435 11.6293C9.11479 11.5856 9.14652 11.543 9.17956 11.5016V11.3573Z" fill="#78829D" />
                                                  <path d="M11.0256 14C10.7436 14 10.5021 13.8996 10.3013 13.6987C10.1004 13.4979 10 13.2564 10 12.9744C10 12.7778 10.047 12.6026 10.141 12.4487C10.235 12.2949 10.359 12.1709 10.5128 12.0769V9.24359C10.359 9.14957 10.235 9.02778 10.141 8.87821C10.047 8.72863 10 8.55556 10 8.35897C10 8.07692 10.1004 7.83547 10.3013 7.63462C10.5021 7.43376 10.7436 7.33333 11.0256 7.33333C11.3077 7.33333 11.5491 7.43376 11.75 7.63462C11.9509 7.83547 12.0513 8.07692 12.0513 8.35897C12.0513 8.55556 12.0043 8.72863 11.9103 8.87821C11.8162 9.02778 11.6923 9.14957 11.5385 9.24359V10.7179L13.5897 10.0385V9.24359C13.4359 9.14957 13.312 9.02778 13.2179 8.87821C13.1239 8.72863 13.0769 8.55556 13.0769 8.35897C13.0769 8.07692 13.1773 7.83547 13.3782 7.63462C13.5791 7.43376 13.8205 7.33333 14.1026 7.33333C14.3846 7.33333 14.6261 7.43376 14.8269 7.63462C15.0278 7.83547 15.1282 8.07692 15.1282 8.35897C15.1282 8.55556 15.0812 8.72863 14.9872 8.87821C14.8932 9.02778 14.7692 9.14957 14.6154 9.24359V10.0256C14.6154 10.2479 14.5513 10.4487 14.4231 10.6282C14.2949 10.8077 14.1239 10.9316 13.9103 11L11.5385 11.7949V12.0769C11.6923 12.1709 11.8162 12.2949 11.9103 12.4487C12.0043 12.6026 12.0513 12.7778 12.0513 12.9744C12.0513 13.2564 11.9509 13.4979 11.75 13.6987C11.5491 13.8996 11.3077 14 11.0256 14Z" fill="#78829D" />
                                                </svg>
                                              </i>{data}</span>
                                          </li>
                                        )
                                      })} */}
                                      </ul>
                                    </>
                                  }

                                 {Array.isArray(this.state.currentBottomPanelData.relationship) && this.state.currentBottomPanelData.relationship.length > 0 && 
                                   <h6 className="qd-rt-stat__title">Relationship</h6> }

                                  {Array.isArray(this.state.currentBottomPanelData.relationship) && this.state.currentBottomPanelData.relationship.length > 0 &&                                    
                                    <>
                                      {/* <ul class="top-issue-list top-issue-list--vertical">
                                    <li className='top-issue-list__item'>
                                      <div class="node-wrap">
                                        <div class="node node--parent">
                                          <span className='label'>
                                            <i className='mr-1'>
                                              <FontAwesomeIcon icon={faLayerGroup} />
                                            </i>
                                            <span>Dataset 1</span>
                                          </span>
                                        </div>
                                        <div class="node node--child">
                                          <span className='label'>
                                            <i className='mr-1'>
                                              <FontAwesomeIcon icon={faTag} />
                                            </i>
                                            <span>Attribute</span>
                                          </span>
                                        </div>
                                      </div>
                                    </li>
                                    <li className='top-issue-list__item'>
                                      <div class="node-wrap">
                                        <div class="node node--parent">
                                          <span className='label'>
                                            <i className='mr-1'>
                                              <FontAwesomeIcon icon={faLayerGroup} />
                                            </i>
                                            <span>Dataset 2</span>
                                          </span>
                                        </div>
                                        <div class="node node--child">
                                          <span className='label'>
                                            <i className='mr-1'>
                                              <FontAwesomeIcon icon={faTag} />
                                            </i>
                                            <span>Attribute</span>
                                          </span>
                                        </div>
                                      </div>
                                    </li>
                                  </ul> */}

                                      <ul className="top-issue-list top-issue-list--vertical">
                                        {this.state.currentBottomPanelData.relationship.map((rel, index) => (
                                          <li className='top-issue-list__item' key={index}>
                                            <div className="node-wrap">
                                              <div className="node node--parent">
                                                <span className='label'>
                                                  <i className='mr-1'>
                                                    <FontAwesomeIcon icon={faLayerGroup} />
                                                  </i>
                                                  <span>{rel.data_set_name}</span>
                                                 </span>
                                              </div>
                                              <div className="node node--child">
                                                <span className='label'>
                                                  <i className='mr-1'>
                                                    <FontAwesomeIcon icon={faTag} />
                                                  </i>
                                                  <span>{rel.attribute_name}</span>
                                                </span>
                                              </div>
                                            </div>
                                          </li>
                                        ))}
                                      </ul>
                                    </>

                                    // :
                                    // <>
                                    //   <ul class="top-issue-list top-issue-list--vertical">
                                    //     <li className='top-issue-list__item'>
                                    //       <div class="node-wrap">
                                    //         NA
                                    //       </div>
                                    //     </li>

                                    //   </ul>
                                    // </>
                                  }
                                  <h6 className="qd-rt-stat__title">Top 20 frequency</h6>
                              {this.state.currentBottomPanelData?.top_20_frequency?.length > 0 ? (
                              <ParetoChart
                                data={this.state.currentBottomPanelData.top_20_frequency}
                                width={300}
                                height={300}
                                type={this.state.dataType}
                              />
                            ) : (
                              <div className="text-center text-muted py-5 w-100">
                                <h1><FontAwesomeIcon icon={faChartArea} /></h1>
                                <h6>Data distribution is not available for the selected attribute name</h6>
                                <h6>Please check after sometime.</h6>
                              </div>
                            )}
                                  {/* <img width={"100%"} src={barGraphAttribute} alt="" /> */}
                                    {/* <ParetoChart
                                      data = {this.state.currentBottomPanelData !== undefined && this.state.currentBottomPanelData.top_20_frequency	}
                                      width={300} height={300}
                                      type = {this.state.dataType}
                                      /> */}
                                </div>
                              </div>
                            }


                          </Scrollbars>
                        </>
                        :(this.state.isBottomPanelLoading ? <Load /> : 
                        
                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center",color: "#6b7280",fontSize: "14px" }} 
                                                        ><h1><FontAwesomeIcon icon={faChartArea} /></h1>&nbsp;
                                                        No data found
                                                        </div>
                                                        
                              // <div className="text-center text-muted py-5 w-100">
                              //   <h1><FontAwesomeIcon icon={faChartArea} /></h1>
                              //   <h6>No data found</h6>
                              //   <h6>Please check after sometime.</h6>
                              // </div>
                                                        
                                                        )}
                    </div>

                    <div className="qd-rt-stat">
                      {/* <div className="qd-rt-stat d-none"> */}
                      <>
                        <div className="qd-rt-stat__head">
                          <div className="qd-rt-stat-wrap">
                            <div className="icon-circle">
                              <FontAwesomeIcon icon={faTag}></FontAwesomeIcon>
                            </div>
                            <div className="content-stack">
                              <>
                                <h4>Age</h4>
                                <ol className="qd-rt-breadcrum">
                                  <li className="qd-rt-breadcrum-item"><span>serving_data.csv</span></li>
                                  <li className="qd-rt-breadcrum-item"><span>Clustering</span></li>
                                </ol>
                              </>
                            </div>
                          </div>
                          <div class="alert alert-sm moniker-alert text-body mb-0" role="alert">
                            <p className='m-0'>
                              <i className='mr-1'>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.99775 12.6347C8.30388 12.6347 7.67094 12.4589 7.09894 12.1074C6.52694 11.7559 6.08563 11.285 5.775 10.6946C5.70675 10.5735 5.6945 10.4461 5.73825 10.3125C5.78213 10.1789 5.86731 10.0873 5.99381 10.0378C6.10081 9.98831 6.20988 9.9885 6.321 10.0384C6.432 10.0883 6.51781 10.1681 6.57844 10.2778C6.81369 10.7186 7.147 11.0725 7.57837 11.3396C8.00975 11.6068 8.48363 11.7403 9 11.7403C9.75688 11.7403 10.4028 11.4728 10.9378 10.9378C11.4728 10.4028 11.7403 9.75688 11.7403 9C11.7403 8.24313 11.4728 7.59719 10.9378 7.06219C10.4028 6.52719 9.75688 6.25969 9 6.25969C8.5875 6.25969 8.20094 6.34619 7.84031 6.51919C7.47981 6.69231 7.16013 6.93269 6.88125 7.24031H7.6875C7.81663 7.24031 7.92344 7.28256 8.00794 7.36706C8.09244 7.45144 8.13469 7.55813 8.13469 7.68712C8.13469 7.81625 8.09244 7.92313 8.00794 8.00775C7.92344 8.09238 7.81663 8.13469 7.6875 8.13469H6.04331C5.85119 8.13469 5.69019 8.06969 5.56031 7.93969C5.43031 7.80981 5.36531 7.64881 5.36531 7.45669V5.8125C5.36531 5.68338 5.40756 5.57656 5.49206 5.49206C5.57644 5.40756 5.68313 5.36531 5.81213 5.36531C5.94125 5.36531 6.04812 5.40756 6.13275 5.49206C6.21737 5.57656 6.25969 5.68338 6.25969 5.8125V6.59288C6.62219 6.21688 7.03925 5.91831 7.51087 5.69719C7.9825 5.47594 8.47888 5.36531 9 5.36531C10.0086 5.36531 10.8666 5.71894 11.5738 6.42619C12.2811 7.13344 12.6347 7.99137 12.6347 9C12.6347 10.0086 12.2811 10.8666 11.5738 11.5738C10.8666 12.2811 10.0079 12.6347 8.99775 12.6347ZM3.98081 15.375C3.60194 15.375 3.28125 15.2438 3.01875 14.9813C2.75625 14.7188 2.625 14.3981 2.625 14.0192V11.8125C2.625 11.6531 2.67894 11.5195 2.78681 11.4116C2.89469 11.3039 3.02831 11.25 3.18769 11.25C3.34719 11.25 3.48075 11.3039 3.58838 11.4116C3.69613 11.5195 3.75 11.6531 3.75 11.8125V14.0192C3.75 14.0769 3.77406 14.1298 3.82219 14.1778C3.87019 14.2259 3.92306 14.25 3.98081 14.25H6.1875C6.34688 14.25 6.4805 14.3039 6.58838 14.4118C6.69613 14.5197 6.75 14.6533 6.75 14.8127C6.75 14.9722 6.69613 15.1058 6.58838 15.2134C6.4805 15.3211 6.34688 15.375 6.1875 15.375H3.98081ZM14.0192 15.375H11.8125C11.6531 15.375 11.5195 15.3211 11.4116 15.2132C11.3039 15.1053 11.25 14.9717 11.25 14.8123C11.25 14.6528 11.3039 14.5192 11.4116 14.4116C11.5195 14.3039 11.6531 14.25 11.8125 14.25H14.0192C14.0769 14.25 14.1298 14.2259 14.1778 14.1778C14.2259 14.1298 14.25 14.0769 14.25 14.0192V11.8125C14.25 11.6531 14.3039 11.5195 14.4118 11.4116C14.5197 11.3039 14.6533 11.25 14.8127 11.25C14.9722 11.25 15.1058 11.3039 15.2134 11.4116C15.3211 11.5195 15.375 11.6531 15.375 11.8125V14.0192C15.375 14.3981 15.2438 14.7188 14.9813 14.9813C14.7188 15.2438 14.3981 15.375 14.0192 15.375ZM2.625 6.1875V3.98081C2.625 3.60194 2.75625 3.28125 3.01875 3.01875C3.28125 2.75625 3.60194 2.625 3.98081 2.625H6.1875C6.34688 2.625 6.4805 2.67894 6.58838 2.78681C6.69613 2.89469 6.75 3.02831 6.75 3.18769C6.75 3.34719 6.69613 3.48075 6.58838 3.58838C6.4805 3.69613 6.34688 3.75 6.1875 3.75H3.98081C3.92306 3.75 3.87019 3.77406 3.82219 3.82219C3.77406 3.87019 3.75 3.92306 3.75 3.98081V6.1875C3.75 6.34688 3.69606 6.4805 3.58819 6.58838C3.48031 6.69613 3.34669 6.75 3.18731 6.75C3.02781 6.75 2.89425 6.69613 2.78662 6.58838C2.67887 6.4805 2.625 6.34688 2.625 6.1875ZM14.25 6.1875V3.98081C14.25 3.92306 14.2259 3.87019 14.1778 3.82219C14.1298 3.77406 14.0769 3.75 14.0192 3.75H11.8125C11.6531 3.75 11.5195 3.69606 11.4116 3.58819C11.3039 3.48031 11.25 3.34669 11.25 3.18731C11.25 3.02781 11.3039 2.89425 11.4116 2.78662C11.5195 2.67887 11.6531 2.625 11.8125 2.625H14.0192C14.3981 2.625 14.7188 2.75625 14.9813 3.01875C15.2438 3.28125 15.375 3.60194 15.375 3.98081V6.1875C15.375 6.34688 15.3211 6.4805 15.2132 6.58838C15.1053 6.69613 14.9717 6.75 14.8123 6.75C14.6528 6.75 14.5192 6.69613 14.4116 6.58838C14.3039 6.4805 14.25 6.34688 14.25 6.1875Z" fill="#5F6368" />
                                </svg>
                              </i>
                              Last profiled at <strong>Wed, 31 Jan 2024 09:18:30 GMT</strong>
                            </p>
                          </div>
                        </div>
                        <Scrollbars className="custom-scrollbar"
                          autoHeightMin={0}
                          style={{ height: 'calc(100% - 66px)' }}
                          autoHeightMax="100%"
                          thumbMinSize={30}
                          universal={true}
                        >
                          <div style={{ paddingBottom: '10px' }}>
                            <div className="qd-rt-stat__body clearfix">
                              <ul className="rt-stat-tags mb-5px">
                                <li className='rt-stat-tag rt-stat-tag--light-blue'>
                                  <span className="value">integer</span>
                                  <label>Type</label>
                                </li>
                                <li className='rt-stat-tag rt-stat-tag--light-blue'>
                                  <span className="value">NA</span>
                                  <label>Bussiness rule</label>
                                </li>
                              </ul>
                              <ul className="rt-stat-tags">
                                <li className='rt-stat-tag'>
                                  <span className="value">22</span>
                                  <label>Null Values</label>
                                </li>
                                <li className='rt-stat-tag'>
                                  <span className="value">22</span>
                                  <label>Unique Values</label>
                                </li>
                                <li className='rt-stat-tag'>
                                  <span className="value">34</span>
                                  <label>Duplicate Values</label>
                                </li>
                              </ul>
                              <h6 className="qd-rt-stat__title">Top 3 DQ errors in the attribute</h6>
                              <div className="qd-rt-summary">
                                <div className="qd-rt-summary_item">
                                  <span className="qd-rt-summary_label">Metric Name 1</span>
                                  <strong className="qd-rt-summary_value">6/12</strong>
                                </div>
                                <div className="qd-rt-summary_item">
                                  <span className="qd-rt-summary_label">Metric Name 2</span>
                                  <strong className="qd-rt-summary_value">5/12</strong>
                                </div>
                                <div className="qd-rt-summary_item">
                                  <span className="qd-rt-summary_label">Metric Name 3</span>
                                  <strong className="qd-rt-summary_value">20/50</strong>
                                </div>
                              </div>
                              <h6 className="qd-rt-stat__title">No. Partitions having DQ errors in the attributes:</h6>
                              <ul className="rt-stat-tags">
                                <li className="rt-stat-tag">
                                  <span className="value">22</span>
                                  <label>Partitions</label>
                                </li>
                              </ul>
                              <h6 className="qd-rt-stat__title">Top 3 partitions having issues in</h6>
                              <ul class="top-issue-list top-issue-list--vertical">
                                <li className='top-issue-list__item'>
                                  <span className='label'>
                                    <i className='mr-1'>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 7.94595L2.29089 5.46934C1.90304 5.29333 1.90304 4.70693 2.29089 4.53092L7.75069 2.05431C7.82898 2.01852 7.9141 2 8.0002 2C8.0863 2 8.17126 2.01852 8.24955 2.05431L13.7089 4.53116C14.0967 4.70716 14.0967 5.29333 13.7089 5.46934L12.0398 6.2265C11.7292 6.07773 11.3869 6 11.0258 6C10.3872 6 9.80749 6.2429 9.35844 6.6918C9.06563 6.98466 8.86039 7.3332 8.75313 7.71741L8.24939 7.94595C8.09005 8.01837 7.90971 8.01837 7.75037 7.94595ZM8.67696 8.58519L8.55929 8.63852C8.38204 8.7189 8.19389 8.75968 8.00004 8.75968C7.80619 8.75968 7.6182 8.7189 7.4408 8.63852L3.65271 6.92128L2.29089 7.53838C1.90304 7.71415 1.90304 8.30008 2.29089 8.47586L7.75037 10.9506C7.90971 11.0228 8.09005 11.0228 8.24939 10.9506L9.17956 10.529V9.82247C9.11967 9.74811 9.06384 9.66984 9.01225 9.58777C8.81352 9.27158 8.70837 8.929 8.67696 8.58519ZM9.17956 11.3573L8.55929 11.6385C8.38204 11.7189 8.19389 11.7596 8.00004 11.7596C7.80619 11.7596 7.6182 11.7189 7.4408 11.6385L3.6475 9.91888L2.29089 10.5337C1.90304 10.7094 1.90304 11.2953 2.29089 11.4711L7.75037 13.9459C7.90971 14.018 8.09005 14.018 8.24939 13.9459L8.78015 13.7053C8.70528 13.474 8.66671 13.2289 8.66671 12.9744C8.66671 12.5554 8.7699 12.1354 9.0033 11.7534C9.02917 11.7111 9.05619 11.6697 9.08435 11.6293C9.11479 11.5856 9.14652 11.543 9.17956 11.5016V11.3573Z" fill="#78829D" />
                                        <path d="M11.0256 14C10.7436 14 10.5021 13.8996 10.3013 13.6987C10.1004 13.4979 10 13.2564 10 12.9744C10 12.7778 10.047 12.6026 10.141 12.4487C10.235 12.2949 10.359 12.1709 10.5128 12.0769V9.24359C10.359 9.14957 10.235 9.02778 10.141 8.87821C10.047 8.72863 10 8.55556 10 8.35897C10 8.07692 10.1004 7.83547 10.3013 7.63462C10.5021 7.43376 10.7436 7.33333 11.0256 7.33333C11.3077 7.33333 11.5491 7.43376 11.75 7.63462C11.9509 7.83547 12.0513 8.07692 12.0513 8.35897C12.0513 8.55556 12.0043 8.72863 11.9103 8.87821C11.8162 9.02778 11.6923 9.14957 11.5385 9.24359V10.7179L13.5897 10.0385V9.24359C13.4359 9.14957 13.312 9.02778 13.2179 8.87821C13.1239 8.72863 13.0769 8.55556 13.0769 8.35897C13.0769 8.07692 13.1773 7.83547 13.3782 7.63462C13.5791 7.43376 13.8205 7.33333 14.1026 7.33333C14.3846 7.33333 14.6261 7.43376 14.8269 7.63462C15.0278 7.83547 15.1282 8.07692 15.1282 8.35897C15.1282 8.55556 15.0812 8.72863 14.9872 8.87821C14.8932 9.02778 14.7692 9.14957 14.6154 9.24359V10.0256C14.6154 10.2479 14.5513 10.4487 14.4231 10.6282C14.2949 10.8077 14.1239 10.9316 13.9103 11L11.5385 11.7949V12.0769C11.6923 12.1709 11.8162 12.2949 11.9103 12.4487C12.0043 12.6026 12.0513 12.7778 12.0513 12.9744C12.0513 13.2564 11.9509 13.4979 11.75 13.6987C11.5491 13.8996 11.3077 14 11.0256 14Z" fill="#78829D" />
                                      </svg>
                                    </i>Name</span>
                                </li>
                                <li className='top-issue-list__item'>
                                  <span className='label'>
                                    <i className='mr-1'>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 7.94595L2.29089 5.46934C1.90304 5.29333 1.90304 4.70693 2.29089 4.53092L7.75069 2.05431C7.82898 2.01852 7.9141 2 8.0002 2C8.0863 2 8.17126 2.01852 8.24955 2.05431L13.7089 4.53116C14.0967 4.70716 14.0967 5.29333 13.7089 5.46934L12.0398 6.2265C11.7292 6.07773 11.3869 6 11.0258 6C10.3872 6 9.80749 6.2429 9.35844 6.6918C9.06563 6.98466 8.86039 7.3332 8.75313 7.71741L8.24939 7.94595C8.09005 8.01837 7.90971 8.01837 7.75037 7.94595ZM8.67696 8.58519L8.55929 8.63852C8.38204 8.7189 8.19389 8.75968 8.00004 8.75968C7.80619 8.75968 7.6182 8.7189 7.4408 8.63852L3.65271 6.92128L2.29089 7.53838C1.90304 7.71415 1.90304 8.30008 2.29089 8.47586L7.75037 10.9506C7.90971 11.0228 8.09005 11.0228 8.24939 10.9506L9.17956 10.529V9.82247C9.11967 9.74811 9.06384 9.66984 9.01225 9.58777C8.81352 9.27158 8.70837 8.929 8.67696 8.58519ZM9.17956 11.3573L8.55929 11.6385C8.38204 11.7189 8.19389 11.7596 8.00004 11.7596C7.80619 11.7596 7.6182 11.7189 7.4408 11.6385L3.6475 9.91888L2.29089 10.5337C1.90304 10.7094 1.90304 11.2953 2.29089 11.4711L7.75037 13.9459C7.90971 14.018 8.09005 14.018 8.24939 13.9459L8.78015 13.7053C8.70528 13.474 8.66671 13.2289 8.66671 12.9744C8.66671 12.5554 8.7699 12.1354 9.0033 11.7534C9.02917 11.7111 9.05619 11.6697 9.08435 11.6293C9.11479 11.5856 9.14652 11.543 9.17956 11.5016V11.3573Z" fill="#78829D" />
                                        <path d="M11.0256 14C10.7436 14 10.5021 13.8996 10.3013 13.6987C10.1004 13.4979 10 13.2564 10 12.9744C10 12.7778 10.047 12.6026 10.141 12.4487C10.235 12.2949 10.359 12.1709 10.5128 12.0769V9.24359C10.359 9.14957 10.235 9.02778 10.141 8.87821C10.047 8.72863 10 8.55556 10 8.35897C10 8.07692 10.1004 7.83547 10.3013 7.63462C10.5021 7.43376 10.7436 7.33333 11.0256 7.33333C11.3077 7.33333 11.5491 7.43376 11.75 7.63462C11.9509 7.83547 12.0513 8.07692 12.0513 8.35897C12.0513 8.55556 12.0043 8.72863 11.9103 8.87821C11.8162 9.02778 11.6923 9.14957 11.5385 9.24359V10.7179L13.5897 10.0385V9.24359C13.4359 9.14957 13.312 9.02778 13.2179 8.87821C13.1239 8.72863 13.0769 8.55556 13.0769 8.35897C13.0769 8.07692 13.1773 7.83547 13.3782 7.63462C13.5791 7.43376 13.8205 7.33333 14.1026 7.33333C14.3846 7.33333 14.6261 7.43376 14.8269 7.63462C15.0278 7.83547 15.1282 8.07692 15.1282 8.35897C15.1282 8.55556 15.0812 8.72863 14.9872 8.87821C14.8932 9.02778 14.7692 9.14957 14.6154 9.24359V10.0256C14.6154 10.2479 14.5513 10.4487 14.4231 10.6282C14.2949 10.8077 14.1239 10.9316 13.9103 11L11.5385 11.7949V12.0769C11.6923 12.1709 11.8162 12.2949 11.9103 12.4487C12.0043 12.6026 12.0513 12.7778 12.0513 12.9744C12.0513 13.2564 11.9509 13.4979 11.75 13.6987C11.5491 13.8996 11.3077 14 11.0256 14Z" fill="#78829D" />
                                      </svg>
                                    </i>Age</span>
                                </li>
                                <li className='top-issue-list__item'>
                                  <span className='label'>
                                    <i className='mr-1'>
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.75037 7.94595L2.29089 5.46934C1.90304 5.29333 1.90304 4.70693 2.29089 4.53092L7.75069 2.05431C7.82898 2.01852 7.9141 2 8.0002 2C8.0863 2 8.17126 2.01852 8.24955 2.05431L13.7089 4.53116C14.0967 4.70716 14.0967 5.29333 13.7089 5.46934L12.0398 6.2265C11.7292 6.07773 11.3869 6 11.0258 6C10.3872 6 9.80749 6.2429 9.35844 6.6918C9.06563 6.98466 8.86039 7.3332 8.75313 7.71741L8.24939 7.94595C8.09005 8.01837 7.90971 8.01837 7.75037 7.94595ZM8.67696 8.58519L8.55929 8.63852C8.38204 8.7189 8.19389 8.75968 8.00004 8.75968C7.80619 8.75968 7.6182 8.7189 7.4408 8.63852L3.65271 6.92128L2.29089 7.53838C1.90304 7.71415 1.90304 8.30008 2.29089 8.47586L7.75037 10.9506C7.90971 11.0228 8.09005 11.0228 8.24939 10.9506L9.17956 10.529V9.82247C9.11967 9.74811 9.06384 9.66984 9.01225 9.58777C8.81352 9.27158 8.70837 8.929 8.67696 8.58519ZM9.17956 11.3573L8.55929 11.6385C8.38204 11.7189 8.19389 11.7596 8.00004 11.7596C7.80619 11.7596 7.6182 11.7189 7.4408 11.6385L3.6475 9.91888L2.29089 10.5337C1.90304 10.7094 1.90304 11.2953 2.29089 11.4711L7.75037 13.9459C7.90971 14.018 8.09005 14.018 8.24939 13.9459L8.78015 13.7053C8.70528 13.474 8.66671 13.2289 8.66671 12.9744C8.66671 12.5554 8.7699 12.1354 9.0033 11.7534C9.02917 11.7111 9.05619 11.6697 9.08435 11.6293C9.11479 11.5856 9.14652 11.543 9.17956 11.5016V11.3573Z" fill="#78829D" />
                                        <path d="M11.0256 14C10.7436 14 10.5021 13.8996 10.3013 13.6987C10.1004 13.4979 10 13.2564 10 12.9744C10 12.7778 10.047 12.6026 10.141 12.4487C10.235 12.2949 10.359 12.1709 10.5128 12.0769V9.24359C10.359 9.14957 10.235 9.02778 10.141 8.87821C10.047 8.72863 10 8.55556 10 8.35897C10 8.07692 10.1004 7.83547 10.3013 7.63462C10.5021 7.43376 10.7436 7.33333 11.0256 7.33333C11.3077 7.33333 11.5491 7.43376 11.75 7.63462C11.9509 7.83547 12.0513 8.07692 12.0513 8.35897C12.0513 8.55556 12.0043 8.72863 11.9103 8.87821C11.8162 9.02778 11.6923 9.14957 11.5385 9.24359V10.7179L13.5897 10.0385V9.24359C13.4359 9.14957 13.312 9.02778 13.2179 8.87821C13.1239 8.72863 13.0769 8.55556 13.0769 8.35897C13.0769 8.07692 13.1773 7.83547 13.3782 7.63462C13.5791 7.43376 13.8205 7.33333 14.1026 7.33333C14.3846 7.33333 14.6261 7.43376 14.8269 7.63462C15.0278 7.83547 15.1282 8.07692 15.1282 8.35897C15.1282 8.55556 15.0812 8.72863 14.9872 8.87821C14.8932 9.02778 14.7692 9.14957 14.6154 9.24359V10.0256C14.6154 10.2479 14.5513 10.4487 14.4231 10.6282C14.2949 10.8077 14.1239 10.9316 13.9103 11L11.5385 11.7949V12.0769C11.6923 12.1709 11.8162 12.2949 11.9103 12.4487C12.0043 12.6026 12.0513 12.7778 12.0513 12.9744C12.0513 13.2564 11.9509 13.4979 11.75 13.6987C11.5491 13.8996 11.3077 14 11.0256 14Z" fill="#78829D" />
                                      </svg>
                                    </i>DOB</span>
                                </li>
                              </ul>
                              <h6 className="qd-rt-stat__title">Relationship</h6>
                              <ul class="top-issue-list top-issue-list--vertical">
                                <li className='top-issue-list__item'>
                                  <div class="node-wrap">
                                    <div class="node node--parent">
                                      <span className='label'>
                                        <i className='mr-1'>
                                          <FontAwesomeIcon icon={faLayerGroup} />
                                        </i>
                                        <span>Dataset 1</span>
                                      </span>
                                    </div>
                                    <div class="node node--child">
                                      <span className='label'>
                                        <i className='mr-1'>
                                          <FontAwesomeIcon icon={faTag} />
                                        </i>
                                        <span>Attribute</span>
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li className='top-issue-list__item'>
                                  <div class="node-wrap">
                                    <div class="node node--parent">
                                      <span className='label'>
                                        <i className='mr-1'>
                                          <FontAwesomeIcon icon={faLayerGroup} />
                                        </i>
                                        <span>Dataset 2</span>
                                      </span>
                                    </div>
                                    <div class="node node--child">
                                      <span className='label'>
                                        <i className='mr-1'>
                                          <FontAwesomeIcon icon={faTag} />
                                        </i>
                                        <span>Attribute</span>
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                              <h6 className="qd-rt-stat__title">Top 20 frequency</h6>
                              {/* <img width={"100%"} src={barGraphAttribute} alt="" /> */}
                              <ParetoChart
                                data = {this.state.currentBottomPanelData !== undefined && this.state.currentBottomPanelData.top_20_frequency	}
                                width={300} height={300} 
                                type = {this.state.dataType}
                                />
                            </div>
                          </div>
                        </Scrollbars>
                      </>
                    </div>
                  </div>
                  {/* Alert Aside */}
                  {/* <div className="qd-rt_alert-aside d-none"> */}
                  <div className="qd-rt_alert-aside d-none">
                    <div className="qd-rt_aside-header">
                      <div className="caption">
                        <span>Alerts</span>
                      </div>
                      <div className="actions">
                        <div className="action-btn">
                          <FontAwesomeIcon icon={faEllipsisV}></FontAwesomeIcon>
                        </div>
                      </div>
                    </div>
                    <div className="qd-rt_aside-body">
                      <div className="rt-placeholder-msg">
                        <div className="rt-placeholder-msg__icon">
                          <Image src="icon_alert_plus" />
                        </div>
                        <p className='rt-placeholder-msg__desc'>Alerts are immediate notifications when your conditions are met. Create your first alert to get started!</p>
                        <button className='btn btn-outline btn-grey btn-circle'>Create Alert</button>
                      </div>
                    </div>
                  </div>
                  {/* Notification Aside */}
                  <div className="qd-rt_notification-aside bg-white h-100 d-none">
                    <div className="qd-rt_aside-header">
                      <div className="caption">
                        <span>Notification</span>
                      </div>
                      <div className="actions">
                        <Dropdown alignRight>
                          <Dropdown.Toggle variant="" id="dropdown-basic" className="action-btn dropdown-caret-hide">
                            <FontAwesomeIcon icon={faEllipsisV}></FontAwesomeIcon>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item href="#/action-1">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="All"
                                custom
                              />
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-2">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="Model Error"
                                custom
                              />
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-3">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="Data Quality Error"
                                custom
                              />
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-3">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="Model Monitoring Metrics Alert"
                                custom
                              />
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-3">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="Model Dataset Not Refreshed"
                                custom
                              />
                            </Dropdown.Item>
                            <Dropdown.Item href="#/action-3">
                              <Form.Check
                                type="checkbox"
                                id="customControlAutosizing"
                                label="Datatype Mismatch Found"
                                custom
                              />
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="qd-rt_aside-body">
                      <div className="qd-search-bar has-btn-close">
                        <div className="input-group border">
                          <div className="input-group-prepend">
                            <button id="button-addon4" type="button" className="btn">
                              <svg className='d-block' width="20" height="20" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.889 12.5237L10.35 9.98474C10.1222 9.75694 9.75283 9.75694 9.52502 9.98474C9.29722 10.2126 9.29722 10.5819 9.52502 10.8097L12.064 13.3487C12.2918 13.5765 12.6612 13.5765 12.889 13.3487C13.1168 13.1209 13.1168 12.7515 12.889 12.5237Z" fill="#99A1B7" />
                                <path d="M6.41667 11.8333C3.82408 11.8333 1.75 9.75923 1.75 7.16667C1.75 4.57408 3.82408 2.5 6.41667 2.5C9.00923 2.5 11.0833 4.57408 11.0833 7.16667C11.0833 9.75923 9.00923 11.8333 6.41667 11.8333ZM6.41667 3.66667C4.39444 3.66667 2.91667 5.14444 2.91667 7.16667C2.91667 9.18891 4.39444 10.6667 6.41667 10.6667C8.43891 10.6667 9.91667 9.18891 9.91667 7.16667C9.91667 5.14444 8.43891 3.66667 6.41667 3.66667Z" fill="#99A1B7" />
                              </svg>
                            </button>
                          </div>
                          <input type="search" placeholder="Search here..." className="form-control" />
                        </div>
                        <button className="btn btn-clear" title="clear"><i className="icon-close"></i></button>
                      </div>
                      <div className="user-notification-block">
                        <div className="user-notification__title">
                          <span className="caption">This Week</span>
                        </div>
                        <div className="user-notification__body">
                          <div className="list-group">
                            <div className="user-notification__list">
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>ML Metrics</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="settings-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faExclamationTriangle} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Dataset Deletion</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="user-notification-block">
                        <div className="user-notification__title">
                          <span className="caption">This Month</span>
                        </div>
                        <div className="user-notification__body">
                          <div className="list-group">
                            <div className="user-notification__list">
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>ML Metrics</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="settings-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faExclamationTriangle} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Dataset Deletion</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="user-notification-block">
                        <div className="user-notification__title">
                          <span className="caption">Earlier</span>
                        </div>
                        <div className="user-notification__body">
                          <div className="list-group">
                            <div className="user-notification__list">
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>ML Metrics</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="app-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faServer} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Data Quality Errors</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                              <ListGroup.Item className="settings-notification unread">
                                <div className="notification-icon">
                                  <span>
                                    <FontAwesomeIcon color="#fff" icon={faExclamationTriangle} />
                                  </span>
                                </div>
                                <div className="notification-content">
                                  <div className="list-group-item-content">
                                    <h5>Dataset Deletion</h5>
                                    <small>9 Mins ago</small>
                                  </div>
                                  <p>Data quality gate failed for the dataset bba_data-aggregate.csv</p>
                                </div>
                              </ListGroup.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Layout Main Content */}
              {this.state.integrationRequest !== undefined && this.state.integrationRequest.length !== 0 &&
                <div className="qd-rt_main-content ">
                  <div className="qd-toolbar" onClick={this.handleScrollToolbar} onScroll={this.handleScrollToolbar}>
                    <div className="qd-toolbar-wrap">
                      <div className="qd-toolbar-left">
                        <div className="qd-toolbar-col">
                          <div className="qd-toolbar-btn toolbar-highlight justify-content-start" onClick={this.handleOpenAutoCompleteModal} style={{ minWidth: '250px' }}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16.5721 15.1366L13.3077 11.8721C13.0148 11.5792 12.5399 11.5792 12.247 11.8721C11.9541 12.165 11.9541 12.6399 12.247 12.9328L15.5114 16.1972C15.8043 16.4901 16.2792 16.4901 16.5721 16.1972C16.865 15.9043 16.865 15.4294 16.5721 15.1366Z" fill="currentColor" />
                              <path d="M8.25 14.25C4.91667 14.25 2.25 11.5833 2.25 8.25C2.25 4.91667 4.91667 2.25 8.25 2.25C11.5833 2.25 14.25 4.91667 14.25 8.25C14.25 11.5833 11.5833 14.25 8.25 14.25ZM8.25 3.75C5.65 3.75 3.75 5.65 3.75 8.25C3.75 10.85 5.65 12.75 8.25 12.75C10.85 12.75 12.75 10.85 12.75 8.25C12.75 5.65 10.85 3.75 8.25 3.75Z" fill="currentColor" />
                            </svg>
                            {this.state.preSelectedAttribute !== null ?
                              <span className="qd-toolbar-text">{normalizeAttributeName(preSelectedAttribute['label'])}</span>
                              :
                              <span className="qd-toolbar-text">{this.state.selectedDatasetName}</span>
                            }
                            {/* <span className="qd-toolbar-text"></span> */}
                            {/* Add Animated spinner Loader */}
                            {/* <Image width="12px" src={"icon_preloader"} alt="loader" className="ml-2" /> */}
                          </div>
                        </div>
                        {/* <div className="qd-toolbar-col">
                                <div className="qd-toolbar_dropdown-wrap" id="topmenuduration" onClick={this.swDropdownOpen.bind(this, "topmenuduration")}>
                                  <div className="qd-toolbar-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                                      <g id="Group_4886" data-name="Group 4886" transform="translate(-984 -3496)">
                                        <rect id="Rectangle_2838" data-name="Rectangle 2838" width="24" height="24" transform="translate(984 3496)" fill="none" />
                                        <g id="Group_4883" data-name="Group 4883" transform="translate(-0.2 -0.5)">
                                          <g id="log-in" transform="translate(985 3501)">
                                            <path id="Path_1423" data-name="Path 1423" d="M10,14.75a.75.75,0,0,1-.53-1.28l2.97-2.97L9.47,7.53A.75.75,0,1,1,10.53,6.47l3.5,3.5a.75.75,0,0,1,0,1.061l-3.5,3.5A.748.748,0,0,1,10,14.75Z" transform="translate(-2.1)" />
                                            <path id="Line_33" data-name="Line 33" d="M8.4.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H8.4A.75.75,0,0,1,9.15,0,.75.75,0,0,1,8.4.75Z" transform="translate(3 10.5)" />
                                          </g>
                                          <g id="log-in-2" data-name="log-in" transform="translate(996 3502)">
                                            <path id="Path_1423-2" data-name="Path 1423" d="M13.5,14.75a.748.748,0,0,1-.53-.22l-3.5-3.5a.75.75,0,0,1,0-1.061l3.5-3.5A.75.75,0,0,1,14.03,7.53l-2.97,2.97,2.97,2.97a.75.75,0,0,1-.53,1.28Z" transform="translate(-10 -7)" />
                                            <path id="Line_33-2" data-name="Line 33" d="M8.4.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H8.4A.75.75,0,0,1,9.15,0,.75.75,0,0,1,8.4.75Z" transform="translate(0 3.5)" />
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                    <span className="qd-toolbar-text">Compare</span>
                                  </div>
                                </div>
                              </div> */}
                        <div className="qd-toolbar-col">
                          <div className={this.state.selectedTopMenu === "topmenugraph" ? "qd-toolbar_dropdown-wrap open" : "qd-toolbar_dropdown-wrap"} id="topmenugraph" onClick={this.swDropdownOpen.bind(this, "topmenugraph")}>
                            <div className="qd-toolbar-btn" style={{ minWidth: '103px' }}>
                              {
                                selectedChart === "Area" ?
                                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.23047 18.8086V19.8086H4.23047V18.8086H3.23047Z" fill="currentColor" />
                                    <path d="M4.23047 19.8086V20.8086H5.23047V19.8086H4.23047Z" fill="currentColor" />
                                    <path d="M2.23047 19.8086V20.8086H3.23047V19.8086H2.23047Z" fill="currentColor" />
                                    <path d="M2.23047 17.8086V18.8086H3.23047V17.8086H2.23047Z" fill="currentColor" />
                                    <path d="M6.23047 19.8086V20.8086H7.23047V19.8086H6.23047Z" fill="currentColor" />
                                    <path d="M8.23047 19.8086V20.8086H9.23047V19.8086H8.23047Z" fill="currentColor" />
                                    <path d="M10.2305 19.8086V20.8086H11.2305V19.8086H10.2305Z" fill="currentColor" />
                                    <path d="M12.2305 19.8086V20.8086H13.2305V19.8086H12.2305Z" fill="currentColor" />
                                    <path d="M14.2305 19.8086V20.8086H15.2305V19.8086H14.2305Z" fill="currentColor" />
                                    <path d="M16.2305 19.8086V20.8086H17.2305V19.8086H16.2305Z" fill="currentColor" />
                                    <path d="M18.2305 19.8086V20.8086H19.2305V19.8086H18.2305Z" fill="currentColor" />
                                    <path d="M20.2305 19.8086V20.8086H21.2305V19.8086H20.2305Z" fill="currentColor" />
                                    <path d="M5.23047 18.8086V19.8086H6.23047V18.8086H5.23047Z" fill="currentColor" />
                                    <path d="M7.23047 18.8086V19.8086H8.23047V18.8086H7.23047Z" fill="currentColor" />
                                    <path d="M9.23047 18.8086V19.8086H10.2305V18.8086H9.23047Z" fill="currentColor" />
                                    <path d="M11.2305 18.8086V19.8086H12.2305V18.8086H11.2305Z" fill="currentColor" />
                                    <path d="M13.2305 18.8086V19.8086H14.2305V18.8086H13.2305Z" fill="currentColor" />
                                    <path d="M15.2305 18.8086V19.8086H16.2305V18.8086H15.2305Z" fill="currentColor" />
                                    <path d="M17.2305 18.8086V19.8086H18.2305V18.8086H17.2305Z" fill="currentColor" />
                                    <path d="M19.2305 18.8086V19.8086H20.2305V18.8086H19.2305Z" fill="currentColor" />
                                    <path d="M6.23047 17.8086V18.8086H7.23047V17.8086H6.23047Z" fill="currentColor" />
                                    <path d="M8.23047 17.8086V18.8086H9.23047V17.8086H8.23047Z" fill="currentColor" />
                                    <path d="M10.2305 17.8086V18.8086H11.2305V17.8086H10.2305Z" fill="currentColor" />
                                    <path d="M7.23047 16.8086V17.8086H8.23047V16.8086H7.23047Z" fill="currentColor" />
                                    <path d="M9.23047 16.8086V17.8086H10.2305V16.8086H9.23047Z" fill="currentColor" />
                                    <path d="M8.23047 15.8086V16.8086H9.23047V15.8086H8.23047Z" fill="currentColor" />
                                    <path d="M9.23047 14.8086V15.8086H10.2305V14.8086H9.23047Z" fill="currentColor" />
                                    <path d="M10.2305 15.8086V16.8086H11.2305V15.8086H10.2305Z" fill="currentColor" />
                                    <path d="M11.2305 16.8086V17.8086H12.2305V16.8086H11.2305Z" fill="currentColor" />
                                    <path d="M12.2305 17.8086V18.8086H13.2305V17.8086H12.2305Z" fill="currentColor" />
                                    <path d="M14.2305 17.8086V18.8086H15.2305V17.8086H14.2305Z" fill="currentColor" />
                                    <path d="M16.2305 17.8086V18.8086H17.2305V17.8086H16.2305Z" fill="currentColor" />
                                    <path d="M18.2305 17.8086V18.8086H19.2305V17.8086H18.2305Z" fill="currentColor" />
                                    <path d="M20.2305 17.8086V18.8086H21.2305V17.8086H20.2305Z" fill="currentColor" />
                                    <path d="M13.2305 16.8086V17.8086H14.2305V16.8086H13.2305Z" fill="currentColor" />
                                    <path d="M15.2305 16.8086V17.8086H16.2305V16.8086H15.2305Z" fill="currentColor" />
                                    <path d="M17.2305 16.8086V17.8086H18.2305V16.8086H17.2305Z" fill="currentColor" />
                                    <path d="M19.2305 16.8086V17.8086H20.2305V16.8086H19.2305Z" fill="currentColor" />
                                    <path d="M14.2305 15.8086V16.8086H15.2305V15.8086H14.2305Z" fill="currentColor" />
                                    <path d="M16.2305 15.8086V16.8086H17.2305V15.8086H16.2305Z" fill="currentColor" />
                                    <path d="M18.2305 15.8086V16.8086H19.2305V15.8086H18.2305Z" fill="currentColor" />
                                    <path d="M20.2305 15.8086V16.8086H21.2305V15.8086H20.2305Z" fill="currentColor" />
                                    <path d="M15.2305 14.8086V15.8086H16.2305V14.8086H15.2305Z" fill="currentColor" />
                                    <path d="M17.2305 14.8086V15.8086H18.2305V14.8086H17.2305Z" fill="currentColor" />
                                    <path d="M19.2305 14.8086V15.8086H20.2305V14.8086H19.2305Z" fill="currentColor" />
                                    <path d="M16.2305 13.8086V14.8086H17.2305V13.8086H16.2305Z" fill="currentColor" />
                                    <path d="M18.2305 13.8086V14.8086H19.2305V13.8086H18.2305Z" fill="currentColor" />
                                    <path d="M20.2305 13.8086V14.8086H21.2305V13.8086H20.2305Z" fill="currentColor" />
                                    <path d="M17.2305 12.8086V13.8086H18.2305V12.8086H17.2305Z" fill="currentColor" />
                                    <path d="M19.2305 12.8086V13.8086H20.2305V12.8086H19.2305Z" fill="currentColor" />
                                    <path d="M18.2305 11.8086V12.8086H19.2305V11.8086H18.2305Z" fill="currentColor" />
                                    <path d="M20.2305 11.8086V12.8086H21.2305V11.8086H20.2305Z" fill="currentColor" />
                                    <path d="M19.2305 10.8086V11.8086H20.2305V10.8086H19.2305Z" fill="currentColor" />
                                    <path d="M20.2305 9.80859V10.8086H21.2305V9.80859H20.2305Z" fill="currentColor" />
                                    <path d="M3.23047 16.8086V17.8086H4.23047V16.8086H3.23047Z" fill="currentColor" />
                                    <path d="M4.23047 17.8086V18.8086H5.23047V17.8086H4.23047Z" fill="currentColor" />
                                    <path d="M5.23047 16.8086V17.8086H6.23047V16.8086H5.23047Z" fill="currentColor" />
                                    <path d="M4.23047 15.8086V16.8086H5.23047V15.8086H4.23047Z" fill="currentColor" />
                                    <path d="M5.23047 14.8086V15.8086H6.23047V14.8086H5.23047Z" fill="currentColor" />
                                    <path d="M6.23047 15.8086V16.8086H7.23047V15.8086H6.23047Z" fill="currentColor" />
                                    <path d="M7.23047 14.8086V15.8086H8.23047V14.8086H7.23047Z" fill="currentColor" />
                                    <path d="M8.23047 13.8086V14.8086H9.23047V13.8086H8.23047Z" fill="currentColor" />
                                    <path d="M9.23047 12.8086V13.8086H10.2305V12.8086H9.23047Z" fill="currentColor" />
                                    <path d="M10.2305 13.8086V14.8086H11.2305V13.8086H10.2305Z" fill="currentColor" />
                                    <path d="M11.2305 14.8086V15.8086H12.2305V14.8086H11.2305Z" fill="currentColor" />
                                    <path d="M12.2305 15.8086V16.8086H13.2305V15.8086H12.2305Z" fill="currentColor" />
                                    <path d="M13.2305 14.8086V15.8086H14.2305V14.8086H13.2305Z" fill="currentColor" />
                                    <path d="M14.2305 13.8086V14.8086H15.2305V13.8086H14.2305Z" fill="currentColor" />
                                    <path d="M15.2305 12.8086V13.8086H16.2305V12.8086H15.2305Z" fill="currentColor" />
                                    <path d="M16.2305 11.8086V12.8086H17.2305V11.8086H16.2305Z" fill="currentColor" />
                                    <path d="M17.2305 10.8086V11.8086H18.2305V10.8086H17.2305Z" fill="currentColor" />
                                    <path d="M18.2305 9.80859V10.8086H19.2305V9.80859H18.2305Z" fill="currentColor" />
                                    <path d="M19.2305 8.80859V9.80859H20.2305V8.80859H19.2305Z" fill="currentColor" />
                                    <path d="M20.2305 7.80859V8.80859H21.2305V7.80859H20.2305Z" fill="currentColor" />
                                    <path d="M6.23047 13.8086V14.8086H7.23047V13.8086H6.23047Z" fill="currentColor" />
                                    <path d="M7.23047 12.8086V13.8086H8.23047V12.8086H7.23047Z" fill="currentColor" />
                                    <path d="M8.23047 11.8086V12.8086H9.23047V11.8086H8.23047Z" fill="currentColor" />
                                    <path d="M2.73075 15.5385L2 14.8077L8.80775 8L12.8078 12L19.7922 4L20.5 4.66925L12.8463 13.5L8.80775 9.4615L2.73075 15.5385Z" fill="currentColor" />
                                  </svg> :
                                  selectedChart === "Line" ?
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M3.50001 20.7308L2.76926 20L9.57701 13.1923L13.577 17.1923L20.5615 9.19226L21.2693 9.86151L13.6155 18.6923L9.57701 14.6538L3.50001 20.7308ZM3.50001 14.7308L2.76926 14L9.57701 7.19226L13.577 11.1923L20.5615 3.19226L21.2693 3.86151L13.6155 12.6923L9.57701 8.65376L3.50001 14.7308Z" fill="currentColor" />
                                    </svg>
                                    :
                                    selectedChart === "Bar" ?
                                      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 20V19H21V20H3ZM4 17.2308V12H6V17.2308H4ZM8.65375 17.2308V7H10.6537V17.2308H8.65375ZM13.327 17.2308V10H15.327V17.2308H13.327ZM18 17.2308V4H20V17.2308H18Z" fill="currentColor" />
                                      </svg> : ""
                              }
                              <span className="qd-toolbar-text">{selectedChart}</span>
                              <i class="icon-expand">
                                <svg className='d-block' width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 14.7078L6.69225 9.40001L7.4 8.69226L12 13.2923L16.6 8.69226L17.3078 9.40001L12 14.7078Z" fill="currentColor" />
                                </svg>
                              </i>
                            </div>
                            <div className="qd-toolbar_dropdown">
                              <a className={`qd-toolbar_dropdown-item ${selectedChart === "Area" ? "active" : ""}`} href='#!'
                                onClick={(event) => {
                                  event.preventDefault(); // Prevents scrolling to the top
                                  event.stopPropagation();
                                  this.renderChart("Area");
                                }}
                              >
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.23047 18.8086V19.8086H4.23047V18.8086H3.23047Z" fill="currentColor" />
                                  <path d="M4.23047 19.8086V20.8086H5.23047V19.8086H4.23047Z" fill="currentColor" />
                                  <path d="M2.23047 19.8086V20.8086H3.23047V19.8086H2.23047Z" fill="currentColor" />
                                  <path d="M2.23047 17.8086V18.8086H3.23047V17.8086H2.23047Z" fill="currentColor" />
                                  <path d="M6.23047 19.8086V20.8086H7.23047V19.8086H6.23047Z" fill="currentColor" />
                                  <path d="M8.23047 19.8086V20.8086H9.23047V19.8086H8.23047Z" fill="currentColor" />
                                  <path d="M10.2305 19.8086V20.8086H11.2305V19.8086H10.2305Z" fill="currentColor" />
                                  <path d="M12.2305 19.8086V20.8086H13.2305V19.8086H12.2305Z" fill="currentColor" />
                                  <path d="M14.2305 19.8086V20.8086H15.2305V19.8086H14.2305Z" fill="currentColor" />
                                  <path d="M16.2305 19.8086V20.8086H17.2305V19.8086H16.2305Z" fill="currentColor" />
                                  <path d="M18.2305 19.8086V20.8086H19.2305V19.8086H18.2305Z" fill="currentColor" />
                                  <path d="M20.2305 19.8086V20.8086H21.2305V19.8086H20.2305Z" fill="currentColor" />
                                  <path d="M5.23047 18.8086V19.8086H6.23047V18.8086H5.23047Z" fill="currentColor" />
                                  <path d="M7.23047 18.8086V19.8086H8.23047V18.8086H7.23047Z" fill="currentColor" />
                                  <path d="M9.23047 18.8086V19.8086H10.2305V18.8086H9.23047Z" fill="currentColor" />
                                  <path d="M11.2305 18.8086V19.8086H12.2305V18.8086H11.2305Z" fill="currentColor" />
                                  <path d="M13.2305 18.8086V19.8086H14.2305V18.8086H13.2305Z" fill="currentColor" />
                                  <path d="M15.2305 18.8086V19.8086H16.2305V18.8086H15.2305Z" fill="currentColor" />
                                  <path d="M17.2305 18.8086V19.8086H18.2305V18.8086H17.2305Z" fill="currentColor" />
                                  <path d="M19.2305 18.8086V19.8086H20.2305V18.8086H19.2305Z" fill="currentColor" />
                                  <path d="M6.23047 17.8086V18.8086H7.23047V17.8086H6.23047Z" fill="currentColor" />
                                  <path d="M8.23047 17.8086V18.8086H9.23047V17.8086H8.23047Z" fill="currentColor" />
                                  <path d="M10.2305 17.8086V18.8086H11.2305V17.8086H10.2305Z" fill="currentColor" />
                                  <path d="M7.23047 16.8086V17.8086H8.23047V16.8086H7.23047Z" fill="currentColor" />
                                  <path d="M9.23047 16.8086V17.8086H10.2305V16.8086H9.23047Z" fill="currentColor" />
                                  <path d="M8.23047 15.8086V16.8086H9.23047V15.8086H8.23047Z" fill="currentColor" />
                                  <path d="M9.23047 14.8086V15.8086H10.2305V14.8086H9.23047Z" fill="currentColor" />
                                  <path d="M10.2305 15.8086V16.8086H11.2305V15.8086H10.2305Z" fill="currentColor" />
                                  <path d="M11.2305 16.8086V17.8086H12.2305V16.8086H11.2305Z" fill="currentColor" />
                                  <path d="M12.2305 17.8086V18.8086H13.2305V17.8086H12.2305Z" fill="currentColor" />
                                  <path d="M14.2305 17.8086V18.8086H15.2305V17.8086H14.2305Z" fill="currentColor" />
                                  <path d="M16.2305 17.8086V18.8086H17.2305V17.8086H16.2305Z" fill="currentColor" />
                                  <path d="M18.2305 17.8086V18.8086H19.2305V17.8086H18.2305Z" fill="currentColor" />
                                  <path d="M20.2305 17.8086V18.8086H21.2305V17.8086H20.2305Z" fill="currentColor" />
                                  <path d="M13.2305 16.8086V17.8086H14.2305V16.8086H13.2305Z" fill="currentColor" />
                                  <path d="M15.2305 16.8086V17.8086H16.2305V16.8086H15.2305Z" fill="currentColor" />
                                  <path d="M17.2305 16.8086V17.8086H18.2305V16.8086H17.2305Z" fill="currentColor" />
                                  <path d="M19.2305 16.8086V17.8086H20.2305V16.8086H19.2305Z" fill="currentColor" />
                                  <path d="M14.2305 15.8086V16.8086H15.2305V15.8086H14.2305Z" fill="currentColor" />
                                  <path d="M16.2305 15.8086V16.8086H17.2305V15.8086H16.2305Z" fill="currentColor" />
                                  <path d="M18.2305 15.8086V16.8086H19.2305V15.8086H18.2305Z" fill="currentColor" />
                                  <path d="M20.2305 15.8086V16.8086H21.2305V15.8086H20.2305Z" fill="currentColor" />
                                  <path d="M15.2305 14.8086V15.8086H16.2305V14.8086H15.2305Z" fill="currentColor" />
                                  <path d="M17.2305 14.8086V15.8086H18.2305V14.8086H17.2305Z" fill="currentColor" />
                                  <path d="M19.2305 14.8086V15.8086H20.2305V14.8086H19.2305Z" fill="currentColor" />
                                  <path d="M16.2305 13.8086V14.8086H17.2305V13.8086H16.2305Z" fill="currentColor" />
                                  <path d="M18.2305 13.8086V14.8086H19.2305V13.8086H18.2305Z" fill="currentColor" />
                                  <path d="M20.2305 13.8086V14.8086H21.2305V13.8086H20.2305Z" fill="currentColor" />
                                  <path d="M17.2305 12.8086V13.8086H18.2305V12.8086H17.2305Z" fill="currentColor" />
                                  <path d="M19.2305 12.8086V13.8086H20.2305V12.8086H19.2305Z" fill="currentColor" />
                                  <path d="M18.2305 11.8086V12.8086H19.2305V11.8086H18.2305Z" fill="currentColor" />
                                  <path d="M20.2305 11.8086V12.8086H21.2305V11.8086H20.2305Z" fill="currentColor" />
                                  <path d="M19.2305 10.8086V11.8086H20.2305V10.8086H19.2305Z" fill="currentColor" />
                                  <path d="M20.2305 9.80859V10.8086H21.2305V9.80859H20.2305Z" fill="currentColor" />
                                  <path d="M3.23047 16.8086V17.8086H4.23047V16.8086H3.23047Z" fill="currentColor" />
                                  <path d="M4.23047 17.8086V18.8086H5.23047V17.8086H4.23047Z" fill="currentColor" />
                                  <path d="M5.23047 16.8086V17.8086H6.23047V16.8086H5.23047Z" fill="currentColor" />
                                  <path d="M4.23047 15.8086V16.8086H5.23047V15.8086H4.23047Z" fill="currentColor" />
                                  <path d="M5.23047 14.8086V15.8086H6.23047V14.8086H5.23047Z" fill="currentColor" />
                                  <path d="M6.23047 15.8086V16.8086H7.23047V15.8086H6.23047Z" fill="currentColor" />
                                  <path d="M7.23047 14.8086V15.8086H8.23047V14.8086H7.23047Z" fill="currentColor" />
                                  <path d="M8.23047 13.8086V14.8086H9.23047V13.8086H8.23047Z" fill="currentColor" />
                                  <path d="M9.23047 12.8086V13.8086H10.2305V12.8086H9.23047Z" fill="currentColor" />
                                  <path d="M10.2305 13.8086V14.8086H11.2305V13.8086H10.2305Z" fill="currentColor" />
                                  <path d="M11.2305 14.8086V15.8086H12.2305V14.8086H11.2305Z" fill="currentColor" />
                                  <path d="M12.2305 15.8086V16.8086H13.2305V15.8086H12.2305Z" fill="currentColor" />
                                  <path d="M13.2305 14.8086V15.8086H14.2305V14.8086H13.2305Z" fill="currentColor" />
                                  <path d="M14.2305 13.8086V14.8086H15.2305V13.8086H14.2305Z" fill="currentColor" />
                                  <path d="M15.2305 12.8086V13.8086H16.2305V12.8086H15.2305Z" fill="currentColor" />
                                  <path d="M16.2305 11.8086V12.8086H17.2305V11.8086H16.2305Z" fill="currentColor" />
                                  <path d="M17.2305 10.8086V11.8086H18.2305V10.8086H17.2305Z" fill="currentColor" />
                                  <path d="M18.2305 9.80859V10.8086H19.2305V9.80859H18.2305Z" fill="currentColor" />
                                  <path d="M19.2305 8.80859V9.80859H20.2305V8.80859H19.2305Z" fill="currentColor" />
                                  <path d="M20.2305 7.80859V8.80859H21.2305V7.80859H20.2305Z" fill="currentColor" />
                                  <path d="M6.23047 13.8086V14.8086H7.23047V13.8086H6.23047Z" fill="currentColor" />
                                  <path d="M7.23047 12.8086V13.8086H8.23047V12.8086H7.23047Z" fill="currentColor" />
                                  <path d="M8.23047 11.8086V12.8086H9.23047V11.8086H8.23047Z" fill="currentColor" />
                                  <path d="M2.73075 15.5385L2 14.8077L8.80775 8L12.8078 12L19.7922 4L20.5 4.66925L12.8463 13.5L8.80775 9.4615L2.73075 15.5385Z" fill="currentColor" />
                                </svg> Area
                              </a>
                              <a className={`qd-toolbar_dropdown-item ${selectedChart === "Bar" ? "active" : ""}`} href='#!'
                                onClick={(event) => {
                                  event.preventDefault(); // Prevents scrolling to the top
                                  event.stopPropagation();
                                  this.renderChart("Bar");
                                }}

                              >
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3 20V19H21V20H3ZM4 17.2308V12H6V17.2308H4ZM8.65375 17.2308V7H10.6537V17.2308H8.65375ZM13.327 17.2308V10H15.327V17.2308H13.327ZM18 17.2308V4H20V17.2308H18Z" fill="currentColor" />
                                </svg> Bar
                              </a>

                              <a className={`qd-toolbar_dropdown-item ${selectedChart === "Line" ? "active" : ""}`} href='#!'
                                onClick={(event) => {
                                  event.preventDefault()
                                  event.stopPropagation();
                                  this.renderChart("Line");
                                }}
                              >
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.50001 20.7308L2.76926 20L9.57701 13.1923L13.577 17.1923L20.5615 9.19226L21.2693 9.86151L13.6155 18.6923L9.57701 14.6538L3.50001 20.7308ZM3.50001 14.7308L2.76926 14L9.57701 7.19226L13.577 11.1923L20.5615 3.19226L21.2693 3.86151L13.6155 12.6923L9.57701 8.65376L3.50001 14.7308Z" fill="currentColor" />
                                </svg> Line
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="qd-toolbar-col d-none">
                          <div className="qd-toolbar_dropdown-wrap" id="topmenuaggregate" onClick={this.swDropdownOpen.bind(this, "topmenuaggregate")}>
                            <div className="qd-toolbar-btn" id="topmenudistance" style={{ minWidth: '120.26px' }}>
                              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13.3845L2.01926 8.19225L12 3L22 8.19225L12 13.3845ZM12 17.1923L2.59426 12.3058L3.63651 11.7327L12 16.052L20.3828 11.7327L21.425 12.3058L12 17.1923ZM12 21L2.59426 16.1135L3.63651 15.5405L12 19.8595L20.3828 15.5405L21.425 16.1135L12 21ZM12 12.2443L19.9213 8.19225L12 4.1405L4.09801 8.19225L12 12.2443Z" fill="currentColor" />
                              </svg>
                              <span className="qd-toolbar-text">Aggregate</span>
                              {/* <sup><FontAwesomeIcon icon={faExclamationCircle} className="text-danger" /></sup> */}
                            </div>
                            <div className="qd-toolbar_dropdown">
                              <a className="qd-toolbar_dropdown-item" href="#!">
                                <span className="qd-toolbar_dropdown-text">Min</span>
                              </a>
                              <a className="qd-toolbar_dropdown-item" href="#!">
                                <span className="qd-toolbar_dropdown-text">Max</span>
                              </a>
                              <a className="qd-toolbar_dropdown-item" href="#!">
                                <span className="qd-toolbar_dropdown-text">Self <span className="label label-danger">Error</span></span>
                              </a>
                              <a className="qd-toolbar_dropdown-item" href="#!">
                                <span className="qd-toolbar_dropdown-text">Mean</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>


<input 
  type="button" 
  className="btn btn-sm btn-default mb-3 d-none" 
  value="Stage" 
  onClick={() => this.pushResponseData(
{
  "latest_chart_data": {
    "732_1_attr": {
      "drift": 0,
      "time": "2026-02-24 08:44:21",
      "value": 200,
      "drift_patterns": "NO_DRIFT",
      "name": "Fill Rate",
      "error_rows": null,
      "metric_threshold_error_status": false,
      "metric_threshold_error_diff_value": 0,
      "contribution": null,
      "normalization_value": null,
      "data_type": null,
      "boxplot_data": null,
      "version_name": null,
      "drift_pattern": "NO_DRIFT",
      "metric_threshold": 80
    }
  },
  "latest_tree_data": {
    "732_1_attr": {
      "previous": "NA",
      "latest": 200,
      "error": false,
      "metric_id": "1",
      "name": "Fill Rate"
    }
  },
  "data_set_id": 232,
  "env_id": 4
}

)}
/>

<input 
  type="button" 
  className="btn btn-sm btn-default mb-3 d-none" 
  value="Run" 
  onClick={() => this.pushResponseData({"data_set_id":5,"env_id":1,"bottom_panel_data":{"5_dt":{"total_issues":1000,"total_attributes":12,"total_partitions":0,"attributes_with_issues_count":0,"partitions_with_issues_count":0,"metric_id_count_map":{},"top_three_attributes_with_issues":[],"top_three_partitions_with_issues":[],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":[{"attribute_name":"HttpResponse","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"New_col","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"IS_ACTIVE","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"URL","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"SSN_name_changed","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"IP_ADDRESS","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"WEBSITE","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"GENDER","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"EMAIL","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"TRANSACTION_DATE","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"CREDIT_CARD","value":57,"time":"2026-04-01 09:09:27"},{"attribute_name":"ID","value":57,"time":"2026-04-01 09:09:27"}],"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80},"2":{"drift":0,"time":"2026-04-01 09:09:27","value":57,"drift_patterns":"NO_DRIFT","name":"Row Count","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":[],"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":30,"avg_row_count":0,"deviation_percentage":0},"3":{"drift":42,"time":"2026-04-02 05:51:22","value":42,"drift_patterns":"Threshold Alert","name":"Recency","error_rows":null,"metric_threshold_error_status":true,"metric_threshold_error_diff_value":37,"contribution":[],"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"Threshold Alert","metric_threshold":5}}},"37_attr":{"business_rule":"ssn","type":"string","unique_values":7,"null_values":0,"duplicate":50,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[],"top_20_frequency":[["123-45-6790",17],["111-22-3334",16],["999-88-7778",14],["wrong",6],["999-88-7777",2],["111-22-3333",1],["123-45-6789",1]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"42_attr":{"business_rule":"date","type":"string","unique_values":7,"null_values":0,"duplicate":50,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"27","attribute_name":"TRANSACTION_DATE","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"133","attribute_name":"TRANSACTION_DATE","data_set_name":"conformity.csv"}],"top_20_frequency":[["04-10-2023",17],["05-10-2023",16],["06-10-2023",14],["wrong",6],["03-10-2023",2],["01-10-2023",1],["02-10-2023",1]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"33_attr":{"business_rule":"http","type":"string","unique_values":6,"null_values":0,"duplicate":51,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"2","attribute_name":"HttpResponse","data_set_name":"conformity-double-old.csv"}],"top_20_frequency":[["304",22],["503",17],["504",14],["!!!!!!!!",2],["500",1],["502",1]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"35_attr":{"business_rule":"boolean","type":"string","unique_values":3,"null_values":0,"duplicate":54,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"107","attribute_name":"IS_ACTIVE","data_set_name":"conformity.csv"}],"top_20_frequency":[["FALSE",32],["TRUE",19],["wrong",6]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"36_attr":{"business_rule":"url","type":"string","unique_values":2,"null_values":0,"duplicate":55,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"11","attribute_name":"URL","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"111","attribute_name":"URL","data_set_name":"conformity.csv"}],"top_20_frequency":[["https://example.com ",51],["wrong",6]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"38_attr":{"business_rule":"ip","type":"string","unique_values":4,"null_values":0,"duplicate":53,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"18","attribute_name":"IP_ADDRESS","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"119","attribute_name":"IP_ADDRESS","data_set_name":"conformity.csv"}],"top_20_frequency":[["169.250.6.93",32],["255.255.255.0 ",17],["wrong",6],["192.52.70.76",2]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"39_attr":{"business_rule":"url","type":"string","unique_values":3,"null_values":0,"duplicate":54,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"21","attribute_name":"WEBSITE","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"123","attribute_name":"WEBSITE","data_set_name":"conformity.csv"}],"top_20_frequency":[["http://example.net ",32],["http://example.com ",19],["wrong ",6]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"40_attr":{"business_rule":"gender","type":"string","unique_values":4,"null_values":0,"duplicate":53,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"23","attribute_name":"GENDER","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"127","attribute_name":"GENDER","data_set_name":"conformity.csv"}],"top_20_frequency":[["Female",32],["Male",17],["wrong",6],["Toddler",2]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"34_attr":{"business_rule":null,"type":"string","unique_values":6,"null_values":0,"duplicate":51,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"5","attribute_name":"New_col","data_set_name":"conformity-double-old.csv"}],"top_20_frequency":[["new127",22],["new126",17],["new128",14],["new125",2],["new123",1],["new124",1]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"41_attr":{"business_rule":"email","type":"string","unique_values":4,"null_values":0,"duplicate":53,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"25","attribute_name":"EMAIL","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"15","attribute_id":"102","attribute_name":"email","data_set_name":"metric-errors.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"130","attribute_name":"EMAIL","data_set_name":"conformity.csv"}],"top_20_frequency":[["john.doe@example.com",18],["jane.doe@example.com",17],["jim.bean@example.com",16],["wrong",6]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"43_attr":{"business_rule":"credit_card","type":"string","unique_values":2,"null_values":0,"duplicate":55,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"29","attribute_name":"CREDIT_CARD","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"134","attribute_name":"CREDIT_CARD","data_set_name":"conformity.csv"}],"top_20_frequency":[["420000000000",51],["wrong",6]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}},"44_attr":{"business_rule":null,"type":"int","unique_values":6,"null_values":0,"duplicate":51,"metrics_with_issue":null,"partitions_with_issues_count":0,"relationship":[{"env_id":"1","integration_id":"1","data_set_id":"4","attribute_id":"31","attribute_name":"ID","data_set_name":"conformity-double-old.csv"},{"env_id":"1","integration_id":"1","data_set_id":"18","attribute_id":"53","attribute_name":"id","data_set_name":"schema_drift.csv"},{"env_id":"1","integration_id":"1","data_set_id":"15","attribute_id":"105","attribute_name":"id","data_set_name":"metric-errors.csv"},{"env_id":"1","integration_id":"1","data_set_id":"12","attribute_id":"92","attribute_name":"id","data_set_name":"date_conformity_test.csv"},{"env_id":"1","integration_id":"1","data_set_id":"6","attribute_id":"136","attribute_name":"ID","data_set_name":"conformity.csv"}],"top_20_frequency":[[5,22],[4,17],[6,14],[3,2],[1,1],[2,1]],"chart_data":{"1":{"drift":0,"time":"2026-04-01 09:09:27","value":100,"drift_patterns":"NO_DRIFT","name":"Fill Rate","error_rows":null,"metric_threshold_error_status":false,"metric_threshold_error_diff_value":0,"contribution":null,"normalization_value":null,"data_type":null,"boxplot_data":null,"version_name":null,"drift_pattern":"NO_DRIFT","metric_threshold":80}}}}})}
/>

                      <input 
  type="button" 
  className="btn btn-sm btn-default mb-3 d-none" 
  value="Run" 
  onClick={() => this.pushResponseData({
  "data_set_id": 158,
  "env_id": 1,
  "bottom_panel_data": {
    "158_dt": {
      "total_issues": 11,
      "total_attributes": 8,
      "total_partitions": 5,
      "attributes_with_issues_count": 8,
      "partitions_with_issues_count": 2,
      "metric_id_count_map": {
        "Fill Rate": 8
      },
      "top_three_attributes_with_issues": [
        224,
        225,
        226
      ],
      "top_three_partitions_with_issues": [
        "checkrtd_qldds_country_code_qldds_IN",
        "checkrtd_qldds_country_code_qldds_INDIA"
      ],
      "chart_data": {
        "1": {
          "drift": 7.270890999999999,
          "time": "2026-02-24 11:12:29",
          "value": 59.90566,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 40.09434,
          "contribution": [
            {
              "attribute_name": "country_code",
              "value": 40,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "phone_number",
              "value": 40,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "email",
              "value": 40,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "gender",
              "value": 40,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "user_id",
              "value": 40,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "age",
              "value": 34,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "pan_number",
              "value": 10,
              "time": "2026-02-24 11:12:29"
            },
            {
              "attribute_name": "full_name",
              "value": 10,
              "time": "2026-02-24 11:12:29"
            }
          ],
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        },
        "2": {
          "drift": 0,
          "time": "2026-02-24 11:12:29",
          "value": 53,
          "drift_patterns": "NO_DRIFT",
          "name": "Row Count",
          "error_rows": null,
          "metric_threshold_error_status": false,
          "metric_threshold_error_diff_value": 0,
          "contribution": [],
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "NO_DRIFT",
          "metric_threshold": 0,
          "avg_row_count": 2,
          "deviation_percentage": 0
        },
        "3": {
          "drift": 5,
          "time": "2026-02-24 13:34:53",
          "value": 5,
          "drift_patterns": "blip",
          "name": "Recency",
          "error_rows": null,
          "metric_threshold_error_status": false,
          "metric_threshold_error_diff_value": 0,
          "contribution": [],
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "blip",
          "metric_threshold": 5
        }
      }
    },
    "226_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 9,
      "null_values": 13,
      "duplicate": 39,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          "IN",
          20
        ],
        [
          "INDIA",
          20
        ],
        [
          "US",
          5
        ],
        [
          "IND",
          4
        ],
        [
          "uk",
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "227_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 8,
      "null_values": 13,
      "duplicate": 32,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          "12345",
          8
        ],
        [
          "9876543210",
          8
        ],
        [
          "9876543211",
          8
        ],
        [
          "1",
          7
        ],
        [
          "12",
          7
        ],
        [
          "23",
          7
        ],
        [
          "8887776665",
          4
        ],
        [
          "9998887776",
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "224_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 6,
      "null_values": 43,
      "duplicate": 4,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 2,
      "relationship": [],
      "top_20_frequency": [
        [
          "",
          30
        ],
        [
          "ABCDE1234F",
          5
        ],
        [
          "LMNOP9876Q",
          5
        ],
        [
          "PQRSX5678Z",
          5
        ],
        [
          "1234ABCDE",
          4
        ],
        [
          "ABCDE9999",
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 4.606906815756233,
          "time": "2026-02-24 11:12:29",
          "value": 18.867924528301888,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 81.132075,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "228_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 7,
      "null_values": 13,
      "duplicate": 33,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          "john.doe@mail.com",
          15
        ],
        [
          "anitasharma",
          14
        ],
        [
          "ravi.kumar",
          14
        ],
        [
          "alex.smith@mail",
          4
        ],
        [
          "meera.patel@mail.com",
          4
        ],
        [
          "anitasharma.com",
          1
        ],
        [
          "ravi.kumar@gmail.com",
          1
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "229_attr": {
      "business_rule": "gender",
      "type": "string",
      "unique_values": 4,
      "null_values": 13,
      "duplicate": 36,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          "Male",
          30
        ],
        [
          "F",
          15
        ],
        [
          "Other",
          7
        ],
        [
          "Female",
          1
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "230_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 6,
      "null_values": 43,
      "duplicate": 4,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 2,
      "relationship": [],
      "top_20_frequency": [
        [
          "",
          30
        ],
        [
          "Anita Sharma",
          5
        ],
        [
          "John Doe",
          5
        ],
        [
          "Ravi Kumar",
          5
        ],
        [
          "Alex Smith",
          4
        ],
        [
          "Meera@Patel",
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 4.606906815756233,
          "time": "2026-02-24 11:12:29",
          "value": 18.867924528301888,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 81.132075,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "225_attr": {
      "business_rule": null,
      "type": "int",
      "unique_values": 6,
      "null_values": 19,
      "duplicate": 28,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 2,
      "relationship": [],
      "top_20_frequency": [
        [
          99999,
          21
        ],
        [
          16,
          8
        ],
        [
          28,
          5
        ],
        [
          30,
          5
        ],
        [
          35,
          4
        ],
        [
          65,
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 10.36287904749782,
          "time": "2026-02-24 11:12:29",
          "value": 64.15094339622641,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 35.849057,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    },
    "231_attr": {
      "business_rule": null,
      "type": "int",
      "unique_values": 5,
      "null_values": 13,
      "duplicate": 35,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          1,
          15
        ],
        [
          2,
          15
        ],
        [
          3,
          15
        ],
        [
          4,
          4
        ],
        [
          5,
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    }
  }
})}
/>

<input 
  type="button" 
  className="btn btn-sm btn-default mb-3 d-none" 
  value="Stage" 
  onClick={() => this.pushResponseData({
  "data_set_id": 158,
  "meta_data_id": 226,
  "env_id": 1,
  "bottom_panel_data": {
    "226_attr": {
      "business_rule": null,
      "type": "string",
      "unique_values": 9,
      "null_values": 11,
      "duplicate": 39,
      "metrics_with_issue": [
        "Fill Rate"
      ],
      "partitions_with_issues_count": 0,
      "relationship": [],
      "top_20_frequency": [
        [
          "IN",
          20
        ],
        [
          "INDIA",
          20
        ],
        [
          "US",
          5
        ],
        [
          "IND",
          4
        ],
        [
          "uk",
          4
        ]
      ],
      "chart_data": {
        "1": {
          "drift": 11.403613006824571,
          "time": "2026-02-24 11:12:29",
          "value": 75.47169811320755,
          "drift_patterns": "Threshold Alert",
          "name": "Fill Rate",
          "error_rows": null,
          "metric_threshold_error_status": true,
          "metric_threshold_error_diff_value": 24.528302,
          "contribution": null,
          "normalization_value": null,
          "data_type": null,
          "boxplot_data": null,
          "version_name": null,
          "drift_pattern": "Threshold Alert",
          "metric_threshold": 100
        }
      }
    }
  }
})}
/>


                      <div className="qd-toolbar-col">
                        <div className="qd-toolbar-btn" style={{ minWidth: '160px' }}>
                          <div className="custom-control custom-checkbox custom-control-inline mr-0">
                            <Form.Control
                              type="checkbox"
                              value="partition"
                              className="custom-control-input"
                              name="partition"
                              id="add_partition"
                              checked={this.state.isCheckedBoxPartition}
                              onChange={this.handlePartitionChange} />
                            <Form.Label className="custom-control-label" for="add_partition">Include Partition</Form.Label>
                          </div>
                        </div>
                      </div>

                      <div className="qd-toolbar-col">
                        <div className="qd-toolbar-btn" style={{ minWidth: '124px' }}>
                          <div className="custom-control custom-switch custom-switch-sm custom-switch--danger">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="showIncidents"
                              checked={this.state.isCheckedIncidents} // Controlled by state
                              onChange={this.handleToggleIncidents} // Call handler on change
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="activeRuns"
                              onClick={this.handleToggleIncidents} // Ensure label click also toggles
                              style={{ cursor: "pointer" }}
                            >
                              <span className="ml-1">
                                Incidents
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="qd-toolbar-col">
                        <RcTooltip
                          placement="top"
                          overlay={
                            <span>Fullscreen mode</span>
                          }
                          arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                        >
                          <div className="qd-toolbar-btn" style={{ minWidth: '40px' }} onClick={this.handleChartFullscreen}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 20V15.577H5V19H8.423V20H4ZM15.5962 20V19H19.0193V15.577H20.0193V20H15.5962ZM4 8.423V4H8.423V5H5V8.423H4ZM19.0193 8.423V5H15.5962V4H20.0193V8.423H19.0193Z" fill="currentColor" />
                            </svg>
                          </div>
                        </RcTooltip>
                      </div>
                      <div className="qd-toolbar-col">
                        <div className="qd-toolbar_dropdown-wrap" id="topmenucamera" onClick={this.handleCaptureClick}>
                          <RcTooltip
                            placement="topRight"
                            align={{
                              offset: [0, 5], // Adjusts tooltip positioning
                            }}
                            overlay={
                              <span>Take snapshot</span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                          >
                            <div className="qd-toolbar-btn" style={{ minWidth: '40px' }}>
                              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 16.7308C13.0448 16.7308 13.9278 16.3702 14.649 15.649C15.3702 14.9278 15.7308 14.0448 15.7308 13C15.7308 11.9552 15.3702 11.0722 14.649 10.351C13.9278 9.62983 13.0448 9.26925 12 9.26925C10.9552 9.26925 10.0722 9.62983 9.351 10.351C8.62983 11.0722 8.26925 11.9552 8.26925 13C8.26925 14.0448 8.62983 14.9278 9.351 15.649C10.0722 16.3702 10.9552 16.7308 12 16.7308ZM12 15.7308C11.223 15.7308 10.5737 15.4698 10.052 14.948C9.53017 14.4263 9.26925 13.777 9.26925 13C9.26925 12.223 9.53017 11.5737 10.052 11.052C10.5737 10.5302 11.223 10.2693 12 10.2693C12.777 10.2693 13.4263 10.5302 13.948 11.052C14.4698 11.5737 14.7308 12.223 14.7308 13C14.7308 13.777 14.4698 14.4263 13.948 14.948C13.4263 15.4698 12.777 15.7308 12 15.7308ZM4.6155 20C4.15517 20 3.77083 19.8458 3.4625 19.5375C3.15417 19.2292 3 18.8448 3 18.3845V7.6155C3 7.15517 3.15417 6.77083 3.4625 6.4625C3.77083 6.15417 4.15517 6 4.6155 6H7.573L9.423 4H14.577L16.427 6H19.3845C19.8448 6 20.2292 6.15417 20.5375 6.4625C20.8458 6.77083 21 7.15517 21 7.6155V18.3845C21 18.8448 20.8458 19.2292 20.5375 19.5375C20.2292 19.8458 19.8448 20 19.3845 20H4.6155ZM4.6155 19H19.3845C19.564 19 19.7115 18.9423 19.827 18.827C19.9423 18.7115 20 18.564 20 18.3845V7.6155C20 7.436 19.9423 7.2885 19.827 7.173C19.7115 7.05767 19.564 7 19.3845 7H15.9885L14.1443 5H9.85575L8.0115 7H4.6155C4.436 7 4.2885 7.05767 4.173 7.173C4.05767 7.2885 4 7.436 4 7.6155V18.3845C4 18.564 4.05767 18.7115 4.173 18.827C4.2885 18.9423 4.436 19 4.6155 19Z" fill="currentColor" />
                              </svg>
                            </div>
                          </RcTooltip>
                          <div className="qd-toolbar_dropdown qd-toolbar_dropdown-right">
                            <a className="qd-toolbar_dropdown-item" href="#!" onClick={this.renderChart.bind(this, "Bar")}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 -960 960 960" width="28" fill="#333"><path d="M480-342 356-466l20-20 90 90v-352h28v352l90-90 20 20-124 124ZM272-212q-26 0-43-17t-17-43v-90h28v90q0 12 10 22t22 10h416q12 0 22-10t10-22v-90h28v90q0 26-17 43t-43 17H272Z" /></svg> Download Image
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="toolbar_fade-left"></div>
                    <div className="toolbar_fade-right"></div>
                  </div>
                  <div className={`qd-rt_chart-widget-wrap 
                        ${this.state.showChartFullscreen === true ?
                      'qd-rt_chart-widget--fullscreen' : ''}`}


                    style={{
                      ...(this.state.incidentPanelState === "minimized"
                        ? {} // Hide the panel when minimized
                        : {
                          height:
                            this.state.incidentPanelState === "half"
                              ? `${Math.max(0, window.innerHeight / 2 - 69)}px` // Prevents negative values
                              : this.state.incidentPanelState === "halffull"
                                ? `${Math.max(0, window.innerHeight / 2)}px`
                                : "0px",
                        })
                    }}

                    ref={this.containerRef} >{/* Add "qd-rt_chart-widget--fullscreen" for fullscreen view */}
                    <div className="qd-rt_chart-container" id="chart-container"
                      style={{
                        height: this.state.toggleIncidentPanel === true ? 'calc(100% - 500)' : 'calc(100% - 41px)',
                        display: 'flex',
                        gap: '5px',
                        columnGap: '5px',
                        rowGap: '0px',
                        overflowY: 'auto',
                        flexWrap: 'wrap'
                      }}
                    >

                      {
                        this.state.showChartFullscreen && this.state.escapeMessage?
                          <div className='close-panel tw-animate-fade-up'>
                            <i className='icon-info'>
                              <svg className='d-block' xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="currentColor"><path d="M480.01-290q12.76 0 21.37-8.63Q510-307.25 510-320v-170q0-12.75-8.63-21.38-8.63-8.62-21.38-8.62-12.76 0-21.37 8.62Q450-502.75 450-490v170q0 12.75 8.63 21.37 8.63 8.63 21.38 8.63ZM480-588.46q13.73 0 23.02-9.29t9.29-23.02q0-13.73-9.29-23.02-9.29-9.28-23.02-9.28t-23.02 9.28q-9.29 9.29-9.29 23.02t9.29 23.02q9.29 9.29 23.02 9.29Zm.07 488.46q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z"/></svg>
                            </i>
                            <span>Press Esc to exit full screen and show panels</span>
                            <i className="icon-close" onClick={this.handleEscapeMessageClose}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                            </i>
                          </div>
                          : ''
                      }
                      {/* Virtualized Chart Grid */}


                      {inputData === null || inputData === undefined || Object.keys(inputData).length === 0 || (inputData && (!inputData.attributes || inputData.attributes.length === 0)) ?
                        <div
                          className="qd-rt_chart-widget-row"
                          style={{
                            width: "100%",
                            height: this.state.showChartFullscreen
                              ? document.documentElement.clientHeight
                              : window.innerHeight - 199,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          No Data Found
                        </div>
                        :

                      chartIds === ""  ?
                        <div className='container mw-100 m-0' style={{ padding: '0 3px' }}>
                          <div className="row" style={{ margin: '0 -6px' }}>
                            {[...Array(4)].map((_, index) => (
                              <div
                                key={"loading_" + index} // Ensure each element has a unique key
                                className='col-6'
                                style={{ padding: '0 3px 6px' }}
                              >
                                <div className="qd-rt_chart-widget" style={{ height: (window.innerHeight - 199) / 2 }}>
                                  <div style={{ textAlign: "center", height: "100%" }}>
                                    <Load />
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        :
                        <div className="row w-100 no-gutters">
                          {/* separate Component */}
                          <DqChart
                            showChartFullscreen={this.state.showChartFullscreen}
                            incidentPanelState={this.state.incidentPanelState}
                            itemData={[...chartIds]}
                            chartData = {this.state.chartData}
                            incidentchartData = {this.state.incidentchartData}
                            isCheckedIncidents = {this.state.isCheckedIncidents}
                            visibleCharts = {this.state.visibleCharts}
                            fullAttributeList = {this.state.fullAttributeList}
                            saveList = {this.state.saveList}
                            hasMoreData = {this.state.hasMoreData}
                            selectedEnvId= {this.state.selectedEnvId}
                            selectedDatasetId = {this.state.selectedDatasetId}
                            selectedDatasetName = {this.state.selectedDatasetName}
                            selectedDatasetAttrId = {this.state.selectedDatasetAttrId}
                            selectedDatasetAttrName = {this.state.selectedDatasetAttrName}
                            selectedMeticsName = {this.state.selectedMeticsName}
                            selectedIntegrationId = {this.state.selectedIntegrationId}
                            startDate = {this.state.startDate}
                            endDate = {this.state.endDate}
                            browser_tab_id =  {this.props.browser_tab_id}
                            session_id =  {this.props.sessionId}
                            user_id =  {this.props.userId}
                            getChartDataRequestParams = {this.getChartDataRequestParams}
                            inputData={this.state.inputData}
                            bottomPanelData = {this.state.bottomPanelData}
                            onBottomChartVisibleChange={this.handleBottomChartChangeInParent}
                            Row = {this.Row}
                            handleItemsRendered = {this.handleItemsRendered}
                            currentBottomPanelData = {this.state.currentBottomPanelData}
                            partitionError = {partitionError}
                            shouldRenderTitleForGrid={(() => {

                            })()}
                            
                          >
                        </DqChart>

                        </div>
                      }

                    </div>
                    <div className="qd-rt_chart-range">
                      <div className="qd_cr-wrap">
                        {this.state.dateRanges.map((range) => (
                          <button
                            id={"dateRanges_" + range}
                            key={range}
                            className={`qd_cr-btn ${selectedRange === range ? 'active' : ''}`}
                            onClick={() => this.handleDateRange(range)}
                          >
                            <span className="qd_cr-text">{range}</span>
                          </button>
                        ))}
                        <Dropdown drop="up">
                          <Dropdown.Toggle variant=" " id="dropdown-basic" className="qd_cr-btn qd_cr-btn--calendar dropdown-caret-hide">
                            {/* <OverlayTrigger
                                                            placement="top"
                                                            trigger={[]}
                                                            show={this.state.showDatePopover}
                                                            overlay={
                                                              <Popover className="flush-popover tw-border-0 tw-shadow-lg tw-rounded-lg" style={{ zIndex: 1060 }}>
                                                                <Popover.Content className="!tw-pt-3">
                                                                  <div className="tw-flex tw-items-center tw-gap-3">
                                                                    <CalendarIcon size="16" color="white" className='tw-opacity-70' />
                                                                    <span className="tw-text-white tw-text-xs tw-leading-snug">Select a date to filter<br />your dashboard</span>
                                                                    <button
                                                                      onClick={(e) => { e.stopPropagation(); this.setState({ showDatePopover: false }); }}
                                                                      className="tw-bg-transparent tw-border-0 tw-text-white tw-opacity-70 hover:tw-opacity-100 tw-cursor-pointer tw-p-0 tw-ml-2 tw-flex-shrink-0 tw-transition-opacity"
                                                                    >
                                                                      <X size="16" color="white" />
                                                                    </button>
                                                                  </div>
                                                                </Popover.Content>
                                                              </Popover>
                                                            }
                                                          >
                            <svg id="Group_4900" data-name="Group 4900" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                              <rect id="Rectangle_2841" data-name="Rectangle 2841" width="24" height="24" fill="none" />
                              <g id="Group_4899" data-name="Group 4899" transform="translate(2 2.292)">
                                <path id="Subtraction_6" data-name="Subtraction 6" d="M14.2,18.373H6.264V16.7H14.2a.836.836,0,0,0,.835-.835V8.351H1.67v2.088H0V4.176A2.509,2.509,0,0,1,2.506,1.67h1.67V.835a.835.835,0,1,1,1.67,0V1.67h5.011V.835a.835.835,0,1,1,1.67,0V1.67H14.2A2.508,2.508,0,0,1,16.7,4.176V15.867A2.508,2.508,0,0,1,14.2,18.373ZM2.506,3.341a.836.836,0,0,0-.836.835V6.681H15.032V4.176a.836.836,0,0,0-.835-.835h-1.67v.835a.835.835,0,1,1-1.67,0V3.341H5.846v.835a.835.835,0,1,1-1.67,0V3.341Z" transform="translate(3.298)" />
                                <g id="log-in" transform="translate(0 12.318)">
                                  <path id="Path_1423" data-name="Path 1423" d="M9.876,13.348a.626.626,0,0,1-.443-1.069l2.48-2.48-2.48-2.48a.626.626,0,1,1,.886-.886l2.923,2.923a.626.626,0,0,1,0,.886l-2.923,2.923A.624.624,0,0,1,9.876,13.348Z" transform="translate(-5.158 -6.25)" />
                                  <path id="Line_33" data-name="Line 33" d="M6.891.5H-.124A.626.626,0,0,1-.75-.124.626.626,0,0,1-.124-.75H6.891a.626.626,0,0,1,.626.626A.626.626,0,0,1,6.891.5Z" transform="translate(0.75 3.673)" />
                                </g>
                              </g>
                            </svg>
                            </OverlayTrigger> */}
                            <OverlayTrigger
                                placement="top"
                                trigger={[]}
                                show={this.state.switchRealTimeView}
                                overlay={
                                  <Popover className="flush-popover tw-border-0 tw-shadow-lg tw-rounded-lg" style={{ zIndex: 1060, maxWidth: 'min-content' }}>
                                    <Popover.Content className="!tw-p-4">
                                      <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-gap-5 md:tw-gap-6">
                                        <div className="tw-rounded-lg tw-bg-gradient-to-br tw-from-[#E2F0FF] tw-to-[#0021A5] tw-pl-3 tw-pt-3 tw-w-[270px] tw-h-[200px] overflow-hidden tw-flex-shrink-0">
                                          <Image
                                            src="img_monitor_switch"
                                            className="tw-w-[420px] tw-h-auto tw-object-contain"
                                          />
                                        </div>
                                        <div>
                                          <h3 className='tw-text-lg tw-leading-5 tw-text-[#F0F0F1] tw-mb-3 tw-font-semibold'>Switch to Legacy Monitor View</h3>
                                          <p className='tw-text-sm tw-leading-[18px] tw-text-[#CECFD2] tw-m-0'>The selected date is before <strong className='tw-font-semibold'>{deploymentMonth}</strong> and is available in the Legacy Monitor view. You'll be switched to access historical data.</p>
                                          <div className="tw-flex tw-flex-row tw-items-center tw-gap-2 tw-pt-4 md:tw-pt-6 tw-pb-2 md:pb-0 md:tw-gap-3">
                                            <button type="button" onClick={(e) => { e.stopPropagation(); this.handleMonitorSwitchCancel(); }}
                                              className="btn btn-outline btn-grey btn-circle !tw-py-[8px] !tw-px-[16px] !tw-font-semibold !tw-text-[13px] md:!tw-text-sm tw-whitespace-nowrap">Cancel
                                            </button>
                                            <button type="button" onClick={this.handleMonitorSwitchConfirm}
                                              className="btn btn-primary btn-circle !tw-py-[8px] !tw-px-[16px] !tw-font-semibold !tw-text-[13px] md:!tw-text-sm tw-whitespace-nowrap">Switch to Legacy Monitor
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </Popover.Content>
                                  </Popover>
                                }
                              >
                                <svg id="Group_4900" data-name="Group 4900" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                  <rect id="Rectangle_2841" data-name="Rectangle 2841" width="24" height="24" fill="none" />
                                  <g id="Group_4899" data-name="Group 4899" transform="translate(2 2.292)">
                                    <path id="Subtraction_6" data-name="Subtraction 6" d="M14.2,18.373H6.264V16.7H14.2a.836.836,0,0,0,.835-.835V8.351H1.67v2.088H0V4.176A2.509,2.509,0,0,1,2.506,1.67h1.67V.835a.835.835,0,1,1,1.67,0V1.67h5.011V.835a.835.835,0,1,1,1.67,0V1.67H14.2A2.508,2.508,0,0,1,16.7,4.176V15.867A2.508,2.508,0,0,1,14.2,18.373ZM2.506,3.341a.836.836,0,0,0-.836.835V6.681H15.032V4.176a.836.836,0,0,0-.835-.835h-1.67v.835a.835.835,0,1,1-1.67,0V3.341H5.846v.835a.835.835,0,1,1-1.67,0V3.341Z" transform="translate(3.298)" />
                                    <g id="log-in" transform="translate(0 12.318)">
                                      <path id="Path_1423" data-name="Path 1423" d="M9.876,13.348a.626.626,0,0,1-.443-1.069l2.48-2.48-2.48-2.48a.626.626,0,1,1,.886-.886l2.923,2.923a.626.626,0,0,1,0,.886l-2.923,2.923A.624.624,0,0,1,9.876,13.348Z" transform="translate(-5.158 -6.25)" />
                                      <path id="Line_33" data-name="Line 33" d="M6.891.5H-.124A.626.626,0,0,1-.75-.124.626.626,0,0,1-.124-.75H6.891a.626.626,0,0,1,.626.626A.626.626,0,0,1,6.891.5Z" transform="translate(0.75 3.673)" />
                                    </g>
                                  </g>
                                </svg>
                              </OverlayTrigger>
                            <span class="divider"></span>
                            <span className="qd_cr-text">
                              {
                                this.state.endDate !== "" ?
                                  this.state.selectedRange === this.state.dateRanges[0] ?
                                  moment(this.state.startDate).format('DD-MM-Y') + " (GMT)" : moment(this.state.startDate).format('DD-MMM-Y') + " - " +
                                    (dateFilterEndDate ? moment(dateFilterEndDate).format('DD-MMM-Y') : moment(this.state.endDate).format('DD-MMM-Y'))
                                   // moment(dateFilterEndDate).format('DD-MMM-Y')
                                    + " (GMT)"
                                    : ""
                              }
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='dateRange-dropdown dropdown-up' align="start" 
                                style={{
                          overflowY: 'auto',  
                          height:
                            this.state.incidentPanelState === "half"
                              ? `${Math.max(0, window.innerHeight / 2 - 65)}px` // Prevents negative values
                              : this.state.incidentPanelState === "halffull"
                                ? `${Math.max(0, window.innerHeight / 2)}px`
                                : window.innerHeight/1.4+ 'px'
                        }}
                          >
                            <Tab.Container defaultActiveKey="custom-range">
                              <Dropdown.Header>
                                <div className="tabbable-line">
                                  <Nav variant="tabs" id="page-nav-tabs">
                                    <Nav.Item>
                                      <Nav.Link eventKey="date">
                                        <span className="qd-menu__link-text">Date</span>
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link eventKey="custom-range">
                                        <span className="qd-menu__link-text">Custom Range</span>
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </div>
                              </Dropdown.Header>
                              <Tab.Content>
                                <Tab.Pane eventKey="date">
                                  <div className='react-calendar__tiles-group'>
                                  <div className="react-calendar__input-group">
                                    <div className="react-calendar__input-group-prepend">
                                      <FontAwesomeIcon icon={faCalendar} />
                                    </div>
                                    <input
                                      id="start-date"
                                      type="text"
                                      placeholder="Select start date"
                                      value={dateFilterStartDate === null ? moment().format('YYYY-MM-DD') : moment(dateFilterStartDate).format('YYYY-MM-DD')}
                                      onClick={this.toggleStartCalendar}
                                      readOnly
                                    />
                                  </div>
                                  {minDate !== undefined && maxDate !== undefined ?

                                    <Calendar
                                      onChange={this.handledateFilterStartDateChange}
                                      // value={dateFilterEndDate === null ?  moment() : moment(dateFilterEndDate)}
                                      minDate={minDate}
                                      maxDate={moment(this.state.endDate).toDate()}
                                      value={dateFilterStartDate}
                                      // minDate={minDate !== undefined ? minDate :  moment(this.state.endDate).toDate()}
                                      // maxDate={maxDate !== undefined ? this.state.endDate : moment(this.state.endDate).toDate()}
                                      style={{ position: 'absolute', zIndex: 1 }}
                                    />
                                    : ""}
                                    </div> 
                                  <div className="dropdown-footer d-flex justify-content-end">
                                    <button onClick={() => $("body").click()} className="btn btn-outline btn-grey btn-circle mr-2">Cancel</button>
                                    <button onClick={() => this.customDateRangeSelect("single")} disabled={dateFilterStartDate === null ? true : false} className="btn btn-primary btn-circle">Apply</button>
                                  </div>
                                </Tab.Pane>
                                <Tab.Pane eventKey="custom-range">
                                  <div className='react-calendar__tiles-group'>
                                    <div className="react-calendar__input-group mb-2">
                                      <div className="react-calendar__input-group-prepend">
                                        <FontAwesomeIcon icon={faCalendar} />
                                      </div>
                                      <input
                                        id="start-date"
                                        type="text"
                                        placeholder="Select start date"
                                        // value={dateFilterStartDate ? moment(dateFilterStartDate).format('YYYY-MM-DD') : moment(this.state.startDate).format('YYYY-MM-DD')}
                                        // value={dateFilterStartDate === null  ?  moment().format('YYYY-MM-DD') :  moment(dateFilterStartDate).format('YYYY-MM-DD')}
                                        value={dateFilterStartDate ? moment(dateFilterStartDate).format('YYYY-MM-DD') : moment(this.state.startDate).format('YYYY-MM-DD')}
                                        onClick={this.toggleStartCalendar}
                                        readOnly
                                      />
                                    </div>
                                    {/* End Date Input */}
                                    <div className="react-calendar__input-group">
                                      <div className="react-calendar__input-group-prepend">
                                        <FontAwesomeIcon icon={faCalendar} />
                                      </div>
                                      <input
                                        id="end-date"
                                        type="text"
                                        placeholder="Select end date"
                                        // value={dateFilterEndDate ? moment(dateFilterEndDate).format('YYYY-MM-DD') : moment(this.state.endDate).format('YYYY-MM-DD')}
                                        // value={dateFilterEndDate === null  ?  moment().format('YYYY-MM-DD') : this.state.endDate!=="" ? moment(this.state.endDate).format('YYYY-MM-DD') : moment(dateFilterEndDate).format('YYYY-MM-DD')}
                                        value={dateFilterEndDate ? moment(dateFilterEndDate).format('YYYY-MM-DD') : moment(this.state.endDate).format('YYYY-MM-DD')}
                                        onClick={this.toggleEndCalendar}
                                        readOnly
                                      />
                                    </div>

                                    {dateFilterShowStartCalendar && (
                                      <Calendar
                                        minDate={minDate}
                                        maxDate={moment(this.state.endDate).toDate()}
                                        onChange={this.handledateFilterCustomStartDateChange}
                                        value={dateFilterStartDate}
                                        style={{ position: 'absolute', zIndex: 1 }}
                                      />
                                    )}

                                    {dateFilterShowEndCalendar && (
                                      <Calendar
                                        minDate={minDate}
                                        maxDate={moment(this.state.endDate).toDate()}
                                        onChange={this.handledateFilterEndDateChange}
                                        value={dateFilterEndDate}
                                        style={{ position: 'absolute', zIndex: 1 }}
                                      />
                                    )}
                                  </div>
                                  <div className="dropdown-footer d-flex justify-content-end">
                                    <button onClick={() => $("body").click()} className="btn btn-outline btn-grey btn-circle mr-2">Cancel</button>
                                    <button onClick={() => this.customDateRangeSelect("custom")}   disabled={!dateFilterStartDate ||!dateFilterEndDate ||new Date(dateFilterStartDate) > new Date(dateFilterEndDate)}className="btn btn-primary btn-circle">Apply</button>
                                  </div>
                                </Tab.Pane>
                              </Tab.Content>

                            </Tab.Container>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  {/*Incident*/}
                  <div className={this.state.incidentPanelState === "full" ? "qd-rt_bottom-panel qd-rt_bottom-panel--fullscreen" : "qd-rt_bottom-panel"}
                    style={{
                      height: this.state.incidentPanelState === "minimized" ? '38'
                        : this.state.incidentPanelState === "half" ?
                          (parseInt(window.innerHeight) / 2) - parseInt(49) : parseInt(window.innerHeight) - parseInt(49)
                    }}
                  >
                    <div className="qd-rt_bp-head">
                      <div className="content">
                        <div className="caption">
                          <h6>
                            <i className='position-relative mr-2'>
                              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 9.5V7.91667H11.5V9.5H0ZM0 5.54167V3.95833H11.5V5.54167H0ZM0 1.58333V0H11.5V1.58333H0Z" fill="#333333" />
                              </svg>
                              <sup className="error-indicator">
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M5 7.26392C5.14167 7.26392 5.26042 7.21751 5.35625 7.1247C5.45208 7.03188 5.5 6.91687 5.5 6.77966C5.5 6.64245 5.45208 6.52744 5.35625 6.43462C5.26042 6.34181 5.14167 6.2954 5 6.2954C4.85833 6.2954 4.73958 6.34181 4.64375 6.43462C4.54792 6.52744 4.5 6.64245 4.5 6.77966C4.5 6.91687 4.54792 7.03188 4.64375 7.1247C4.73958 7.21751 4.85833 7.26392 5 7.26392ZM5 5.32688C5.14167 5.32688 5.26042 5.28047 5.35625 5.18765C5.45208 5.09483 5.5 4.97982 5.5 4.84262V2.90557C5.5 2.76836 5.45208 2.65335 5.35625 2.56053C5.26042 2.46772 5.14167 2.42131 5 2.42131C4.85833 2.42131 4.73958 2.46772 4.64375 2.56053C4.54792 2.65335 4.5 2.76836 4.5 2.90557V4.84262C4.5 4.97982 4.54792 5.09483 4.64375 5.18765C4.73958 5.28047 4.85833 5.32688 5 5.32688ZM5 9.68523C4.30833 9.68523 3.65833 9.55811 3.05 9.30387C2.44167 9.04964 1.9125 8.7046 1.4625 8.26877C1.0125 7.83293 0.65625 7.32042 0.39375 6.73124C0.13125 6.14205 0 5.51251 0 4.84262C0 4.17272 0.13125 3.54318 0.39375 2.95399C0.65625 2.36481 1.0125 1.8523 1.4625 1.41646C1.9125 0.98063 2.44167 0.635593 3.05 0.381356C3.65833 0.127119 4.30833 0 5 0C5.69167 0 6.34167 0.127119 6.95 0.381356C7.55833 0.635593 8.0875 0.98063 8.5375 1.41646C8.9875 1.8523 9.34375 2.36481 9.60625 2.95399C9.86875 3.54318 10 4.17272 10 4.84262C10 5.51251 9.86875 6.14205 9.60625 6.73124C9.34375 7.32042 8.9875 7.83293 8.5375 8.26877C8.0875 8.7046 7.55833 9.04964 6.95 9.30387C6.34167 9.55811 5.69167 9.68523 5 9.68523Z" fill="#F64E60"></path>
                                </svg>
                              </sup>
                            </i>
                            Incidents
                          </h6>
                        </div>
                      </div>
                      <div className="actions">
                        {
                          this.state.incidentPanelState === "minimized" ?
                            <RcTooltip
                              placement='top'
                              overlay={
                                <span>Expand the panel</span>
                              }
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <button className="btn" onClick={() => this.setIncidentPanelState("half")}>
                                <i>
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 15L12 9L6 15" stroke="#484848" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                </i>
                              </button>
                            </RcTooltip>
                            : this.state.incidentPanelState === "half" ?
                              <RcTooltip
                                placement='top'
                                overlay={
                                  <span>Collapse the panel</span>
                                }
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <button className="btn" onClick={() => this.setIncidentPanelState("minimized")}>
                                  <i>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.99997 20.5C6.78747 20.5 6.60936 20.4281 6.46563 20.2842C6.32187 20.1404 6.25 19.9622 6.25 19.7496C6.25 19.537 6.32187 19.359 6.46563 19.2154C6.60936 19.0718 6.78747 19 6.99997 19H17C17.2125 19 17.3906 19.0719 17.5344 19.2157C17.6781 19.3595 17.75 19.5377 17.75 19.7503C17.75 19.9629 17.6781 20.141 17.5344 20.2846C17.3906 20.4282 17.2125 20.5 17 20.5H6.99997Z" fill="black" />
                                    </svg>
                                  </i>
                                </button>
                              </RcTooltip>
                              :
                              <RcTooltip
                                placement='top'
                                overlay={
                                  <span>Collapse Panel</span>
                                }
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <button className="btn" onClick={() => this.setIncidentPanelState("half")}>
                                  <i>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.99997 20.5C6.78747 20.5 6.60936 20.4281 6.46563 20.2842C6.32187 20.1404 6.25 19.9622 6.25 19.7496C6.25 19.537 6.32187 19.359 6.46563 19.2154C6.60936 19.0718 6.78747 19 6.99997 19H17C17.2125 19 17.3906 19.0719 17.5344 19.2157C17.6781 19.3595 17.75 19.5377 17.75 19.7503C17.75 19.9629 17.6781 20.141 17.5344 20.2846C17.3906 20.4282 17.2125 20.5 17 20.5H6.99997Z" fill="black" />
                                    </svg>
                                  </i>
                                </button>
                              </RcTooltip>
                        }
                        {
                          this.state.incidentPanelState === "halffull" ?
                            <RcTooltip
                              placement='topRight'
                              overlay={
                                <span>Maximize the panel</span>
                              }
                              arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                              <button className="btn" onClick={() => this.toggleIncidentPanel()} >
                                <i>
                                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 11.548L15.5865 7.952H8.4135L12 11.548ZM18.6923 3.5C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H18.6923ZM5 16V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V16H5ZM19 14.5V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V14.5H19Z" fill="#484848" />
                                  </svg>
                                </i>
                              </button>
                            </RcTooltip>
                            : this.state.incidentPanelState === "full" ?
                              <RcTooltip
                                placement='topRight'
                                overlay={
                                  <span>Minimize the panel</span>
                                }
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <button className="btn" onClick={() => this.toggleIncidentPanel()} >
                                  <i>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12 11.548L15.5865 7.952H8.4135L12 11.548ZM18.6923 3.5C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H18.6923ZM5 16V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V16H5ZM19 14.5V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V14.5H19Z" fill="#484848" />
                                    </svg>
                                  </i>
                                </button>
                              </RcTooltip>
                              :
                              <RcTooltip
                                placement='topRight'
                                overlay={
                                  <span>Minimize the panel</span>
                                }
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                              >
                                <button className="btn" onClick={() => this.toggleIncidentPanel()} >
                                  <i>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.4135 12.0695H15.5865L12 8.47348L8.4135 12.0695ZM5.30775 21.0215C4.80908 21.0215 4.38308 20.8449 4.02975 20.4917C3.67658 20.1384 3.5 19.7124 3.5 19.2137V5.82923C3.5 5.33057 3.67658 4.90457 4.02975 4.55123C4.38308 4.19807 4.80908 4.02148 5.30775 4.02148H18.6923C19.1909 4.02148 19.6169 4.19807 19.9703 4.55123C20.3234 4.90457 20.5 5.33057 20.5 5.82923V19.2137C20.5 19.7124 20.3234 20.1384 19.9703 20.4917C19.6169 20.8449 19.1909 21.0215 18.6923 21.0215H5.30775ZM5 16.5215V19.2137C5 19.2907 5.03208 19.3612 5.09625 19.4252C5.16025 19.4894 5.23075 19.5215 5.30775 19.5215H18.6923C18.7692 19.5215 18.8398 19.4894 18.9038 19.4252C18.9679 19.3612 19 19.2907 19 19.2137V16.5215H5ZM5 15.0215H19V5.82923C19 5.75223 18.9679 5.68173 18.9038 5.61773C18.8398 5.55357 18.7692 5.52148 18.6923 5.52148H5.30775C5.23075 5.52148 5.16025 5.55357 5.09625 5.61773C5.03208 5.68173 5 5.75223 5 5.82923V15.0215Z" fill="#484848" />
                                    </svg>
                                  </i>
                                </button>
                              </RcTooltip>
                        }

                      </div>
                    </div>
                    <div className="qd-rt_bp-body"
                     style={{
                      overflowY: this.state.incidentPanelState === "full" ? 'hidden' : undefined,
                      ...(this.state.incidentPanelState === "minimized" || this.state.incidentPanelState === "full"
                        ? {}
                        : {
                            height:
                              this.state.incidentPanelState === "half"
                                ? `${Math.max(0, window.innerHeight / 2 - 69)}px` // Prevents negative values
                                : this.state.incidentPanelState === "halffull"
                                  ? `${Math.max(0, window.innerHeight / 2)}px`
                                  : "0px", overflow: 'auto'
                          })
                      }}
                    >
                      {this.state.selectedDatasetId!=="" && this.state.preSelectedDataset !== null &&
                      <DQIncidentGrid
                        key={`${this.state.selectedDatasetId}-${this.state.pushtime}-${this.state.selectedMetricsId || ''}-${this.state.selectedDatasetAttrId || ''}-${this.state.refreshKey}`}
                        focusChart={this.focusChart}
                        selectedDatasetId={this.state.selectedDatasetId}
                        selectedEnvId={this.props.selectedEnvId}
                        selectedIntegrationId={this.state.selectedIntegrationId}
                        incidentEndDate={this.state.incidentEndDate}
                        incidentStartDate={this.state.incidentStartDate}
                        integrationId={this.state.selectedIntegrationId}
                        teamId={this.props.teamId}
                        userId={this.props.userId}
                        selectedDatasetAttrId={this.state.selectedDatasetAttrId} 
                        incidentData = {this.state.incidentData}
                        selectedMeticsName = {this.state.selectedMeticsName}
                       selectedMetricsId={this.state.selectedMetricsId}
                       dataType = {this.state.dataType}
                        selectedDatasetName={this.state.selectedDatasetName}
                        selectedDatasetAttrName={this.state.selectedDatasetAttrName}
                        selectedDate={this.state.selectedDate}
                        selectedWatchListId={this.state.selectedWatchListId}
                        watchlistData={this.state.watchListInformation}
                        />}
                      {/* : <Load/>} */}
                    </div>
                  </div>
                </div>
              }
              {this.state.toastStatus &&
                (
                  <div className="toastMsg">
                    <Toast className={this.state.toastClass}
                      show={this.state.toastStatus}
                      onClose={() => this.setState({ toastStatus: false })}
                      delay={3000}
                      autohide>
                      <div className="d-flex align-items-center">
                        {this.state.toastStatus ?
                          <i className="toast-icon">
                            <FontAwesomeIcon icon={this.state.toastIcon} /></i> : ''}
                        <Toast.Body>
                          <div className="toast-content">
                            <strong className="toast-title">{this.state.toastHeading}</strong>
                            <p>{this.state.toastMsg}</p>
                          </div>
                        </Toast.Body>
                        <button type="button" onClick={this.closeToast} className="close" data-dismiss="toast" aria-label="Close" />
                      </div>
                    </Toast>
                  </div>
                )
              }
              {<div className="position-fixed p-3" style={{ top: '100px', right: '0', zIndex: '5' }}>
                <Toast
                  className='toast-dark p-0 m-0'
                  show={this.state.showIncidentToast}
                  onClose={this.handleCloseIncidentToast}
                  delay={3000}
                  autohide
                >
                  <Toast.Body>
                    <div className="d-flex align-items-center p-2">
                      <div class="toast-icon-wrap">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.15571 26.3795C4.94135 26.3795 4.74649 26.3259 4.57111 26.2188C4.39573 26.1116 4.25932 25.9703 4.16189 25.7949C4.06446 25.6195 4.01087 25.4295 4.00112 25.2249C3.99138 25.0203 4.04497 24.8206 4.16189 24.6257L14.977 5.91858C15.0939 5.72372 15.2449 5.57757 15.43 5.48013C15.6151 5.3827 15.8051 5.33398 16 5.33398C16.1949 5.33398 16.3849 5.3827 16.57 5.48013C16.7551 5.57757 16.9061 5.72372 17.023 5.91858L27.8381 24.6257C27.955 24.8206 28.0086 25.0203 27.9989 25.2249C27.9891 25.4295 27.9355 25.6195 27.8381 25.7949C27.7407 25.9703 27.6043 26.1116 27.4289 26.2188C27.2535 26.3259 27.0586 26.3795 26.8443 26.3795H5.15571ZM16 22.8719C16.3313 22.8719 16.609 22.7599 16.8331 22.5358C17.0571 22.3117 17.1692 22.034 17.1692 21.7027C17.1692 21.3715 17.0571 21.0938 16.8331 20.8697C16.609 20.6456 16.3313 20.5335 16 20.5335C15.6687 20.5335 15.391 20.6456 15.1669 20.8697C14.9429 21.0938 14.8308 21.3715 14.8308 21.7027C14.8308 22.034 14.9429 22.3117 15.1669 22.5358C15.391 22.7599 15.6687 22.8719 16 22.8719ZM16 19.3643C16.3313 19.3643 16.609 19.2523 16.8331 19.0282C17.0571 18.8041 17.1692 18.5264 17.1692 18.1951V14.6876C17.1692 14.3563 17.0571 14.0786 16.8331 13.8545C16.609 13.6304 16.3313 13.5184 16 13.5184C15.6687 13.5184 15.391 13.6304 15.1669 13.8545C14.9429 14.0786 14.8308 14.3563 14.8308 14.6876V18.1951C14.8308 18.5264 14.9429 18.8041 15.1669 19.0282C15.391 19.2523 15.6687 19.3643 16 19.3643Z" fill="#FFD500" />
                        </svg>
                      </div>
                      <div class="toast-content px-3">
                        <h6 className='text-white'>No Incidents Found</h6>
                        <p className='text-white'><span className='opacity-50'>No incidents were found in the {this.state.preSelectedAttribute !== null ? 'attribute' : 'dataset'}</span><strong className='ml-1'>[{this.state.preSelectedAttribute?.label || this.state.selectedDatasetName}]</strong></p>
                      </div>
                      <div class="toast-action mr-2">
                        <button type="button" class="close" onClick={this.handleCloseIncidentToast}></button>
                      </div>
                    </div>
                  </Toast.Body>
                </Toast>
                {/* <span>No Incidents found on
                      <strong className='font-weight-semibold ml-1'>
                        <span className='text-nowrap'>fill-rate-test /</span>
                        <span className='text-nowrap'>string_field_2</span>
                      </strong>
                      </span> */}
              </div>}
              {
                // preSelectedDatasource !== undefined && preSelectedDataset !== undefined &&
                // preSelectedDatasource !== null && 
                preSelectedDataset !== null &&
this.state.isLoadingMetaData === false &&
// this.state.inputData !== null &&
// Object.keys(this.state.inputData).length === 0 && 
                <AdvancedSearch
                  selectedEnvId={this.props.selectedEnvId}
                  inputData={this.state.inputData}
                  autocompletemodal={this.state.autocompletemodal}
                  handleCloseAutoCompleteModal={this.handleCloseAutoCompleteModal}
                  preSelectedDataset={advancdedpreselectedDataset}
                  preSelectedEnv={advancdedpreselectedEnv}
                  preSelectedAttribute={preSelectedAttribute}
                  preSelectedDatasource={preSelectedDatasource}
                  renderchartView={this.renderchartView}
                  watchListMapping={this.state.watchListMapping}
                  handleWatchlistChange={this.handleWatchlistChange}
                  getMetricsValueResponse={this.getMetricsValueResponse}
                />
              }
               {this.state.blurLoader === true && <div className="qd-blur-loader show"></div>}
            </>
          )
      }

     {/* {this.state.switchRealTimeView && (
        <ModalMonitorSwitch
          onConfirm={this.handleMonitorSwitchConfirm}
          onCancel={this.handleMonitorSwitchCancel}
          type = {"monitor"}
        />
      )} */}

    </>)
  }
} 
